/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8865:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ closest)
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/matches.js
var matchesImpl;
/**
 * Checks if a given element matches a selector.
 * 
 * @param node the element
 * @param selector the selector
 */

function matches(node, selector) {
  if (!matchesImpl) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;

    matchesImpl = function matchesImpl(n, s) {
      return nativeMatch.call(n, s);
    };
  }

  return matchesImpl(node, selector);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/closest.js

/**
 * Returns the closest parent element that matches a given selector.
 * 
 * @param node the reference element
 * @param selector the selector to match
 * @param stopAt stop traversing when this element is found
 */

function closest(node, selector, stopAt) {
  if (node.closest && !stopAt) node.closest(selector);
  var nextNode = node;

  do {
    if (matches(nextNode, selector)) return nextNode;
    nextNode = nextNode.parentElement;
  } while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);

  return null;
}

/***/ }),

/***/ 424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ contains)
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 5175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ css)
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ const css = (style);

/***/ }),

/***/ 632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ scrollbarSize)
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ const canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),

/***/ 5862:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"avatar-module__resetButton--eM9wk","root":"avatar-module__root--bTpnh","letter":"avatar-module__letter--HX_q8"};

/***/ }),

/***/ 1100:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"backdrop-module__root--HFFLt","invisible":"backdrop-module__invisible--jN_uH"};

/***/ }),

/***/ 1902:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"badge-module__resetButton--SE52D","root":"badge-module__root--iE2qQ","content":"badge-module__content--MDJHQ","disableTextTransform":"badge-module__disableTextTransform--VFQdN","intentDefault":"badge-module__intentDefault--uGUom","inverted":"badge-module__inverted--qVfLU","ghost":"badge-module__ghost--yKW8E","warning":"badge-module__warning--fkbjr"};

/***/ }),

/***/ 8482:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"button-base-module__resetButton--o_7oW","root":"button-base-module__root--tSgbv","disabled":"button-base-module__disabled--TwI0i","focused":"button-base-module__focused--h3vo9","inverted":"button-base-module__inverted--w006j","normal":"button-base-module__normal--zZV5y","active":"button-base-module__active--_4XLi","noIntent":"button-base-module__noIntent--imcGx","hovered":"button-base-module__hovered--gLQOn","accent":"button-base-module__accent--R0aFZ","alarm":"button-base-module__alarm--jCYxQ","ghost":"button-base-module__ghost--EOz2l"};

/***/ }),

/***/ 5037:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"button-group-module__root--tIBac","button":"button-group-module__button--k7ftY","ghostAccent":"button-group-module__ghostAccent--s_paA"};

/***/ }),

/***/ 1503:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"button-module__root--bhoWr","rounded":"button-module__rounded--HbpPb","iconStart":"button-module__iconStart--RIqd8","iconEnd":"button-module__iconEnd--oskDs","text":"button-module__text--cFcrD","nowrap":"button-module__nowrap--L810S","ghost":"button-module__ghost--CifV4","accent":"button-module__accent--xp0r5","iconStartSingle":"button-module__iconStartSingle--vHudk","iconEndSingle":"button-module__iconEndSingle--SHY_a","small":"button-module__small--K8BJE","submenuIndicator":"button-module__submenuIndicator--koKiB","tiny":"button-module__tiny--eQihz"};

/***/ }),

/***/ 3395:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"circular-countdown-module__resetButton--VKQDv","root":"circular-countdown-module__root--YlZA1","progressCircle":"circular-countdown-module__progressCircle--AOVu6"};

/***/ }),

/***/ 8570:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"controls-item-module__root--tLrUq controls-module__item--jxuf7","shrink":"controls-item-module__shrink--hNpTQ","grow":"controls-item-module__grow--PdRLR"};

/***/ }),

/***/ 1825:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"controls-module__resetButton--iU7g7","container":"controls-module__container--F4kbI","alignCenter":"controls-module__alignCenter--MtD20","alignBaseline":"controls-module__alignBaseline--ZoYpg","gap1":"controls-module__gap1--zvrbO","item":"controls-module__item--jxuf7","gap2":"controls-module__gap2--DaxG5","gap4":"controls-module__gap4--D62FB","gap8":"controls-module__gap8--LX_7n","justifyStart":"controls-module__justifyStart--soENl","justifyEnd":"controls-module__justifyEnd--c2Z5e","justifyCenter":"controls-module__justifyCenter--TBsxQ","justifySpaceBetween":"controls-module__justifySpaceBetween--m4rC_","noWrap":"controls-module__noWrap--NeNrT","wrap":"controls-module__wrap--n59Xe"};

/***/ }),

/***/ 2450:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"dialog-body-module__resetButton--Nkhk3","root":"dialog-body-module__root--O33nt","scrollable":"dialog-body-module__scrollable--mnvFF"};

/***/ }),

/***/ 6214:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"dialog-footer-module__resetButton--Jc6Gx","root":"dialog-footer-module__root--f9kR_","content":"dialog-footer-module__content--XT2N5"};

/***/ }),

/***/ 153:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"dialog-header-module__resetButton--MiFYs","root":"dialog-header-module__root--HsRaB","shiftedContent":"dialog-header-module__shiftedContent--Rnj3H"};

/***/ }),

/***/ 2465:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"dialog-module__resetButton--Tn0aq","overlay":"dialog-module__overlay--GVYvM","container":"dialog-module__container--lNAdI","root":"dialog-module__root--y4ddn","small":"dialog-module__small--zJwLC","medium":"dialog-module__medium--wjxFD","large":"dialog-module__large--L3YfC","overlayScrollable":"dialog-module__overlayScrollable--LicyQ","closeButton":"dialog-module__closeButton--gpAGJ"};

/***/ }),

/***/ 8179:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"divider-module__resetButton--8SDZA","root":"divider-module__root--sajap","inverted":"divider-module__inverted--MyirD","dashed":"divider-module__dashed--d7nOK","transparent":"divider-module__transparent--cS_m2","startGap1":"divider-module__startGap1--tV8ZU","startGap2":"divider-module__startGap2--HV0vX","startGap3":"divider-module__startGap3--SmjkI","startGap4":"divider-module__startGap4--UBDcM","startGap5":"divider-module__startGap5--wIp0n","endGap1":"divider-module__endGap1--xtYB7","endGap2":"divider-module__endGap2--jnCzT","endGap3":"divider-module__endGap3--MTb6Q","endGap4":"divider-module__endGap4--UlzOJ","endGap5":"divider-module__endGap5--qnaPK"};

/***/ }),

/***/ 5234:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"drawer-module__resetButton--TZqbG","root":"drawer-module__root--qNORm","overlay":"drawer-module__overlay--T2RwR","leftSided":"drawer-module__leftSided--KoMo9","rightSided":"drawer-module__rightSided--qXxdR"};

/***/ }),

/***/ 5001:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fade-module__root--hRJ5C","enter":"fade-module__enter--FEdZl","entering":"fade-module__entering--_gGde","exit":"fade-module__exit--ly6yC","exiting":"fade-module__exiting--ln8ww"};

/***/ }),

/***/ 9274:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"field-module__resetButton--CKUnm","root":"field-module__root--OMt3t","focused":"field-module__focused--wWhkZ","invalid":"field-module__invalid--WkLV0","disabled":"field-module__disabled--eAV69","fullWidth":"field-module__fullWidth--rGF_r"};

/***/ }),

/***/ 6838:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"flex-expander-module__root--AStVu"};

/***/ }),

/***/ 2411:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"flex-module__resetButton--Oo1Xw","root":"flex-module__root--tagyP","container":"flex-module__container--Mk9BL","baseline":"flex-module__baseline--uaomW","gap0":"flex-module__gap0--bnnEn","gap1":"flex-module__gap1--yYKNh","gap2":"flex-module__gap2--aTkiM","gap3":"flex-module__gap3--Y_m1E","gap4":"flex-module__gap4--cL3xm","shrink":"flex-module__shrink--G6qjw","grow":"flex-module__grow--vyARV","ellipsis":"flex-module__ellipsis--wN9ei","justifyStart":"flex-module__justifyStart--qp6ph","justifyCenter":"flex-module__justifyCenter--gI_BR","justifyEnd":"flex-module__justifyEnd--Rzqtf","alignStart":"flex-module__alignStart--JYCGd","alignCenter":"flex-module__alignCenter--ydOCz","alignBaseline":"flex-module__alignBaseline--l7cYq","alignEnd":"flex-module__alignEnd--kFzX4","noWrap":"flex-module__noWrap--GirWy","wrap":"flex-module__wrap--fz94l","row":"flex-module__row--lSuno","rowReverse":"flex-module__rowReverse--iGO1H","column":"flex-module__column--ORYJ9","columnReverse":"flex-module__columnReverse--kvFV2"};

/***/ }),

/***/ 1120:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"form-control-label-module__resetButton--N7J1j","label":"form-control-label-module__label--fZvSf","disabled":"form-control-label-module__disabled--Ps3AM","typographyDisabled":"form-control-label-module__typographyDisabled--WrTBh"};

/***/ }),

/***/ 6919:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"enter":"grow-module__enter--uSR2N","entering":"grow-module__entering--spshb","exit":"grow-module__exit--a5p8c","exiting":"grow-module__exiting--SHWIG","centerCenter":"grow-module__centerCenter--BsY1t","centerLeft":"grow-module__centerLeft--I83_e","centerRight":"grow-module__centerRight--vjSBj","topCenter":"grow-module__topCenter--ojQlw","topLeft":"grow-module__topLeft--BB2fa","topRight":"grow-module__topRight--rlFep","bottomCenter":"grow-module__bottomCenter--HJEZP","bottomLeft":"grow-module__bottomLeft--UNTZs","bottomRight":"grow-module__bottomRight--iLJlu"};

/***/ }),

/***/ 595:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-block-module__resetButton--kDAy0","root":"header-block-module__root--ACa5d","grow":"header-block-module__grow--nBwLO","shrink":"header-block-module__shrink--G1tCS","cell":"header-block-module__cell--lENwy","iconCell":"header-block-module__iconCell--vFKZJ"};

/***/ }),

/***/ 1833:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-item-cell-module__resetButton--lToe2","root":"header-item-cell-module__root--LXvn0 header-block-module__cell--lENwy header-item-module__cell--XNmHT","grow":"header-item-cell-module__grow--jg4xY","shrink":"header-item-cell-module__shrink--Rs3pl"};

/***/ }),

/***/ 4972:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-item-icon-module__resetButton--Wuh6y","root":"header-item-icon-module__root--YoJ0l header-block-module__iconCell--vFKZJ header-item-module__iconCell--wPzit"};

/***/ }),

/***/ 4624:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-item-secondary-actions-module__resetButton--ZLevP","root":"header-item-secondary-actions-module__root--FCMYQ header-block-module__iconCell--vFKZJ header-item-module__iconCell--wPzit header-item-module__secondaryActionsCell--XDkou"};

/***/ }),

/***/ 5883:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-item-text-module__resetButton--Wnt2H","root":"header-item-text-module__root--OvuMv header-block-module__cell--lENwy header-item-module__cell--XNmHT"};

/***/ }),

/***/ 1953:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-item-module__resetButton--E7u8i","root":"header-item-module__root--kPvFK","disabled":"header-item-module__disabled--lUyvx","fakeHover":"header-item-module__fakeHover--ch4o2","active":"header-item-module__active--p3BD0","secondaryActionsCell":"header-item-module__secondaryActionsCell--XDkou","cell":"header-item-module__cell--XNmHT","iconCell":"header-item-module__iconCell--wPzit"};

/***/ }),

/***/ 7822:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"header-module__resetButton--BNXCd","spacer":"header-module__spacer--mZrWy","root":"header-module__root--e1aXe header-module__spacer--mZrWy","fixed":"header-module__fixed--W2WLW","withBorder":"header-module__withBorder--bFc2Z"};

/***/ }),

/***/ 6241:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"hidden-scrollbar-module__resetButton--L1pv9","root":"hidden-scrollbar-module__root--ccphn","container":"hidden-scrollbar-module__container--PjWZE","control":"hidden-scrollbar-module__control--X7oQk","startControl":"hidden-scrollbar-module__startControl--v14bq hidden-scrollbar-module__control--X7oQk","endControl":"hidden-scrollbar-module__endControl--jVJ3a hidden-scrollbar-module__control--X7oQk","startControlIcon":"hidden-scrollbar-module__startControlIcon--x0Y8n","endControlIcon":"hidden-scrollbar-module__endControlIcon--cTb_2 hidden-scrollbar-module__startControlIcon--x0Y8n"};

/***/ }),

/***/ 2286:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"icon-module__resetButton--Sh5B5","root":"icon-module__root--jsqsQ"};

/***/ }),

/***/ 3831:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"input-module__resetButton--EKJaZ","root":"input-module__root--f8G70","inputCell":"input-module__inputCell--iv5hJ","prependCell":"input-module__prependCell--UMn8l","appendCell":"input-module__appendCell--uhU7a","input":"input-module__input--HQAKU","withHelpers":"input-module__withHelpers--XM2Z3","helpers":"input-module__helpers--ewf4c","spinner":"input-module__spinner--AHdM1","clearButton":"input-module__clearButton--ep1nR"};

/***/ }),

/***/ 2066:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"interactive-element-module__root--U9GlL"};

/***/ }),

/***/ 4026:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"link-module__resetButton--WHHBf","root":"link-module__root--dga0t","label":"link-module__label--KOwpR","focus":"link-module__focus--hC6KW","active":"link-module__active--iMSko","disabled":"link-module__disabled--utBKu","inverted":"link-module__inverted--uiI_8","pseudo":"link-module__pseudo--bhsei","external":"link-module__external--I328p","alarm":"link-module__alarm--Q0LL7"};

/***/ }),

/***/ 7230:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"list-item-module__resetButton--OhJv7","root":"list-item-module__root--f_hNj","interactive":"list-item-module__interactive--FB6WV","focused":"list-item-module__focused--OIkq1","hovered":"list-item-module__hovered--Hv4zb","active":"list-item-module__active--TkDXg","disabled":"list-item-module__disabled--BZQV8","inclusiveDisabled":"list-item-module__inclusiveDisabled--utKbD","prepend":"list-item-module__prepend--TKASa","content":"list-item-module__content--MnoY2","title":"list-item-module__title--gqS2I","titleContent":"list-item-module__titleContent--bG15g","subtitle":"list-item-module__subtitle--QiuQz","append":"list-item-module__append--zdzFP","inPage":"list-item-module__inPage--qTt3p","inDialog":"list-item-module__inDialog--ICD1S"};

/***/ }),

/***/ 8944:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"list-module__resetButton--CFtMc","root":"list-module__root--jYpeB"};

/***/ }),

/***/ 1207:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"margin-box-full-width-module__resetButton--i1GWO","inPage":"margin-box-full-width-module__inPage--FXlhz","inDialog":"margin-box-full-width-module__inDialog--taC8Y"};

/***/ }),

/***/ 2290:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"margin-box-module__resetButton--wLYBl","root":"margin-box-module__root--bgKT2","inPage":"margin-box-module__inPage--rtRCr","inDialog":"margin-box-module__inDialog--vd9N7","divider":"margin-box-module__divider--UMgLb"};

/***/ }),

/***/ 5580:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"menu-caption-module__resetButton--jAZmT","root":"menu-caption-module__root--Lc73k"};

/***/ }),

/***/ 1262:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"menu-item-module__resetButton--oBCEo","root":"menu-item-module__root--rqG5L","prepend":"menu-item-module__prepend--W95Rx","append":"menu-item-module__append--zS30l","subMenu":"menu-item-module__subMenu--RrE6x"};

/***/ }),

/***/ 9125:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"menu-popover-module__resetButton--tv_fp","root":"menu-popover-module__root--zlysS"};

/***/ }),

/***/ 7505:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"menu-module__resetButton--U8Ol1","closed":"menu-module__closed--ElvkS","subMenu":"menu-module__subMenu--imJKe"};

/***/ }),

/***/ 3870:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"notification-module__resetButton--EvXMr","root":"notification-module__root--w47_0","closeButton":"notification-module__closeButton--x2s0o","circularProgress":"notification-module__circularProgress--PuygQ"};

/***/ }),

/***/ 2457:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"overlay-module__resetButton--F6BTX","root":"overlay-module__root--QMXAD","invisible":"overlay-module__invisible--bH0w_"};

/***/ }),

/***/ 556:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"paginator-module__resetButton--FCexn","container":"paginator-module__container--dssBM","info":"paginator-module__info--r2agP","button":"paginator-module__button--YS_D9"};

/***/ }),

/***/ 2074:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"paper-module__resetButton--VsR2H","root":"paper-module__root--MkjTS","inverted":"paper-module__inverted--cHTrE"};

/***/ }),

/***/ 3386:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"popover-module__resetButton--G0px7","popper":"popover-module__popper--octRE","paper":"popover-module__paper--bJyHF","arrow":"popover-module__arrow--wtC7R","arrowIcon":"popover-module__arrowIcon--utvvy","withArrow":"popover-module__withArrow--wigCg","arrowHidden":"popover-module__arrowHidden--NodPN","roundCorners":"popover-module__roundCorners--sJ8Iy"};

/***/ }),

/***/ 3683:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"width100":"preloader-module__width100--sxqsa","width75":"preloader-module__width75--mhVlf","width85":"preloader-module__width85--h2puv","preloader":"preloader-module__preloader--sBt6y","backgroundRegular":"preloader-module__backgroundRegular--jFwYP","backgroundInverted":"preloader-module__backgroundInverted--TcjNg"};

/***/ }),

/***/ 5287:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"root-element-module__resetButton--kk0hS","root":"root-element-module__root--GbT58"};

/***/ }),

/***/ 749:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"scroll-view-module__root--S1oxM","inverted":"scroll-view-module__inverted--koUcE","scrollbarsAlwaysShown":"scroll-view-module__scrollbarsAlwaysShown--hUgdE"};

/***/ }),

/***/ 5538:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"option-module__resetButton--ZktBo","root":"option-module__root--vvJCi"};

/***/ }),

/***/ 1649:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"select-emitter-module__resetButton--YEBAB","root":"select-emitter-module__root--f7yhu","small":"select-emitter-module__small--dRu_I","arrow":"select-emitter-module__arrow--L1WQy","optionLabel":"select-emitter-module__optionLabel--CMG3i","label":"select-emitter-module__label--Jdr8N","info":"select-emitter-module__info--SgMOl","accent":"select-emitter-module__accent--nj7GX","invalid":"select-emitter-module__invalid--GOIQF","disabled":"select-emitter-module__disabled--N7qjf","ghost":"select-emitter-module__ghost--tB93K"};

/***/ }),

/***/ 6452:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"select-native-module__resetButton--L_ECv","select":"select-native-module__select--rX1J8"};

/***/ }),

/***/ 9140:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"shake-module__root--jliSc","enter":"shake-module__enter--mfWmo","shake-animation":"shake-module__shake-animation--EB4cp","enterDone":"shake-module__enterDone--dFQYl"};

/***/ }),

/***/ 2628:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"slide-module__root--TLb0v","enter":"slide-module__enter--wykXM","entering":"slide-module__entering--yoT1k","fast":"slide-module__fast--Ba7Hz","exiting":"slide-module__exiting--pLxtx","exitLeft":"slide-module__exitLeft--GJyxo","exitRight":"slide-module__exitRight--uGHnb","exitTop":"slide-module__exitTop--SOaud","exitBottom":"slide-module__exitBottom--OQPmA"};

/***/ }),

/***/ 6355:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"spinner-module__resetButton--upd8w","root":"spinner-module__root--k4e3D","spinner-rotate":"spinner-module__spinner-rotate--T2kFr","circle":"spinner-module__circle--aWjFd","backgroundCircle":"spinner-module__backgroundCircle--h0vd3"};

/***/ }),

/***/ 1559:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"styles-module__resetButton--ZCH57","list":"styles-module__list--BEwpk"};

/***/ }),

/***/ 1109:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"root":"suggest-module__root--k2rop","popoverContainer":"suggest-module__popoverContainer--AzpzO","popover":"suggest-module__popover--GPvm3"};

/***/ }),

/***/ 3855:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"switch-module__resetButton--oKfya","root":"switch-module__root--Fr1RF","small":"switch-module__small--f8MCk","input":"switch-module__input--oi9Bk","disabled":"switch-module__disabled--hvgSE","track":"switch-module__track--S_JJY","focused":"switch-module__focused--BQqbh","inverted":"switch-module__inverted--jx1Lf","handler":"switch-module__handler--R5HRu"};

/***/ }),

/***/ 1154:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"indicator-module__resetButton--SZWF_","root":"indicator-module__root--ItzBd","bottom":"indicator-module__bottom--jDB5o","top":"indicator-module__top--m5Wag","left":"indicator-module__left--hw6p4","right":"indicator-module__right--EchFa","fullWidth":"indicator-module__fullWidth--N3MrF","active":"indicator-module__active--Okrp2"};

/***/ }),

/***/ 5055:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"tab-module__resetButton--lDSg2","root":"tab-module__root--hd4eO","normal":"tab-module__normal--gG861","small":"tab-module__small--YQ2S2","tiny":"tab-module__tiny--qWZuR","empty":"tab-module__empty--v2R4o","hovered":"tab-module__hovered--sPwkn","disabled":"tab-module__disabled--RZRuL","solid":"tab-module__solid--XhBdM","selected":"tab-module__selected--nxigy","prepend":"tab-module__prepend--HYKOc","append":"tab-module__append--WAYwN","body":"tab-module__body--CEtUN","label":"tab-module__label--GS_Dt","indicator":"tab-module__indicator--CZMTj"};

/***/ }),

/***/ 9715:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"tabs-module__resetButton--UEZew","root":"tabs-module__root--w8sCp","tabList":"tabs-module__tabList--plqB9","vertical":"tabs-module__vertical--BojAm","transition":"tabs-module__transition--itB__","indicator":"tabs-module__indicator--b8fD6"};

/***/ }),

/***/ 2882:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"text-label-module__resetButton--o4aKU","root":"text-label-module__root--F1qpx","inline":"text-label-module__inline--q2mob","label":"text-label-module__label--UK7Rg","grow":"text-label-module__grow--jzBeg","wrap":"text-label-module__wrap--BUz0y","caption":"text-label-module__caption--ewcxH"};

/***/ }),

/***/ 9108:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"textarea-module__resetButton--RM9fz","root":"textarea-module__root--eGRMe","invalid":"textarea-module__invalid--KEYYS","fullWidth":"textarea-module__fullWidth--qXPaL"};

/***/ }),

/***/ 4670:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"tooltip-module__resetButton--nU5VW","root":"tooltip-module__root--p8tkg","withGaps":"tooltip-module__withGaps--ZE95j","popperContainer":"tooltip-module__popperContainer--Y8jcS","tooltipContainer":"tooltip-module__tooltipContainer--tLLkx","arrow":"tooltip-module__arrow--W3cH0","arrowIcon":"tooltip-module__arrowIcon--yPSEK"};

/***/ }),

/***/ 9370:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"typography-module__resetButton--Ay9kB","root":"typography-module__root--D8Olb","ellipsis":"typography-module__ellipsis--EsW4J","condensed":"typography-module__condensed--Kq2iG","inline":"typography-module__inline--YDQ8a","paragraph":"typography-module__paragraph--uMK29","header":"typography-module__header--VJQPn","quiet":"typography-module__quiet--qV01H","title":"typography-module__title--bKThT","section":"typography-module__section--Bhicq","body":"typography-module__body--caD2s","inverted":"typography-module__inverted--AhRkd","caption":"typography-module__caption--XPXwW","success":"typography-module__success--Ci6qY","alarm":"typography-module__alarm--ZA25H","warning":"typography-module__warning--QrTNd"};

/***/ }),

/***/ 1348:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7107:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1075:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ esm_CSSTransition)
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(1721);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(6689);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(660);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(9391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) (0,reflow/* forceReflow */.Q)(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/external_react_default().createElement(Transition["default"], _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}((external_react_default()).Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ const esm_CSSTransition = (CSSTransition);

/***/ }),

/***/ 660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ENTERED: () => (/* binding */ ENTERED),
  ENTERING: () => (/* binding */ ENTERING),
  EXITED: () => (/* binding */ EXITED),
  EXITING: () => (/* binding */ EXITING),
  UNMOUNTED: () => (/* binding */ UNMOUNTED),
  "default": () => (/* binding */ esm_Transition)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(1721);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(6689);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(6405);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ const config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ const TransitionGroupContext = (external_react_default().createContext(null));
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(9391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : external_react_dom_default().findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,reflow/* forceReflow */.Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [external_react_dom_default().findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : external_react_dom_default().findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : external_react_dom_default().findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      external_react_default().createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : external_react_default().cloneElement(external_react_default().Children.only(children), childProps))
    );
  };

  return Transition;
}((external_react_default()).Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ const esm_Transition = (Transition);

/***/ }),

/***/ 9391:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: () => (/* binding */ forceReflow)
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 6369:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Avatar = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(5862));
/**
 * Avatar component is the graphical representation of a user
 */
function Avatar(props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), initialsProp = _a.initials, classes = _a.classes, icon = _a.icon, rest = __rest(_a, ["initials", "classes", "icon"]);
    var initials = null;
    if (initialsProp) {
        var letters = Array.from(initialsProp);
        initials = (React.createElement(React.Fragment, null,
            letters[1] ? (React.createElement("div", { className: classes.letter, "data-qa": "avatar-letter" }, letters[1].toUpperCase())) : null,
            React.createElement("div", { className: classes.letter, "data-qa": "avatar-letter" }, letters[0].toUpperCase())));
    }
    return (React.createElement(typography_1.Typography, __assign({ "data-qa": "avatar", as: "div" }, rest, { className: (0, classnames_1.default)(classes.root, rest.className) }), icon ? (icon) : (React.createElement(React.Fragment, null,
        initials,
        rest.children))));
}
exports.Avatar = Avatar;


/***/ }),

/***/ 9399:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Avatar = void 0;
var avatar_1 = __webpack_require__(6369);
Object.defineProperty(exports, "Avatar", ({ enumerable: true, get: function () { return avatar_1.Avatar; } }));


/***/ }),

/***/ 7749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Backdrop = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var styles_1 = __webpack_require__(598);
var fade_1 = __webpack_require__(5848);
var styles = __importStar(__webpack_require__(1100));
/**
 * Backdrop component is used for blocking page content when a modal is shown.
 * Container that uses Backdrop should have its own z-index and focus state,
 * because popovers or menus have greater `z-index` than dialog has.
 *
 * Can be transparent when rendering a popover or a menu.
 */
var Backdrop = /** @class */ (function (_super) {
    __extends(Backdrop, _super);
    function Backdrop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Backdrop.prototype.render = function () {
        var _a;
        var _b = (0, styles_1.mergeClassesProps)(this.props, styles), open = _b.open, invisible = _b.invisible, className = _b.className, _c = _b.fadeProps, fadeProps = _c === void 0 ? {} : _c, classes = _b.classes, onExited = _b.onExited, rest = __rest(_b, ["open", "invisible", "className", "fadeProps", "classes", "onExited"]);
        return (React.createElement(fade_1.Fade, __assign({}, fadeProps, { in: open, appear: true, unmountOnExit: true, onExited: (0, chain_1.chain)(fadeProps.onExited, onExited) }),
            React.createElement("div", __assign({ "data-qa": "backdrop" }, rest, { className: (0, classnames_1.default)(className, classes.root, (_a = {},
                    _a[classes.invisible] = invisible,
                    _a)) }))));
    };
    return Backdrop;
}(React.Component));
exports.Backdrop = Backdrop;


/***/ }),

/***/ 3597:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Backdrop = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var backdrop_1 = __webpack_require__(7749);
Object.defineProperty(exports, "Backdrop", ({ enumerable: true, get: function () { return backdrop_1.Backdrop; } }));


/***/ }),

/***/ 9529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Badge = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(1902));
/**
 * Text which plays the role of an icon
 */
exports.Badge = React.forwardRef(function Badge(props, ref) {
    var _a;
    var _b = (0, utils_1.mergeClassesProps)(props, styles), _c = _b.as, Component = _c === void 0 ? 'span' : _c, _d = _b.variant, variant = _d === void 0 ? 'body' : _d, _e = _b.intent, intent = _e === void 0 ? 'default' : _e, ghost = _b.ghost, children = _b.children, classes = _b.classes, _f = _b.contentProps, contentProps = _f === void 0 ? {} : _f, disableTextTransform = _b.disableTextTransform, inverted = _b.inverted, rest = __rest(_b, ["as", "variant", "intent", "ghost", "children", "classes", "contentProps", "disableTextTransform", "inverted"]);
    var darkContext = React.useContext(utils_1.DarkContext);
    return (React.createElement(typography_1.Typography, __assign({ "data-qa": "badge" }, rest, { as: Component, variant: variant, className: (0, classnames_1.default)(rest.className, classes.root), ref: ref }),
        React.createElement("span", { className: (0, classnames_1.default)(contentProps.className, classes.content, (_a = {},
                _a[classes.intentDefault] = intent === 'default',
                _a[classes.warning] = intent === 'warning',
                _a[classes.ghost] = ghost,
                _a[classes.disableTextTransform] = disableTextTransform,
                _a[classes.inverted] = inverted || darkContext,
                _a)) }, children)));
});


/***/ }),

/***/ 358:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Badge = void 0;
var badge_1 = __webpack_require__(9529);
Object.defineProperty(exports, "Badge", ({ enumerable: true, get: function () { return badge_1.Badge; } }));


/***/ }),

/***/ 6819:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonBase = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var dark_context_1 = __webpack_require__(3693);
var matches_1 = __webpack_require__(7522);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(8482));
var use_button_active_state_1 = __webpack_require__(5579);
/** Base component for any elements that look and live like buttons */
exports.ButtonBase = React.forwardRef(function ButtonBase(props, ref) {
    var _a;
    var darkContext = React.useContext(dark_context_1.DarkContext);
    var _b = (0, styles_1.mergeClassesProps)(props, styles), ghost = _b.ghost, _c = _b.intent, intent = _c === void 0 ? 'no-intent' : _c, hovered = _b.hovered, focused = _b.focused, tabIndex = _b.tabIndex, active = _b.active, classes = _b.classes, _d = _b.component, Component = _d === void 0 ? 'button' : _d, disabled = _b.disabled, onClick = _b.onClick, inverted = _b.inverted, _e = _b.inclusiveDisabled, inclusiveDisabled = _e === void 0 ? false : _e, rest = __rest(_b, ["ghost", "intent", "hovered", "focused", "tabIndex", "active", "classes", "component", "disabled", "onClick", "inverted", "inclusiveDisabled"]);
    var isNativeButton = Component === 'button';
    var anyDisabled = disabled || inclusiveDisabled;
    var handleClick = React.useCallback(function (event) {
        // React has bug in Chrome. It calls `onClick` callback when button is
        // in disabled fieldset. It is a workaround. @see https://git.io/JvGEj
        var isHtmlDisabled = (0, matches_1.matches)(event.currentTarget, ':disabled');
        if (onClick && !isHtmlDisabled && !anyDisabled) {
            onClick(event);
        }
    }, [onClick, anyDisabled]);
    var activeState = (0, use_button_active_state_1.useButtonActiveState)({
        onClick: handleClick,
        disableHook: isNativeButton || anyDisabled
    });
    return (React.createElement(Component, __assign({ "data-qa": "button-base", type: isNativeButton ? 'button' : undefined }, rest, { disabled: isNativeButton ? disabled : undefined, ref: ref, tabIndex: !anyDisabled ? tabIndex : undefined, className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
            _a[classes.active] = active || activeState.active,
            _a[classes.hovered] = hovered,
            _a[classes.focused] = focused,
            _a[classes.disabled] = anyDisabled,
            _a[classes.ghost] = ghost,
            _a[classes.normal] = !ghost,
            _a[classes.noIntent] = intent === 'no-intent',
            _a[classes.accent] = intent === 'accent',
            _a[classes.alarm] = intent === 'alarm',
            _a[classes.inverted] = inverted || darkContext,
            _a)), onClick: handleClick, onMouseDown: (0, chain_1.chain)(rest.onMouseDown, activeState.onMouseDown), onKeyDown: (0, chain_1.chain)(rest.onKeyDown, activeState.onKeyDown), onKeyUp: (0, chain_1.chain)(rest.onKeyUp, activeState.onKeyUp) })));
});


/***/ }),

/***/ 3592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonBase = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var button_base_1 = __webpack_require__(6819);
Object.defineProperty(exports, "ButtonBase", ({ enumerable: true, get: function () { return button_base_1.ButtonBase; } }));


/***/ }),

/***/ 5579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useButtonActiveState = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var SPACE_KEY = ' ';
/** Hook to simulate button pressing behaviour */
function useButtonActiveState(props) {
    var _a = React.useState(false), active = _a[0], setActiveState = _a[1];
    React.useEffect(function () {
        var handleWindowMouseUp = function () {
            setActiveState(false);
        };
        window.addEventListener('mouseup', handleWindowMouseUp);
        return function () {
            window.removeEventListener('mouseup', handleWindowMouseUp);
        };
    }, []);
    function getEventHandlers() {
        if (props.disableHook) {
            // no handlers needed when hook is disabled
            return {};
        }
        return {
            onMouseDown: function (event) {
                if (!event.defaultPrevented && !active) {
                    setActiveState(true);
                }
            },
            onKeyDown: function (event) {
                if (!event.defaultPrevented &&
                    event.target === event.currentTarget &&
                    event.key === SPACE_KEY) {
                    // stops scrolling on space press
                    event.preventDefault();
                    if (!active) {
                        setActiveState(true);
                    }
                }
            },
            onKeyUp: function (event) {
                if (!event.defaultPrevented &&
                    event.target === event.currentTarget &&
                    event.key === SPACE_KEY &&
                    active) {
                    setActiveState(false);
                    // simulate on click when target is not button
                    if (props.onClick && !(event.target instanceof HTMLButtonElement)) {
                        props.onClick(event);
                    }
                }
            }
        };
    }
    var callbackProps = React.useMemo(getEventHandlers, [
        active,
        props.disableHook,
        props.onClick
    ]);
    return __assign({ active: active }, callbackProps);
}
exports.useButtonActiveState = useButtonActiveState;


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGroup = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var button_context_1 = __webpack_require__(1426);
var styles = __importStar(__webpack_require__(5037));
/** Joined group of buttons */
function ButtonGroup(props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), rootRef = _a.rootRef, intent = _a.intent, ghost = _a.ghost, classes = _a.classes, size = _a.size, rest = __rest(_a, ["rootRef", "intent", "ghost", "classes", "size"]);
    var contextValue = React.useMemo(function () {
        var _a;
        return ({
            intent: intent,
            ghost: ghost,
            size: size,
            className: (0, classnames_1.default)(classes.button, (_a = {},
                _a[classes.ghostAccent] = ghost && intent === 'accent',
                _a))
        });
    }, [ghost, intent, classes.button, classes.ghostAccent, size]);
    return (React.createElement(button_context_1.ButtonContext.Provider, { value: contextValue },
        React.createElement("div", __assign({ "data-qa": "button-group" }, rest, { ref: rootRef, className: (0, classnames_1.default)(rest.className, classes.root) }))));
}
exports.ButtonGroup = ButtonGroup;


/***/ }),

/***/ 6119:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGroup = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var button_group_1 = __webpack_require__(1269);
Object.defineProperty(exports, "ButtonGroup", ({ enumerable: true, get: function () { return button_group_1.ButtonGroup; } }));


/***/ }),

/***/ 1426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonContext = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/** Internal Button context */
exports.ButtonContext = React.createContext({});


/***/ }),

/***/ 2768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Button = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var button_base_1 = __webpack_require__(3592);
var button_context_1 = __webpack_require__(1426);
var styles = __importStar(__webpack_require__(1503));
var submenu_indicator_1 = __webpack_require__(2627);
/**
 * Button component
 *
 * @example ./all-button-combinations.md
 */
exports.Button = React.forwardRef(function Button(props, ref) {
    var _a, _b, _c, _d;
    var buttonContext = React.useContext(button_context_1.ButtonContext);
    var _e = (0, styles_1.mergeClassesProps)(props, styles), _f = _e.ghost, ghost = _f === void 0 ? buttonContext.ghost : _f, _g = _e.intent, intent = _g === void 0 ? buttonContext.intent : _g, _h = _e.size, size = _h === void 0 ? buttonContext.size : _h, icon = _e.icon, iconStart = _e.iconStart, iconEnd = _e.iconEnd, children = _e.children, wrap = _e.wrap, rounded = _e.rounded, classes = _e.classes, _j = _e.inclusiveDisabled, inclusiveDisabled = _j === void 0 ? false : _j, hasSubmenuIndicator = _e.hasSubmenuIndicator, rest = __rest(_e, ["ghost", "intent", "size", "icon", "iconStart", "iconEnd", "children", "wrap", "rounded", "classes", "inclusiveDisabled", "hasSubmenuIndicator"]);
    return (React.createElement(button_base_1.ButtonBase, __assign({ "data-qa": "button", ref: ref, 
        // use default tabIndex to enable focusing
        tabIndex: 0 }, rest, { ghost: ghost, intent: intent, classes: classes, className: (0, classnames_1.default)(rest.className, classes.root, buttonContext.className, (_a = {},
            _a[classes.small] = size === 'small',
            _a[classes.tiny] = size === 'tiny',
            _a[classes.rounded] = rounded,
            _a)), inclusiveDisabled: inclusiveDisabled }),
        icon || iconStart ? (React.createElement("span", { className: (0, classnames_1.default)(classes.iconStart, (_b = {},
                _b[classes.iconStartSingle] = !children,
                _b)) }, icon || iconStart)) : null,
        children ? (React.createElement("span", { className: (0, classnames_1.default)(classes.text, (_c = {},
                _c[classes.nowrap] = !wrap,
                _c)) }, children)) : null,
        iconEnd ? (React.createElement("span", { className: (0, classnames_1.default)(classes.iconEnd, (_d = {},
                _d[classes.iconEndSingle] = !children,
                _d)) }, iconEnd)) : null,
        hasSubmenuIndicator ? React.createElement(submenu_indicator_1.SubmenuIndicator, null) : null));
});


/***/ }),

/***/ 8329:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Button = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var button_1 = __webpack_require__(2768);
Object.defineProperty(exports, "Button", ({ enumerable: true, get: function () { return button_1.Button; } }));


/***/ }),

/***/ 2627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SubmenuIndicator = void 0;
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(1503));
// I use svg here instead of css so that I can apply so very convenient gs-svg-icon-fill class
function SubmenuIndicator() {
    return (React.createElement("svg", { width: "4", height: "4", viewBox: "0 0 4 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: styles.submenuIndicator },
        React.createElement("path", { d: "M4 4V0L0 4H4Z", className: "gs-svg-icon-fill" })));
}
exports.SubmenuIndicator = SubmenuIndicator;


/***/ }),

/***/ 1482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CircularCountdown = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var css_1 = __importDefault(__webpack_require__(5175));
var React = __importStar(__webpack_require__(6689));
var Transition_1 = __importDefault(__webpack_require__(660));
var chain_1 = __webpack_require__(9416);
var reflow_1 = __webpack_require__(6874);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(3395));
var DEFAULT_ENTER_DURATION = 6000;
var EXIT_DURATION = 120;
var DIAMETER = 24;
var STROKE_WIDTH = 1.5;
var CIRCLE_RADIUS = (DIAMETER - STROKE_WIDTH) / 2;
var CIRCLE_PERIMETER = (CIRCLE_RADIUS * 2 * Math.PI).toFixed(3);
/**
 * Circular Countdown is a SVG element which uses
 * [Transition Component](https://github.com/reactjs/react-transition-group)
 * and indicates how much time is left by contrast circle.
 */
var CircularCountdown = /** @class */ (function (_super) {
    __extends(CircularCountdown, _super);
    function CircularCountdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestId = null;
        _this.handleEnter = function (node) {
            _this.setCircleStyles(node, 'exited');
            _this.requestAnimationFrame(function () {
                (0, reflow_1.reflow)(node);
                _this.setCircleStyles(node, 'entering');
                _this.requestAnimationFrame(function () {
                    _this.setCircleStyles(node, 'entered');
                });
            });
        };
        _this.handleExit = function (node) {
            _this.setCircleStyles(node, 'entered');
            _this.requestAnimationFrame(function () {
                (0, reflow_1.reflow)(node);
                _this.setCircleStyles(node, 'exiting');
                _this.requestAnimationFrame(function () {
                    _this.setCircleStyles(node, 'exited');
                });
            });
        };
        return _this;
    }
    CircularCountdown.prototype.componentWillUnmount = function () {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
    };
    CircularCountdown.prototype.requestAnimationFrame = function (callback) {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
        this.requestId = requestAnimationFrame(callback);
    };
    CircularCountdown.prototype.getCircleStyles = function (status) {
        var _a = this.props.duration, duration = _a === void 0 ? DEFAULT_ENTER_DURATION : _a;
        var defaultStyle = {
            strokeDasharray: CIRCLE_PERIMETER,
            strokeDashoffset: '0',
            transition: "stroke-dashoffset ".concat(duration, "ms linear")
        };
        var enteringStyle = {
            strokeDashoffset: "-".concat(CIRCLE_PERIMETER, "px")
        };
        var enteredStyle = {
            strokeDashoffset: "-".concat(CIRCLE_PERIMETER, "px")
        };
        var exitingStyle = {
            strokeDashoffset: '0',
            transition: "stroke-dashoffset ".concat(EXIT_DURATION, "ms linear")
        };
        var exitedStyle = {
            strokeDashoffset: '0'
        };
        return __assign(__assign(__assign(__assign(__assign({}, defaultStyle), (status === 'entering' && enteringStyle)), (status === 'entered' && enteredStyle)), (status === 'exiting' && exitingStyle)), (status === 'exited' && exitedStyle));
    };
    CircularCountdown.prototype.setCircleStyles = function (node, status) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css_1.default(node, this.getCircleStyles(status));
    };
    CircularCountdown.prototype.render = function () {
        var _a = (0, styles_1.mergeClassesProps)(this.props, styles), transitionIn = _a.in, onComplete = _a.onComplete, _b = _a.transitionProps, transitionProps = _b === void 0 ? {} : _b, _c = _a.circleProps, circleProps = _c === void 0 ? {} : _c, _d = _a.duration, duration = _d === void 0 ? DEFAULT_ENTER_DURATION : _d, classes = _a.classes, rest = __rest(_a, ["in", "onComplete", "transitionProps", "circleProps", "duration", "classes"]);
        var timeout = {
            enter: duration,
            exit: EXIT_DURATION
        };
        return (React.createElement("svg", __assign({ "data-qa": "circular-countdown", viewBox: "0 0 ".concat(DIAMETER, " ").concat(DIAMETER) }, rest, { className: (0, classnames_1.default)(rest.className, classes.root) }),
            React.createElement(Transition_1.default, __assign({}, transitionProps, { timeout: timeout, in: transitionIn, onEnter: (0, chain_1.chain)(transitionProps.onEnter, this.handleEnter), onEntered: (0, chain_1.chain)(transitionProps.onEntered, onComplete), onExit: (0, chain_1.chain)(transitionProps.onExit, this.handleExit) }),
                React.createElement("circle", __assign({ style: this.getCircleStyles(transitionIn ? 'entered' : 'exited'), cx: DIAMETER / 2, cy: DIAMETER / 2, r: CIRCLE_RADIUS, fill: "none", strokeWidth: STROKE_WIDTH }, circleProps, { className: (0, classnames_1.default)(circleProps.className, classes.progressCircle) })))));
    };
    return CircularCountdown;
}(React.PureComponent));
exports.CircularCountdown = CircularCountdown;


/***/ }),

/***/ 1122:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CircularCountdown = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var circular_countdown_1 = __webpack_require__(1482);
Object.defineProperty(exports, "CircularCountdown", ({ enumerable: true, get: function () { return circular_countdown_1.CircularCountdown; } }));


/***/ }),

/***/ 1962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ControlsItem = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(8570));
/** Single item of controls container */
var ControlsItem = function (props) {
    var _a;
    var _b = props.as, Component = _b === void 0 ? 'div' : _b, shrink = props.shrink, grow = props.grow, rest = __rest(props, ["as", "shrink", "grow"]);
    return (React.createElement(Component, __assign({}, rest, { className: (0, classnames_1.default)(rest.className, styles.root, (_a = {},
            _a[styles.shrink] = shrink,
            _a[styles.grow] = grow,
            _a)) })));
};
exports.ControlsItem = ControlsItem;


/***/ }),

/***/ 6649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Controls = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(1825));
/**
 * Controls component is used for layout groups of controls.
 * Every sibling controls item has left and right margins
 * that are defined by `gap` property of controls container.
 */
var Controls = function (props) {
    var _a;
    var _b = props.as, Component = _b === void 0 ? 'div' : _b, _c = props.gap, gap = _c === void 0 ? 2 : _c, _d = props.justify, justify = _d === void 0 ? 'start' : _d, _e = props.align, align = _e === void 0 ? 'center' : _e, _f = props.flexWrap, flexWrap = _f === void 0 ? 'nowrap' : _f, rest = __rest(props, ["as", "gap", "justify", "align", "flexWrap"]);
    return (React.createElement(Component, __assign({ "data-qa": "controls" }, rest, { className: (0, classnames_1.default)(rest.className, styles.container, (_a = {},
            _a[styles.gap1] = gap === 1,
            _a[styles.gap2] = gap === 2,
            _a[styles.gap4] = gap === 4,
            _a[styles.gap8] = gap === 8,
            _a[styles.justifyCenter] = justify === 'center',
            _a[styles.justifyEnd] = justify === 'end',
            _a[styles.justifyStart] = justify === 'start',
            _a[styles.justifySpaceBetween] = justify === 'space-between',
            _a[styles.alignCenter] = align === 'center',
            _a[styles.alignBaseline] = align === 'baseline',
            _a[styles.noWrap] = flexWrap === 'nowrap',
            _a[styles.wrap] = flexWrap === 'wrap',
            _a)) })));
};
exports.Controls = Controls;


/***/ }),

/***/ 8321:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ControlsItem = exports.Controls = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var controls_1 = __webpack_require__(6649);
Object.defineProperty(exports, "Controls", ({ enumerable: true, get: function () { return controls_1.Controls; } }));
var controls_item_1 = __webpack_require__(1962);
Object.defineProperty(exports, "ControlsItem", ({ enumerable: true, get: function () { return controls_item_1.ControlsItem; } }));


/***/ }),

/***/ 1674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogBody = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var margin_box_1 = __webpack_require__(3358);
var styles = __importStar(__webpack_require__(2450));
var dialog_context_1 = __webpack_require__(4405);
/**
 * DialogBody element includes main content of Dialog.
 *
 * By default dialog body could have scroll when the content is too long.
 * This scroll could be disabled by compact dialog mode.
 */
var DialogBody = function (props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), classes = _a.classes, rest = __rest(_a, ["classes"]);
    return (React.createElement(dialog_context_1.DialogContext.Consumer, null, function (dialogContext) {
        var _a;
        return (React.createElement(margin_box_1.MarginBox, __assign({ "data-qa": "dialog-body", contained: "in-dialog" }, rest, { className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
                _a[classes.scrollable] = dialogContext.scrollable,
                _a)) })));
    }));
};
exports.DialogBody = DialogBody;


/***/ }),

/***/ 4405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogContext = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/**
 * Private Dialog Context.
 * It is used to inform nested dialog elements about dialog settings.
 */
exports.DialogContext = React.createContext({
    scrollable: false,
    hideCloseButton: false
});


/***/ }),

/***/ 4894:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogFooter = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var margin_box_1 = __webpack_require__(3358);
var dialog_context_1 = __webpack_require__(4405);
var styles = __importStar(__webpack_require__(6214));
/**
 * Dialog Footer is element that placed in bottom of Dialog.
 * It should presents required actions (buttons).
 */
var DialogFooter = function (props) {
    var children = props.children, startDividerProps = props.startDividerProps, rest = __rest(props, ["children", "startDividerProps"]);
    return (React.createElement(dialog_context_1.DialogContext.Consumer, null, function (dialogContext) { return (React.createElement(margin_box_1.MarginBox, __assign({ "data-qa": "dialog-footer", contained: "in-dialog" }, rest, { className: (0, classnames_1.default)(rest.className, styles.root), noStartDivider: !dialogContext.scrollable, startDividerProps: __assign({ variant: 'stroke' }, startDividerProps) }), children)); }));
};
exports.DialogFooter = DialogFooter;


/***/ }),

/***/ 8976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogFullWidth = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var margin_box_1 = __webpack_require__(3358);
/**
 * Use this element to remove side paddings from Dialog elements.
 * It add negative margins to compensate dialog side paddings.
 */
var DialogFullWidth = function (props) { return React.createElement(margin_box_1.MarginBoxFullWidth, __assign({}, props)); };
exports.DialogFullWidth = DialogFullWidth;


/***/ }),

/***/ 7529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogHeader = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var margin_box_1 = __webpack_require__(3358);
var dialog_context_1 = __webpack_require__(4405);
var styles = __importStar(__webpack_require__(153));
/**
 * Dialog Header should present common info about dialog (title, subtitle).
 * Also it adds right padding for close button placing if exists.
 */
var DialogHeader = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), children = _b.children, _c = _b.contentProps, contentProps = _c === void 0 ? {} : _c, endDividerProps = _b.endDividerProps, startDividerProps = _b.startDividerProps, classes = _b.classes, rest = __rest(_b, ["children", "contentProps", "endDividerProps", "startDividerProps", "classes"]);
    var dialogContext = React.useContext(dialog_context_1.DialogContext);
    return (React.createElement(margin_box_1.MarginBox, __assign({ "data-qa": "dialog-header", contained: "in-dialog" }, rest, { className: (0, classnames_1.default)(rest.className, classes.root), startDividerProps: __assign({ endGap: 5 }, startDividerProps), noEndDivider: !dialogContext.scrollable, endDividerProps: __assign({ variant: 'stroke' }, endDividerProps) }),
        React.createElement("div", __assign({}, contentProps, { className: (0, classnames_1.default)(contentProps.className, classes.content, (_a = {},
                _a[classes.shiftedContent] = !dialogContext.hideCloseButton,
                _a)) }), children)));
};
exports.DialogHeader = DialogHeader;


/***/ }),

/***/ 6524:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dialog = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var cross_icon_1 = __webpack_require__(1433);
var chain_1 = __webpack_require__(9416);
var styles_1 = __webpack_require__(598);
var button_1 = __webpack_require__(8329);
var fade_1 = __webpack_require__(5848);
var overlay_1 = __webpack_require__(5415);
var paper_1 = __webpack_require__(6764);
var dialog_context_1 = __webpack_require__(4405);
var styles = __importStar(__webpack_require__(2465));
/**
 * Dialogs is a modal overlays that could contains some information or controls.
 *
 * Mostly dialog should contain
 * `<DialogHeader />`, `<DialogBody />` and `<DialogFooter />` elements.
 */
function Dialog(props) {
    var _a, _b;
    var handleCloseButtonClick = function (event) {
        if (props.onClose) {
            props.onClose('header-close-button-click', event);
        }
    };
    var mouseDownRef = React.useRef();
    var handleContainerMouseDown = function (event) {
        mouseDownRef.current = event.target;
    };
    var handleContainerClick = function (event) {
        var _a;
        if (event.target !== event.currentTarget) {
            return;
        }
        // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownRef.current) {
            return;
        }
        if (((_a = props.overlayProps) === null || _a === void 0 ? void 0 : _a.disableClickListener) === true) {
            return;
        }
        if (props.onClose) {
            props.onClose('backdrop-click', event);
        }
    };
    var _c = (0, styles_1.mergeClassesProps)(props, styles), open = _c.open, _d = _c.scrollable, scrollable = _d === void 0 ? false : _d, onClose = _c.onClose, onClosed = _c.onClosed, _e = _c.overlayProps, overlayProps = _e === void 0 ? {} : _e, _f = _c.transitionComponent, Transition = _f === void 0 ? fade_1.Fade : _f, classes = _c.classes, children = _c.children, _g = _c.hideCloseButton, hideCloseButton = _g === void 0 ? false : _g, _h = _c.closeButtonProps, closeButtonProps = _h === void 0 ? {} : _h, _j = _c.containerProps, containerProps = _j === void 0 ? {} : _j, _k = _c.size, size = _k === void 0 ? 'auto' : _k, rest = __rest(_c, ["open", "scrollable", "onClose", "onClosed", "overlayProps", "transitionComponent", "classes", "children", "hideCloseButton", "closeButtonProps", "containerProps", "size"]);
    return (React.createElement(overlay_1.Overlay, __assign({}, overlayProps, { open: open, onClose: (0, chain_1.chain)(overlayProps.onClose, onClose), onClosed: (0, chain_1.chain)(overlayProps.onClosed, onClosed), className: (0, classnames_1.default)(overlayProps.className, classes.overlay, (_a = {},
            _a[classes.overlayScrollable] = !scrollable,
            _a)) }),
        React.createElement(dialog_context_1.DialogContext.Provider, { value: { scrollable: scrollable, hideCloseButton: hideCloseButton } },
            React.createElement("div", __assign({}, containerProps, { onClick: (0, chain_1.chain)(containerProps.onClick, handleContainerClick), onMouseDown: (0, chain_1.chain)(containerProps.onMouseDown, handleContainerMouseDown), className: (0, classnames_1.default)(containerProps.className, classes.container) }),
                React.createElement(Transition, { in: open, appear: true },
                    React.createElement(paper_1.Paper, __assign({ "data-qa": "dialog" }, rest, { tabIndex: -1, className: (0, classnames_1.default)(rest.className, classes.root, (_b = {},
                            _b[classes.small] = size === 'small',
                            _b[classes.medium] = size === 'medium',
                            _b[classes.large] = size === 'large',
                            _b)) }),
                        children,
                        !hideCloseButton ? (React.createElement(button_1.Button, __assign({}, closeButtonProps, { ghost: true, size: "tiny", component: "button", className: (0, classnames_1.default)(closeButtonProps.className, classes.closeButton), onClick: (0, chain_1.chain)(closeButtonProps.onClick, handleCloseButtonClick) }),
                            React.createElement(cross_icon_1.CrossIcon, null))) : null))))));
}
exports.Dialog = Dialog;


/***/ }),

/***/ 5330:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DialogBody = exports.DialogFooter = exports.DialogFullWidth = exports.DialogHeader = exports.Dialog = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var dialog_1 = __webpack_require__(6524);
Object.defineProperty(exports, "Dialog", ({ enumerable: true, get: function () { return dialog_1.Dialog; } }));
var dialog_header_1 = __webpack_require__(7529);
Object.defineProperty(exports, "DialogHeader", ({ enumerable: true, get: function () { return dialog_header_1.DialogHeader; } }));
var dialog_full_width_1 = __webpack_require__(8976);
Object.defineProperty(exports, "DialogFullWidth", ({ enumerable: true, get: function () { return dialog_full_width_1.DialogFullWidth; } }));
var dialog_footer_1 = __webpack_require__(4894);
Object.defineProperty(exports, "DialogFooter", ({ enumerable: true, get: function () { return dialog_footer_1.DialogFooter; } }));
var dialog_body_1 = __webpack_require__(1674);
Object.defineProperty(exports, "DialogBody", ({ enumerable: true, get: function () { return dialog_body_1.DialogBody; } }));


/***/ }),

/***/ 5561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Divider = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var dark_context_1 = __webpack_require__(3693);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(8179));
/** A divider is a thin line that groups content in lists and layouts. */
function Divider(props) {
    return (React.createElement(dark_context_1.DarkContext.Consumer, null, function (darkContext) {
        var _a;
        var _b = props.gap, gap = _b === void 0 ? 1 : _b;
        var _c = (0, styles_1.mergeClassesProps)(props, styles), className = _c.className, _d = _c.variant, variant = _d === void 0 ? 'stroke' : _d, omittedGap = _c.gap, _e = _c.startGap, startGap = _e === void 0 ? gap : _e, _f = _c.endGap, endGap = _f === void 0 ? gap : _f, classes = _c.classes, _g = _c.inverted, inverted = _g === void 0 ? darkContext : _g, rest = __rest(_c, ["className", "variant", "gap", "startGap", "endGap", "classes", "inverted"]);
        return (React.createElement("hr", __assign({ "data-qa": "divider" }, rest, { className: (0, classnames_1.default)(className, classes.root, (_a = {},
                _a[classes.dashed] = variant === 'dashed',
                _a[classes.transparent] = variant === 'transparent',
                _a[classes.startGap1] = startGap === 1,
                _a[classes.startGap2] = startGap === 2,
                _a[classes.startGap3] = startGap === 3,
                _a[classes.startGap4] = startGap === 4,
                _a[classes.startGap5] = startGap === 5,
                _a[classes.endGap1] = endGap === 1,
                _a[classes.endGap2] = endGap === 2,
                _a[classes.endGap3] = endGap === 3,
                _a[classes.endGap4] = endGap === 4,
                _a[classes.endGap5] = endGap === 5,
                _a[classes.inverted] = inverted,
                _a)) })));
    }));
}
exports.Divider = Divider;


/***/ }),

/***/ 1840:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Divider = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var divider_1 = __webpack_require__(5561);
Object.defineProperty(exports, "Divider", ({ enumerable: true, get: function () { return divider_1.Divider; } }));


/***/ }),

/***/ 1093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DrawerFullWidth = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var margin_box_1 = __webpack_require__(3358);
/**
 * Use this element to remove side paddings from Drawer elements.
 * It add negative margins to compensate drawer side paddings.
 */
var DrawerFullWidth = function (props) { return React.createElement(margin_box_1.MarginBoxFullWidth, __assign({}, props)); };
exports.DrawerFullWidth = DrawerFullWidth;


/***/ }),

/***/ 212:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Drawer = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var margin_box_1 = __webpack_require__(3358);
var overlay_1 = __webpack_require__(5415);
var paper_1 = __webpack_require__(6764);
var slide_1 = __webpack_require__(6798);
var styles = __importStar(__webpack_require__(5234));
/**
 * Navigation drawers provide access to destinations in your app.
 * Side sheets are surfaces containing supplementary content
 * that are anchored to the left or right edge of the screen.
 */
var Drawer = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), open = _b.open, onClose = _b.onClose, onClosed = _b.onClosed, _c = _b.side, side = _c === void 0 ? 'left' : _c, _d = _b.overlayProps, overlayProps = _d === void 0 ? {} : _d, _e = _b.slideProps, slideProps = _e === void 0 ? {} : _e, classes = _b.classes, rest = __rest(_b, ["open", "onClose", "onClosed", "side", "overlayProps", "slideProps", "classes"]);
    return (React.createElement(overlay_1.Overlay, __assign({}, overlayProps, { open: open, onClose: onClose, onClosed: onClosed, className: (0, classnames_1.default)(overlayProps.className, classes.overlay) }),
        React.createElement(slide_1.Slide, __assign({}, slideProps, { appear: true, in: open, direction: side }),
            React.createElement(margin_box_1.MarginBox, __assign({ "data-qa": "drawer", tabIndex: -1, contained: "in-dialog" }, rest, { as: paper_1.Paper, className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
                    _a[classes.leftSided] = side === 'left',
                    _a[classes.rightSided] = side === 'right',
                    _a)) })))));
};
exports.Drawer = Drawer;


/***/ }),

/***/ 2141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DrawerFullWidth = exports.Drawer = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var drawer_1 = __webpack_require__(212);
Object.defineProperty(exports, "Drawer", ({ enumerable: true, get: function () { return drawer_1.Drawer; } }));
var drawer_full_width_1 = __webpack_require__(1093);
Object.defineProperty(exports, "DrawerFullWidth", ({ enumerable: true, get: function () { return drawer_full_width_1.DrawerFullWidth; } }));


/***/ }),

/***/ 1270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fade = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var Transition_1 = __importDefault(__webpack_require__(660));
var chain_1 = __webpack_require__(9416);
var reflow_1 = __webpack_require__(6874);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(5001));
var DURATION_TIMEOUT = 300;
/**
 * Fade transition component is used for smoothed showing and hiding elements through opacity.
 *
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Fade = /** @class */ (function (_super) {
    __extends(Fade, _super);
    function Fade() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestId = null;
        _this.handleEnter = function (node) {
            var classes = (0, styles_1.mergeClassesProps)(_this.props, styles).classes;
            node.classList.remove(classes.enter);
            node.classList.add(classes.exit);
            _this.requestAnimationFrame(function () {
                node.classList.remove(classes.exiting);
                node.classList.add(classes.entering);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.exit);
                node.classList.add(classes.enter);
            });
        };
        _this.handleExit = function (node) {
            var classes = (0, styles_1.mergeClassesProps)(_this.props, styles).classes;
            node.classList.remove(classes.exit);
            node.classList.add(classes.enter);
            _this.requestAnimationFrame(function () {
                node.classList.remove(classes.entering);
                node.classList.add(classes.exiting);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.enter);
                node.classList.add(classes.exit);
            });
        };
        return _this;
    }
    Fade.prototype.componentWillUnmount = function () {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
    };
    Fade.prototype.requestAnimationFrame = function (callback) {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
        this.requestId = requestAnimationFrame(callback);
    };
    Fade.prototype.render = function () {
        var _a;
        var _b = (0, styles_1.mergeClassesProps)(this.props, styles), className = _b.className, classes = _b.classes, children = _b.children, rest = __rest(_b, ["className", "classes", "children"]);
        var child = React.Children.only(children);
        return (React.createElement(Transition_1.default, __assign({}, rest, { timeout: DURATION_TIMEOUT, onEnter: (0, chain_1.chain)(rest.onEnter, this.handleEnter), onExit: (0, chain_1.chain)(rest.onExit, this.handleExit) }), React.cloneElement(child, {
            className: (0, classnames_1.default)(className, child.props.className, (_a = {},
                _a[classes.enter] = rest.in,
                _a[classes.exit] = !rest.in,
                _a))
        })));
    };
    return Fade;
}(React.Component));
exports.Fade = Fade;


/***/ }),

/***/ 5848:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fade = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var fade_1 = __webpack_require__(1270);
Object.defineProperty(exports, "Fade", ({ enumerable: true, get: function () { return fade_1.Fade; } }));


/***/ }),

/***/ 1574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Field = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(9274));
/**
 * Field is base component that used to set common styles for input-like components
 * like `select`, `input`, `textarea` etc.
 * Using of this component should be avoided in common cases.
 */
exports.Field = React.forwardRef(function Field(props, ref) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), _c = _b.component, Component = _c === void 0 ? 'div' : _c, fullWidth = _b.fullWidth, focused = _b.focused, invalid = _b.invalid, classes = _b.classes, rest = __rest(_b, ["component", "fullWidth", "focused", "invalid", "classes"]);
    return (React.createElement(Component, __assign({ "data-qa": "field" }, rest, { ref: ref, className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
            _a[classes.invalid] = invalid,
            _a[classes.disabled] = rest.disabled,
            _a[classes.focused] = focused,
            _a[classes.fullWidth] = fullWidth,
            _a)) })));
});


/***/ }),

/***/ 3874:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Field = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var field_1 = __webpack_require__(1574);
Object.defineProperty(exports, "Field", ({ enumerable: true, get: function () { return field_1.Field; } }));


/***/ }),

/***/ 1697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexExpander = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(6838));
/**
 * Helper component that lets to expand two near flex element.
 * Useful when you want to push flex element to the right of container.
 */
var FlexExpander = function (props) { return (React.createElement("div", __assign({}, props, { className: (0, classnames_1.default)(props.className, styles.root) }))); };
exports.FlexExpander = FlexExpander;


/***/ }),

/***/ 9629:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexExpander = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var flex_expander_1 = __webpack_require__(1697);
Object.defineProperty(exports, "FlexExpander", ({ enumerable: true, get: function () { return flex_expander_1.FlexExpander; } }));


/***/ }),

/***/ 2813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexItem = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var flex_1 = __webpack_require__(1016);
/** Helper component to make flex layouts with paddings */
var FlexItem = function (props) { return (React.createElement(flex_1.Flex, __assign({}, props),
    React.createElement("div", null, props.children))); };
exports.FlexItem = FlexItem;


/***/ }),

/***/ 1016:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(2411));
/**
 * Component to build flex layouts.
 */
var Flex = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), container = _b.container, shrink = _b.shrink, grow = _b.grow, _c = _b.gap, gap = _c === void 0 ? 2 : _c, ellipsis = _b.ellipsis, children = _b.children, baseline = _b.baseline, className = _b.className, classes = _b.classes, justify = _b.justify, align = _b.align, flexWrap = _b.flexWrap, direction = _b.direction, rest = __rest(_b, ["container", "shrink", "grow", "gap", "ellipsis", "children", "baseline", "className", "classes", "justify", "align", "flexWrap", "direction"]);
    var child = React.Children.only(children);
    return React.cloneElement(child, __assign(__assign({}, rest), { className: (0, classnames_1.default)(className, child.props.className, classes.root, (_a = {},
            _a[classes.container] = container,
            _a[classes.baseline] = baseline,
            _a[classes.shrink] = shrink,
            _a[classes.grow] = grow,
            _a[classes.gap0] = gap === 0,
            _a[classes.gap1] = gap === 1,
            _a[classes.gap2] = gap === 2,
            _a[classes.gap3] = gap === 3,
            _a[classes.gap4] = gap === 4,
            _a[classes.ellipsis] = ellipsis,
            _a[classes.justifyStart] = justify === 'start',
            _a[classes.justifyCenter] = justify === 'center',
            _a[classes.justifyEnd] = justify === 'end',
            _a[classes.alignStart] = align === 'start',
            _a[classes.alignCenter] = align === 'center',
            _a[classes.alignBaseline] = align === 'baseline',
            _a[classes.alignEnd] = align === 'end',
            _a[classes.noWrap] = flexWrap === 'nowrap',
            _a[classes.wrap] = flexWrap === 'wrap',
            _a[classes.row] = direction === 'row',
            _a[classes.rowReverse] = direction === 'row-reverse',
            _a[classes.column] = direction === 'column',
            _a[classes.columnReverse] = direction === 'column-reverse',
            _a)) }));
};
exports.Flex = Flex;


/***/ }),

/***/ 6339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexItem = exports.Flex = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var flex_1 = __webpack_require__(1016);
Object.defineProperty(exports, "Flex", ({ enumerable: true, get: function () { return flex_1.Flex; } }));
var flex_item_1 = __webpack_require__(2813);
Object.defineProperty(exports, "FlexItem", ({ enumerable: true, get: function () { return flex_item_1.FlexItem; } }));


/***/ }),

/***/ 4268:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusTrap = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var contains_1 = __importDefault(__webpack_require__(424));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var focusable_elements_1 = __webpack_require__(8717);
var root_ref_1 = __webpack_require__(5424);
function focusElement(element) {
    if (element && element !== document.activeElement) {
        element.focus();
    }
}
function getReachableElementOrSelfInContainer(container, direction) {
    var element = direction === 'next'
        ? (0, focusable_elements_1.getFirstReachableElement)(container)
        : (0, focusable_elements_1.getLastReachableElement)(container);
    if (!element && (0, focusable_elements_1.isElementFocusable)(container)) {
        element = container;
    }
    return element;
}
function getSiblingReachableElement(element, direction) {
    if (!element.parentElement) {
        return null;
    }
    return (0, focusable_elements_1.getSiblingElement)(Array.from((0, focusable_elements_1.getReachableElements)(element.parentElement)), element, direction);
}
/**
 * Component that trap focus in `children`.
 * When user focuses in some element inside children
 * he could not focus element outside this trap by `Tab` key.
 * It is useful when modal overlay has shown to disable
 * all page content under the overlay for focusing.
 *
 * Uses two "sentinel" elements with `tabIndex = 0`
 * before and after root container to prevent
 * browser blur out the trap. This practice is used in W3C dialog example.
 *
 * @see https://www.w3.org/TR/wai-aria-practices/examples/dialog-modal/dialog.html
 */
var FocusTrap = /** @class */ (function (_super) {
    __extends(FocusTrap, _super);
    function FocusTrap(props) {
        var _this = _super.call(this, props) || this;
        _this.trapRef = React.createRef();
        _this.activeElementOnMount = null;
        _this.handleStartFocus = function (event) {
            var trapElement = _this.trapRef.current;
            if (!trapElement) {
                return;
            }
            if ((0, focusable_elements_1.isElementReachable)(trapElement) && trapElement !== event.relatedTarget) {
                focusElement(trapElement);
                return;
            }
            var direction = (0, focusable_elements_1.getFocusDirection)(event) || 'next';
            focusElement(getReachableElementOrSelfInContainer(trapElement, direction) ||
                getSiblingReachableElement(event.currentTarget, direction));
        };
        _this.handleEndFocus = function (event) {
            var trapElement = _this.trapRef.current;
            if (!trapElement) {
                return;
            }
            if ((0, focusable_elements_1.isElementReachable)(trapElement)) {
                focusElement(trapElement);
                return;
            }
            var direction = (0, focusable_elements_1.getFocusDirection)(event) || 'prev';
            focusElement(getReachableElementOrSelfInContainer(trapElement, direction) ||
                getSiblingReachableElement(event.currentTarget, direction));
        };
        // remember active element before mounting because
        // focus trap could contains inputs with `autoFocus`
        // which will steal focus on mount
        if (props.focusOnMount && document.activeElement instanceof HTMLElement) {
            _this.activeElementOnMount = document.activeElement;
        }
        return _this;
    }
    FocusTrap.prototype.componentDidMount = function () {
        if (this.props.focusOnMount) {
            this.trapFocus();
        }
    };
    FocusTrap.prototype.componentWillUnmount = function () {
        var activeElementOnMount = this.activeElementOnMount;
        var trapElement = this.trapRef.current;
        // focus could be exit from the trap, do not restore focus in this cases
        if (document.activeElement &&
            (0, focusable_elements_1.isElementFocusable)(document.activeElement) &&
            trapElement &&
            !(0, contains_1.default)(trapElement, document.activeElement)) {
            return;
        }
        if (activeElementOnMount && (0, contains_1.default)(document.body, activeElementOnMount)) {
            activeElementOnMount.focus();
        }
    };
    FocusTrap.prototype.trapFocus = function () {
        var trapElement = this.trapRef.current;
        if (!trapElement) {
            return;
        }
        // do not change focus if active element is already inside the trap element
        if (document.activeElement && (0, contains_1.default)(trapElement, document.activeElement)) {
            return;
        }
        if ((0, focusable_elements_1.isElementFocusable)(trapElement)) {
            focusElement(trapElement);
        }
        else {
            var focusableElements = (0, focusable_elements_1.getFocusableElements)(trapElement);
            focusElement(focusableElements.item(0));
        }
    };
    FocusTrap.prototype.render = function () {
        var _a = this.props, _b = _a.startSentinelProps, startSentinelProps = _b === void 0 ? {} : _b, startSentinelRef = _a.startSentinelRef, _c = _a.endSentinelProps, endSentinelProps = _c === void 0 ? {} : _c, endSentinelRef = _a.endSentinelRef, children = _a.children;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", __assign({}, startSentinelProps, { ref: startSentinelRef, tabIndex: 0, onFocus: (0, chain_1.chain)(startSentinelProps.onFocus, this.handleStartFocus) })),
            React.createElement(root_ref_1.RootRef, { rootRef: this.trapRef }, children),
            React.createElement("div", __assign({}, endSentinelProps, { ref: endSentinelRef, tabIndex: 0, onFocus: (0, chain_1.chain)(endSentinelProps.onFocus, this.handleEndFocus) }))));
    };
    return FocusTrap;
}(React.Component));
exports.FocusTrap = FocusTrap;


/***/ }),

/***/ 7071:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusTrap = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var focus_trap_1 = __webpack_require__(4268);
Object.defineProperty(exports, "FocusTrap", ({ enumerable: true, get: function () { return focus_trap_1.FocusTrap; } }));


/***/ }),

/***/ 9226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormControlLabel = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var controls_1 = __webpack_require__(8321);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(1120));
/** Drop-in replacement of the Switch component. Use this component if you want to display an extra label. */
function FormControlLabel(props) {
    var _a;
    var control = props.control, label = props.label, labelProps = props.labelProps, disabledProp = props.disabled, _b = props.gap, gap = _b === void 0 ? 1 : _b, restProps = __rest(props, ["control", "label", "labelProps", "disabled", "gap"]);
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
        disabled = control.props.disabled;
    }
    var controlProps = {
        disabled: disabled
    };
    var renderLabel = function () {
        var _a;
        var mutatedLabelProps = __assign(__assign({}, labelProps), { className: (0, classnames_1.default)(labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, (_a = {},
                _a[styles.typographyDisabled] = disabled,
                _a)) });
        if (react_1.default.isValidElement(props.label) && props.label.type === typography_1.Typography) {
            return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.cloneElement(label, mutatedLabelProps));
        }
        return react_1.default.createElement(typography_1.Typography, __assign({}, mutatedLabelProps), label);
    };
    return (react_1.default.createElement(controls_1.Controls, __assign({ "data-qa": "form-control-label" }, restProps, { gap: gap, as: "label", className: (0, classnames_1.default)(styles.label, restProps.className, (_a = {},
            _a[styles.disabled] = disabled,
            _a)) }),
        react_1.default.createElement(controls_1.ControlsItem, null, react_1.default.cloneElement(props.control, controlProps)),
        react_1.default.createElement(controls_1.ControlsItem, null, renderLabel())));
}
exports.FormControlLabel = FormControlLabel;


/***/ }),

/***/ 9962:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormControlLabel = void 0;
var form_control_label_1 = __webpack_require__(9226);
Object.defineProperty(exports, "FormControlLabel", ({ enumerable: true, get: function () { return form_control_label_1.FormControlLabel; } }));


/***/ }),

/***/ 7087:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grow = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var Transition_1 = __importDefault(__webpack_require__(660));
var chain_1 = __webpack_require__(9416);
var reflow_1 = __webpack_require__(6874);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(6919));
var DURATION_TIMEOUT = 300;
var getTransformOriginClassName = function (transformOrigin) {
    if (transformOrigin === 'center left') {
        return 'centerLeft';
    }
    if (transformOrigin === 'center right') {
        return 'centerRight';
    }
    if (transformOrigin === 'top center') {
        return 'topCenter';
    }
    if (transformOrigin === 'top left') {
        return 'topLeft';
    }
    if (transformOrigin === 'top right') {
        return 'topRight';
    }
    if (transformOrigin === 'bottom center') {
        return 'bottomCenter';
    }
    if (transformOrigin === 'bottom left') {
        return 'bottomLeft';
    }
    if (transformOrigin === 'bottom right') {
        return 'bottomRight';
    }
    return 'centerCenter';
};
/**
 * Grow transition component.
 *
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Grow = /** @class */ (function (_super) {
    __extends(Grow, _super);
    function Grow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestId = null;
        _this.handleEnter = function (node) {
            var classes = (0, styles_1.mergeClassesProps)(_this.props, styles).classes;
            node.classList.remove(classes.enter);
            node.classList.add(classes.exit);
            _this.requestAnimationFrame(function () {
                node.classList.remove(classes.exiting);
                node.classList.add(classes.entering);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.exit);
                node.classList.add(classes.enter);
            });
        };
        _this.handleExit = function (node) {
            var classes = (0, styles_1.mergeClassesProps)(_this.props, styles).classes;
            node.classList.remove(classes.exit);
            node.classList.add(classes.enter);
            _this.requestAnimationFrame(function () {
                node.classList.remove(classes.entering);
                node.classList.add(classes.exiting);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.enter);
                node.classList.add(classes.exit);
            });
        };
        return _this;
    }
    Grow.prototype.componentWillUnmount = function () {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
    };
    Grow.prototype.requestAnimationFrame = function (callback) {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
        this.requestId = requestAnimationFrame(callback);
    };
    Grow.prototype.render = function () {
        var _a;
        var _b = (0, styles_1.mergeClassesProps)(this.props, styles), className = _b.className, classes = _b.classes, _c = _b.transformOrigin, transformOrigin = _c === void 0 ? 'center center' : _c, rest = __rest(_b, ["className", "classes", "transformOrigin"]);
        var child = React.Children.only(this.props.children);
        var transformOriginClassName = classes[getTransformOriginClassName(transformOrigin)];
        return (React.createElement(Transition_1.default, __assign({}, rest, { timeout: DURATION_TIMEOUT, onEnter: (0, chain_1.chain)(rest.onEnter, this.handleEnter), onExit: (0, chain_1.chain)(rest.onExit, this.handleExit) }), React.cloneElement(child, {
            className: (0, classnames_1.default)(className, child.props.className, transformOriginClassName, (_a = {},
                _a[classes.enter] = rest.in,
                _a[classes.exit] = !rest.in,
                _a))
        })));
    };
    return Grow;
}(React.Component));
exports.Grow = Grow;


/***/ }),

/***/ 7118:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grow = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var grow_1 = __webpack_require__(7087);
Object.defineProperty(exports, "Grow", ({ enumerable: true, get: function () { return grow_1.Grow; } }));


/***/ }),

/***/ 2946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderBlock = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(595));
var header_item_text_1 = __webpack_require__(6371);
/**
 * Use HeaderBlock if you want to show some non-interactive information
 * in the Header.
 */
function HeaderBlock(props) {
    var _a;
    var _b = props.as, Component = _b === void 0 ? 'div' : _b, grow = props.grow, shrink = props.shrink, headerItemTextProps = props.headerItemTextProps, rest = __rest(props, ["as", "grow", "shrink", "headerItemTextProps"]);
    var children = typeof props.children === 'string' ? (React.createElement(header_item_text_1.HeaderItemText, __assign({}, headerItemTextProps), props.children)) : (props.children);
    return (React.createElement(Component, __assign({ "data-qa": "header-block" }, rest, { className: (0, classnames_1.default)(rest.className, styles.root, (_a = {},
            _a[styles.grow] = grow,
            _a[styles.shrink] = shrink,
            _a)) }), children));
}
exports.HeaderBlock = HeaderBlock;


/***/ }),

/***/ 7882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderItemCell = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(1833));
/** Shortcut to ListItemCell */
var HeaderItemCell = function (props) {
    var _a;
    var grow = props.grow, shrink = props.shrink, rest = __rest(props, ["grow", "shrink"]);
    return (React.createElement("div", __assign({ "data-qa": "header-item-cell" }, rest, { className: (0, classnames_1.default)(rest.className, styles.root, (_a = {},
            _a[styles.grow] = grow,
            _a[styles.shrink] = shrink,
            _a)) })));
};
exports.HeaderItemCell = HeaderItemCell;


/***/ }),

/***/ 5858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderItemIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(4972));
/**
 * Icon that could be placed in header item or button.
 * It has different margins from header item cell or text.
 */
var HeaderItemIcon = function (props) { return (React.createElement("div", __assign({ "data-qa": "header-item-icon" }, props, { className: (0, classnames_1.default)(props.className, styles.root) }))); };
exports.HeaderItemIcon = HeaderItemIcon;


/***/ }),

/***/ 5441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderItemSecondaryActions = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/* eslint-disable react/prop-types */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var styles = __importStar(__webpack_require__(4624));
/**
 * Header item could include other buttons.
 * Wrap this buttons with HeaderItemSecondaryActions to avoid click conflicts.
 */
var HeaderItemSecondaryActions = /** @class */ (function (_super) {
    __extends(HeaderItemSecondaryActions, _super);
    function HeaderItemSecondaryActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            event.stopPropagation();
            event.preventDefault();
        };
        return _this;
    }
    HeaderItemSecondaryActions.prototype.render = function () {
        return (React.createElement("div", __assign({ "data-qa": "header-item-secondary-actions" }, this.props, { onClick: (0, chain_1.chain)(this.props.onClick, this.handleClick), className: (0, classnames_1.default)(this.props.className, styles.root) })));
    };
    return HeaderItemSecondaryActions;
}(React.Component));
exports.HeaderItemSecondaryActions = HeaderItemSecondaryActions;


/***/ }),

/***/ 6371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderItemText = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(5883));
/** Shortcut to ListItemText */
var HeaderItemText = function (props) { return (React.createElement(typography_1.Typography, __assign({ "data-qa": "header-item-text", as: "div" }, props, { className: (0, classnames_1.default)(props.className, styles.root) }))); };
exports.HeaderItemText = HeaderItemText;


/***/ }),

/***/ 8940:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderItem = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var focusable_elements_1 = __webpack_require__(8717);
var styles_1 = __webpack_require__(598);
var interactive_element_1 = __webpack_require__(9699);
var header_block_1 = __webpack_require__(2946);
var header_item_text_1 = __webpack_require__(6371);
var styles = __importStar(__webpack_require__(1953));
/**
 * `HeaderItem` is interactive element of `Header`.
 * By default it is not a native button because it could have nested buttons.
 * For add nested buttons use `HeaderItemSecondaryActions`.
 */
var HeaderItem = /** @class */ (function (_super) {
    __extends(HeaderItem, _super);
    function HeaderItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (event) {
            var item = event.currentTarget;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                var direction = event.key === 'ArrowRight' ? 'next' : 'prev';
                event.preventDefault();
                var reachableElements = item.parentElement && Array.from((0, focusable_elements_1.getReachableElements)(item.parentElement));
                var nextItem = reachableElements && (0, focusable_elements_1.getSiblingElement)(reachableElements, item, direction);
                if (nextItem) {
                    nextItem.focus();
                }
            }
        };
        return _this;
    }
    HeaderItem.prototype.render = function () {
        var _a;
        var _b = (0, styles_1.mergeClassesProps)(this.props, styles), active = _b.active, disabled = _b.disabled, classes = _b.classes, _c = _b.fakeHoverProps, fakeHoverProps = _c === void 0 ? {} : _c, headerItemTextProps = _b.headerItemTextProps, rest = __rest(_b, ["active", "disabled", "classes", "fakeHoverProps", "headerItemTextProps"]);
        var interactiveElementProps = {
            disabled: disabled,
            activeClassName: classes.active
        };
        var children = typeof rest.children === 'string' ? (React.createElement(header_item_text_1.HeaderItemText, __assign({}, headerItemTextProps), rest.children)) : (rest.children);
        var fakeHoverElement = (React.createElement("div", __assign({}, fakeHoverProps, { className: (0, classnames_1.default)(fakeHoverProps.className, classes.fakeHover) })));
        return (React.createElement(header_block_1.HeaderBlock, __assign({ "data-qa": "header-item" }, rest, { as: interactive_element_1.InteractiveElement }, interactiveElementProps, { onKeyDown: (0, chain_1.chain)(rest.onKeyDown, this.handleKeyDown), className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
                _a[classes.active] = active,
                _a[classes.disabled] = disabled,
                _a)) }),
            children,
            fakeHoverElement));
    };
    return HeaderItem;
}(React.Component));
exports.HeaderItem = HeaderItem;


/***/ }),

/***/ 5143:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Header = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var flex_1 = __webpack_require__(6339);
var overlay_manager_1 = __webpack_require__(6777);
var styles = __importStar(__webpack_require__(7822));
/**
 * Header displays common information and actions related to the current screen.
 * It is used for branding, page title, navigation and actions.
 */
var Header = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), disablePositionFixed = _b.disablePositionFixed, disableStaticSpacer = _b.disableStaticSpacer, disableBorder = _b.disableBorder, _c = _b.staticSpacerProps, staticSpacerProps = _c === void 0 ? {} : _c, classes = _b.classes, rest = __rest(_b, ["disablePositionFixed", "disableStaticSpacer", "disableBorder", "staticSpacerProps", "classes"]);
    var spacer = !disableStaticSpacer && !disablePositionFixed ? (React.createElement("div", __assign({}, staticSpacerProps, { className: (0, classnames_1.default)(staticSpacerProps.className, classes.spacer) }))) : null;
    return (React.createElement(React.Fragment, null,
        spacer,
        React.createElement(flex_1.Flex, { container: true, gap: 0 },
            React.createElement("div", __assign({ "data-qa": "header" }, rest, { className: (0, classnames_1.default)(classes.root, rest.className, (_a = {},
                    _a[overlay_manager_1.FIXED_BLOCKS_CLASS_NAME] = !disablePositionFixed,
                    _a[classes.fixed] = !disablePositionFixed,
                    _a[classes.withBorder] = !disableBorder,
                    _a)) })))));
};
exports.Header = Header;


/***/ }),

/***/ 1230:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderBlock = exports.HeaderItemSecondaryActions = exports.HeaderItemText = exports.HeaderItemIcon = exports.HeaderItemCell = exports.HeaderItem = exports.Header = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var header_1 = __webpack_require__(5143);
Object.defineProperty(exports, "Header", ({ enumerable: true, get: function () { return header_1.Header; } }));
var header_item_1 = __webpack_require__(8940);
Object.defineProperty(exports, "HeaderItem", ({ enumerable: true, get: function () { return header_item_1.HeaderItem; } }));
var header_item_cell_1 = __webpack_require__(7882);
Object.defineProperty(exports, "HeaderItemCell", ({ enumerable: true, get: function () { return header_item_cell_1.HeaderItemCell; } }));
var header_item_icon_1 = __webpack_require__(5858);
Object.defineProperty(exports, "HeaderItemIcon", ({ enumerable: true, get: function () { return header_item_icon_1.HeaderItemIcon; } }));
var header_item_text_1 = __webpack_require__(6371);
Object.defineProperty(exports, "HeaderItemText", ({ enumerable: true, get: function () { return header_item_text_1.HeaderItemText; } }));
var header_item_secondary_actions_1 = __webpack_require__(5441);
Object.defineProperty(exports, "HeaderItemSecondaryActions", ({ enumerable: true, get: function () { return header_item_secondary_actions_1.HeaderItemSecondaryActions; } }));
var header_block_1 = __webpack_require__(2946);
Object.defineProperty(exports, "HeaderBlock", ({ enumerable: true, get: function () { return header_block_1.HeaderBlock; } }));


/***/ }),

/***/ 3388:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HiddenScrollbar = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var contains_1 = __importDefault(__webpack_require__(424));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var set_ref_1 = __webpack_require__(2403);
var styles_1 = __webpack_require__(598);
var icon_1 = __webpack_require__(6185);
var styles = __importStar(__webpack_require__(6241));
var scroll_into_container_view_1 = __webpack_require__(8257);
var DEFAULT_SCROLL_STEP = 32;
var DEFAULT_SCROLL_STEP_TIMEOUT = 100;
var ScrollDirectionIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 16 16", fill: "none" },
    React.createElement("path", { d: "M8 6l4 4H4l4-4z", fill: "#818181" })));
/**
 * The component customize native scrollbars to fancy look (just hide it)
 * but leaves native scroll functions.
 *
 * It regulates inner scroll position by focused items.
 * It has two scroll controls on the top and the bottom edges.
 * When user hovers to this controls the component start to scroll inner container
 * to certain direction.
 *
 * @WARNING
 * This component is using flexbox model. If you use `max-height` to limit height of container
 * you should wrap it by element with `display: flex; flex-direction: row`
 * styles. @see https://git.io/fhjPt
 */
var HiddenScrollbar = /** @class */ (function (_super) {
    __extends(HiddenScrollbar, _super);
    function HiddenScrollbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** This timer starts when user hover on the edge scroll controls */
        _this.scrollIntervalId = null;
        /** Container that have scroll */
        _this.containerRef = React.createRef();
        /** Scroll controls that initiate scrolling on hover */
        _this.startControlRef = React.createRef();
        _this.endControlRef = React.createRef();
        _this.animationRequestId = null;
        _this.handleScroll = function () {
            _this.updateContainer();
        };
        /**
         * To prevent partial hiding focused elements below the scroll controls
         * we should move the focused element to visible area in the scroll container.
         */
        _this.handleFocus = function (event) {
            var container = _this.containerRef.current;
            var startControl = _this.startControlRef.current;
            var endControl = _this.endControlRef.current;
            var target = event.target;
            if (container && startControl && endControl && (0, contains_1.default)(container, target)) {
                (0, scroll_into_container_view_1.scrollIntoContainerView)({
                    container: container,
                    startControl: startControl,
                    endControl: endControl,
                    target: target
                });
            }
        };
        /** Starts scroll changing interval whe user hovers to the scroll controls */
        _this.handleStartScrollElementMouseEnter = function () {
            _this.setScrollInterval(function () {
                var container = _this.containerRef.current;
                if (!container) {
                    return;
                }
                var _a = _this.props.scrollStep, scrollStep = _a === void 0 ? DEFAULT_SCROLL_STEP : _a;
                var scrollTop = container.scrollTop;
                container.scrollTop = Math.max(scrollTop - scrollStep, 0);
            });
        };
        _this.handleEndControlMouseEnter = function () {
            _this.setScrollInterval(function () {
                var container = _this.containerRef.current;
                if (!container) {
                    return;
                }
                var _a = _this.props.scrollStep, scrollStep = _a === void 0 ? DEFAULT_SCROLL_STEP : _a;
                var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
                var maxScrollTop = scrollHeight - clientHeight;
                container.scrollTop = Math.min(scrollTop + scrollStep, maxScrollTop);
            });
        };
        /** Stop scroll changing interval when mouse leaves scroll controls */
        _this.handleStartScrollElementMouseLeave = function () {
            _this.clearScrollInterval();
        };
        _this.handleEndControlMouseLeave = function () {
            _this.clearScrollInterval();
        };
        return _this;
    }
    HiddenScrollbar.prototype.componentDidMount = function () {
        this.updateContainer();
    };
    HiddenScrollbar.prototype.componentDidUpdate = function () {
        this.updateContainer();
    };
    HiddenScrollbar.prototype.componentWillUnmount = function () {
        this.cancelAnimationFrame();
        this.clearScrollInterval();
    };
    HiddenScrollbar.prototype.cancelAnimationFrame = function () {
        if (this.animationRequestId) {
            window.cancelAnimationFrame(this.animationRequestId);
            this.animationRequestId = null;
        }
    };
    HiddenScrollbar.prototype.requestAnimationFrame = function (callback) {
        this.cancelAnimationFrame();
        this.animationRequestId = window.requestAnimationFrame(callback);
    };
    HiddenScrollbar.prototype.clearScrollInterval = function () {
        if (this.scrollIntervalId) {
            window.clearInterval(this.scrollIntervalId);
            this.scrollIntervalId = null;
        }
    };
    HiddenScrollbar.prototype.setScrollInterval = function (callback) {
        this.clearScrollInterval();
        var _a = this.props.scrollStepTimeout, scrollStepTimeout = _a === void 0 ? DEFAULT_SCROLL_STEP_TIMEOUT : _a;
        this.scrollIntervalId = window.setInterval(callback, scrollStepTimeout);
        callback();
    };
    /**
     * We should hide scroll controls when they are not necessary:
     * - in edge positions (the top or the bottom)
     * - when scroll container does not have scroll
     */
    HiddenScrollbar.prototype.updateContainer = function () {
        var _this = this;
        this.requestAnimationFrame(function () {
            var container = _this.containerRef.current;
            var startControl = _this.startControlRef.current;
            var endControl = _this.endControlRef.current;
            if (!container || !startControl || !endControl) {
                return;
            }
            var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
            startControl.style.display = scrollTop === 0 ? 'none' : 'flex';
            /**
             * @HACK
             * Sometimes in EDGE `scrollHeight` is greater than `clientHeight` with 1 pixel.
             */
            endControl.style.display =
                scrollTop >= scrollHeight - clientHeight - 1 ? 'none' : 'flex';
        });
    };
    HiddenScrollbar.prototype.render = function () {
        var _a = (0, styles_1.mergeClassesProps)(this.props, styles), scrollStep = _a.scrollStep, scrollStepTimeout = _a.scrollStepTimeout, children = _a.children, className = _a.className, classes = _a.classes, _b = _a.containerProps, containerProps = _b === void 0 ? {} : _b, containerRef = _a.containerRef, _c = _a.startControlProps, startControlProps = _c === void 0 ? {} : _c, startControlRef = _a.startControlRef, _d = _a.endControlProps, endControlProps = _d === void 0 ? {} : _d, endControlRef = _a.endControlRef, rest = __rest(_a, ["scrollStep", "scrollStepTimeout", "children", "className", "classes", "containerProps", "containerRef", "startControlProps", "startControlRef", "endControlProps", "endControlRef"]);
        return (React.createElement("div", __assign({}, rest, { className: (0, classnames_1.default)(className, classes.root), onFocus: (0, chain_1.chain)(rest.onFocus, this.handleFocus) }),
            React.createElement("div", __assign({}, containerProps, { ref: (0, set_ref_1.chainRefs)(containerRef, this.containerRef), onScroll: (0, chain_1.chain)(containerProps.onScroll, this.handleScroll), className: (0, classnames_1.default)(containerProps.className, classes.container) }), children),
            React.createElement("div", __assign({}, startControlProps, { ref: (0, set_ref_1.chainRefs)(startControlRef, this.startControlRef), onMouseEnter: (0, chain_1.chain)(startControlProps.onMouseEnter, this.handleStartScrollElementMouseEnter), onMouseLeave: (0, chain_1.chain)(startControlProps.onMouseLeave, this.handleStartScrollElementMouseLeave), className: (0, classnames_1.default)(startControlProps.className, classes.startControl) }),
                React.createElement(ScrollDirectionIcon, { className: classes.startControlIcon })),
            React.createElement("div", __assign({}, endControlProps, { ref: (0, set_ref_1.chainRefs)(endControlRef, this.endControlRef), className: (0, classnames_1.default)(endControlProps.className, classes.endControl), onMouseEnter: (0, chain_1.chain)(endControlProps.onMouseEnter, this.handleEndControlMouseEnter), onMouseLeave: (0, chain_1.chain)(endControlProps.onMouseLeave, this.handleEndControlMouseLeave) }),
                React.createElement(ScrollDirectionIcon, { className: classes.endControlIcon }))));
    };
    return HiddenScrollbar;
}(React.Component));
exports.HiddenScrollbar = HiddenScrollbar;


/***/ }),

/***/ 3415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HiddenScrollbar = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var hidden_scrollbar_1 = __webpack_require__(3388);
Object.defineProperty(exports, "HiddenScrollbar", ({ enumerable: true, get: function () { return hidden_scrollbar_1.HiddenScrollbar; } }));


/***/ }),

/***/ 8257:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scrollIntoContainerView = void 0;
/**
 * Scrolls container to position when target component is visible.
 * It takes in account start and end absolute elements that could
 * overlap target element.
 */
function scrollIntoContainerView(args) {
    var target = args.target, container = args.container, startControl = args.startControl, endControl = args.endControl;
    var scrollTop = container.scrollTop;
    var startControlRect = startControl.getBoundingClientRect();
    var endControlRect = endControl.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var startControlVisible = startControlRect.height > 0;
    var endControlVisible = endControlRect.height > 0;
    if (startControlVisible && !target.previousElementSibling) {
        container.scrollTop = 0;
        return;
    }
    if (endControlVisible && !target.nextElementSibling) {
        container.scrollTop = container.scrollHeight - container.clientHeight;
        return;
    }
    if (startControlVisible && targetRect.top < startControlRect.bottom) {
        container.scrollTop = scrollTop + targetRect.top - startControlRect.bottom;
        return;
    }
    if (endControlRect.height && targetRect.bottom > endControlRect.top) {
        container.scrollTop = scrollTop + targetRect.bottom - endControlRect.top;
        return;
    }
}
exports.scrollIntoContainerView = scrollIntoContainerView;


/***/ }),

/***/ 228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Highlight = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var escape_reg_exp_1 = __webpack_require__(5125);
var DEFAULT_RENDER_HIGHLIGHTER = function (props) { return React.createElement("b", __assign({}, props)); };
/** Highlights words in children string */
var Highlight = function (props) {
    var _a = props.renderHighlighter, renderHighlighter = _a === void 0 ? DEFAULT_RENDER_HIGHLIGHTER : _a;
    var words = (typeof props.words === 'string' ? [props.words] : props.words)
        .map(function (word) { return word.trim(); })
        .filter(Boolean);
    // nothing to mark
    if (!words.length) {
        return React.createElement(React.Fragment, null, props.children);
    }
    var wordsReg = new RegExp("(".concat(words.map(escape_reg_exp_1.escapeRegExp).join('|'), ")"), 'ig');
    var parts = props.children.split(wordsReg);
    return (React.createElement(React.Fragment, null, parts.map(function (part, index) {
        var matchedWord = words.find(function (word) { return word.toLocaleLowerCase() === part.toLocaleLowerCase(); });
        if (matchedWord) {
            return renderHighlighter({ key: index, children: part });
        }
        return part;
    })));
};
exports.Highlight = Highlight;


/***/ }),

/***/ 4953:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Highlight = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var highlight_1 = __webpack_require__(228);
Object.defineProperty(exports, "Highlight", ({ enumerable: true, get: function () { return highlight_1.Highlight; } }));


/***/ }),

/***/ 3738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(2286));
/**
 * Component adds common styles for `SVG` icons.
 * Should not be used standalone; only for defining certain icons.
 *
 * Use global classNames to colorize SVG icons (`.gs-svg-icon-fill`, `.gs-svg-icon-stroke`).
 * CSS Modules does not provide handy way to redefine CSS properties by context.
 * So this global classes are added.
 *
 * Add `.gs-svg-icon-fill` to any SVG element in your icon to change `fill` color
 * or `.gs-svg-icon-stroke` to change `stroke` color.
 *
 * ```ts
 * const MyIcon = createIcon(<svg><path className="gs-svg-icon-fill" /></svg>);
 * ```
 *
 * ```css
 * .my-icon :global(.gs-svg-icon-fill) {
 *   fill: red;
 * }
 * ```
 */
function createIcon(icon) {
    return /** @class */ (function (_super) {
        __extends(Icon, _super);
        function Icon() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Icon.prototype.render = function () {
            var element = typeof icon === 'function' ? icon(this.props) : icon;
            if (!element) {
                return null;
            }
            var className = element.props.className;
            return React.cloneElement(element, __assign(__assign({ 'data-qa': 'icon', 
                // prevent IE11 to focus SVG
                focusable: 'true' }, this.props), { className: (0, classnames_1.default)(className, this.props.className, styles.root) }));
        };
        return Icon;
    }(React.PureComponent));
}
exports.createIcon = createIcon;


/***/ }),

/***/ 6185:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var icon_1 = __webpack_require__(3738);
Object.defineProperty(exports, "createIcon", ({ enumerable: true, get: function () { return icon_1.createIcon; } }));


/***/ }),

/***/ 4741:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Input = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var input_1 = __webpack_require__(8793);
Object.defineProperty(exports, "Input", ({ enumerable: true, get: function () { return input_1.Input; } }));


/***/ }),

/***/ 2603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InputClearButton = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var clear_icon_1 = __webpack_require__(5516);
var button_1 = __webpack_require__(8329);
var fade_1 = __webpack_require__(5848);
/** Fadable button with clear icon that is used in input field */
var InputClearButton = function (props) {
    var show = props.show, rest = __rest(props, ["show"]);
    var _a = React.useState(true), isClearButtonExited = _a[0], setClearButtonExited = _a[1];
    return show || !isClearButtonExited ? (React.createElement(fade_1.Fade, { in: show, appear: true, onEnter: function () {
            setClearButtonExited(false);
        }, onExited: function () {
            setClearButtonExited(true);
        } },
        React.createElement(button_1.Button, __assign({ "data-qa": "input-clear-button", size: "tiny", ghost: true, component: "button", rounded: true, icon: React.createElement(clear_icon_1.ClearIcon, null), inverted: false }, rest)))) : null;
};
exports.InputClearButton = InputClearButton;


/***/ }),

/***/ 8237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InputSpinner = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var fade_1 = __webpack_require__(5848);
var spinner_1 = __webpack_require__(731);
var SPINNER_SIZE = 16;
/** Fadable spinner that is used in input field when loading */
var InputSpinner = function (props) {
    var show = props.show, rest = __rest(props, ["show"]);
    var _a = React.useState(true), isSpinnerExited = _a[0], setSpinnerExited = _a[1];
    return show || !isSpinnerExited ? (React.createElement(fade_1.Fade, { in: show, appear: true, onEnter: function () {
            setSpinnerExited(false);
        }, onExited: function () {
            setSpinnerExited(true);
        } },
        React.createElement("div", __assign({ "data-qa": "input-spinner" }, rest),
            React.createElement(spinner_1.Spinner, { size: SPINNER_SIZE })))) : null;
};
exports.InputSpinner = InputSpinner;


/***/ }),

/***/ 8793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Input = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var set_ref_1 = __webpack_require__(2403);
var styles_1 = __webpack_require__(598);
var use_input_invalidity_1 = __webpack_require__(5830);
var field_1 = __webpack_require__(3874);
var input_clear_button_1 = __webpack_require__(2603);
var input_spinner_1 = __webpack_require__(8237);
var styles = __importStar(__webpack_require__(3831));
/**
 * Base input field is used for data that could be entered into field within keyboard
 * like `text`, `email`, `password` etc.
 *
 * This component is stateless.
 */
function Input(props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), className = _b.className, style = _b.style, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave, onFocus = _b.onFocus, onBlur = _b.onBlur, invalid = _b.invalid, loading = _b.loading, clearable = _b.clearable, classes = _b.classes, onClearButtonClick = _b.onClearButtonClick, otherInputProps = _b.inputProps, _c = _b.rootProps, otherFieldProps = _c === void 0 ? {} : _c, prepend = _b.prepend, _d = _b.prependCellProps, prependCellProps = _d === void 0 ? {} : _d, append = _b.append, _e = _b.appendCellProps, appendCellProps = _e === void 0 ? {} : _e, _f = _b.inputCellProps, inputCellProps = _f === void 0 ? {} : _f, _g = _b.helpersProps, helpersProps = _g === void 0 ? {} : _g, onValueChange = _b.onValueChange, clearButtonProps = _b.clearButtonProps, spinnerProps = _b.spinnerProps, fullWidth = _b.fullWidth, innerInputRef = _b.inputRef, rest = __rest(_b, ["className", "style", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "invalid", "loading", "clearable", "classes", "onClearButtonClick", "inputProps", "rootProps", "prepend", "prependCellProps", "append", "appendCellProps", "inputCellProps", "helpersProps", "onValueChange", "clearButtonProps", "spinnerProps", "fullWidth", "inputRef"]);
    var _h = otherFieldProps.tabIndex, fieldTabIndex = _h === void 0 ? -1 : _h, fieldProps = __rest(otherFieldProps, ["tabIndex"]);
    var inputProps = __assign(__assign({}, rest), otherInputProps);
    var inputRef = React.useRef(null);
    // add input paddings for placing helpers elements like loader or clear button
    var withHelpers = typeof loading === 'boolean' || clearable;
    // simulate :focus-within css selector because of IE11
    var _j = React.useState(false), focused = _j[0], setFocused = _j[1];
    // use native input attribute to highlight invalid field with css
    var invalidState = (0, use_input_invalidity_1.useInputInvalidity)(inputRef, invalid);
    // simulate native html label element behaviour to prevent flickering
    // focused styles while clicking outside input but into field element
    var handleFieldFocus = function (event) {
        if (event.target === event.currentTarget && inputRef.current) {
            inputRef.current.focus();
        }
        setFocused(true);
    };
    var handleFieldBlur = function () {
        setFocused(false);
    };
    // https://github.com/facebook/react/issues/9142
    React.useEffect(function () {
        if (props.disabled) {
            setFocused(false);
        }
    }, [props.disabled]);
    var handleInputChange = (0, chain_1.chain)(inputProps.onChange, onValueChange &&
        (function (event) {
            if (onValueChange) {
                onValueChange(event.target.value);
            }
        }));
    var handleClearButtonClick = function () {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    return (React.createElement(field_1.Field, __assign({ "data-qa": "input-field", tabIndex: !inputProps.disabled ? fieldTabIndex : undefined, className: (0, classnames_1.default)(className, classes.root), style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: (0, chain_1.chain)(handleFieldFocus, onFocus), onBlur: (0, chain_1.chain)(handleFieldBlur, onBlur), focused: focused, invalid: invalidState, disabled: inputProps.disabled, fullWidth: fullWidth }, fieldProps),
        prepend ? (React.createElement("div", __assign({}, prependCellProps, { className: (0, classnames_1.default)(prependCellProps.className, classes.prependCell) }), prepend)) : null,
        React.createElement("div", __assign({}, inputCellProps, { className: (0, classnames_1.default)(inputCellProps.className, classes.inputCell) }),
            React.createElement("input", __assign({ "data-qa": "input", ref: (0, set_ref_1.chainRefs)(innerInputRef, inputRef) }, inputProps, { className: (0, classnames_1.default)(classes.input, inputProps.className, (_a = {},
                    _a[classes.withHelpers] = withHelpers,
                    _a)), onChange: handleInputChange })),
            withHelpers ? (React.createElement("div", __assign({}, helpersProps, { className: (0, classnames_1.default)(helpersProps.className, classes.helpers) }),
                React.createElement(input_spinner_1.InputSpinner, __assign({}, spinnerProps, { show: loading, className: classes.spinner })),
                React.createElement(input_clear_button_1.InputClearButton, __assign({}, clearButtonProps, { show: clearable &&
                        !inputProps.disabled &&
                        !inputProps.readOnly &&
                        !loading, onClick: (0, chain_1.chain)(onClearButtonClick, handleClearButtonClick), className: classes.clearButton })))) : null),
        append ? (React.createElement("div", __assign({}, appendCellProps, { className: (0, classnames_1.default)(appendCellProps.className, classes.appendCell) }), append)) : null));
}
exports.Input = Input;


/***/ }),

/***/ 9699:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InteractiveElement = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var interactive_element_1 = __webpack_require__(7590);
Object.defineProperty(exports, "InteractiveElement", ({ enumerable: true, get: function () { return interactive_element_1.InteractiveElement; } }));


/***/ }),

/***/ 7590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InteractiveElement = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/* eslint-disable react/prop-types */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var styles = __importStar(__webpack_require__(2066));
/**
 * Internal component that simulates native button behavior.
 * It is used for placing button elements into other "button" elements.
 */
exports.InteractiveElement = React.forwardRef(function InteractiveElement(props, ref) {
    var _a = React.useState({ active: false }), state = _a[0], setState = _a[1];
    var _b = props.as, Component = _b === void 0 ? typeof props.href === 'string' ? 'a' : 'div' : _b, activeClassName = props.activeClassName, disabled = props.disabled, _c = props.inclusiveDisabled, inclusiveDisabled = _c === void 0 ? false : _c, disableListeners = props.disableListeners, _d = props.tabIndex, tabIndex = _d === void 0 ? 0 : _d, _e = props.type, type = _e === void 0 ? 'button' : _e, rest = __rest(props, ["as", "activeClassName", "disabled", "inclusiveDisabled", "disableListeners", "tabIndex", "type"]);
    var handleClick = function (event) {
        var _a;
        setState({ active: false });
        if (inclusiveDisabled) {
            event.preventDefault();
            return;
        }
        if (!disabled) {
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
        }
    };
    var handleKeyDown = function (event) {
        if (event.target === event.currentTarget && event.key === ' ') {
            event.preventDefault();
            setState({ active: true });
        }
    };
    var handleKeyUp = function (event) {
        var _a;
        if (event.target === event.currentTarget && event.key === ' ') {
            event.preventDefault();
            setState({ active: false });
            // keyboard accessibility for non interactive elements hack
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
        }
    };
    var buttonProps = {};
    var buttonLikeProps = {};
    if (Component === 'button') {
        buttonProps.disabled = disabled;
        buttonProps.type = type;
    }
    if (Component !== 'a' && Component !== 'button') {
        buttonLikeProps.onClick = handleClick;
        if (!disabled && !disableListeners) {
            buttonLikeProps.onKeyDown = (0, chain_1.chain)(props.onKeyDown, handleKeyDown);
            buttonLikeProps.onKeyUp = (0, chain_1.chain)(props.onKeyUp, handleKeyUp);
        }
    }
    return React.useMemo(function () { return (React.createElement(Component, __assign({}, rest, buttonProps, buttonLikeProps, { tabIndex: disabled ? -1 : tabIndex, className: (0, classnames_1.default)(rest.className, styles.root, state.active && activeClassName), ref: ref }))); }, [props, state.active]);
});


/***/ }),

/***/ 5545:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Link = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var link_1 = __webpack_require__(6591);
Object.defineProperty(exports, "Link", ({ enumerable: true, get: function () { return link_1.Link; } }));


/***/ }),

/***/ 6591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Link = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var dark_context_1 = __webpack_require__(3693);
var styles_1 = __webpack_require__(598);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(4026));
/**
 * Link component presents an styled anchor.
 */
var Link = function (props) {
    var _a;
    var invertedContext = React.useContext(dark_context_1.DarkContext);
    var _b = (0, styles_1.mergeClassesProps)(props, styles), _c = _b.variant, variant = _c === void 0 ? 'internal' : _c, disabled = _b.disabled, active = _b.active, classes = _b.classes, focus = _b.focus, _d = _b.inverted, inverted = _d === void 0 ? invertedContext : _d, children = _b.children, prepend = _b.prepend, append = _b.append, intent = _b.intent, _e = _b.labelProps, labelProps = _e === void 0 ? {} : _e, rest = __rest(_b, ["variant", "disabled", "active", "classes", "focus", "inverted", "children", "prepend", "append", "intent", "labelProps"]);
    var tabIndex = rest.tabIndex, href = rest.href, onClick = rest.onClick;
    if (disabled) {
        href = undefined;
        tabIndex = undefined;
        onClick = undefined;
    }
    return (React.createElement(typography_1.Typography, __assign({ "data-qa": "link", as: "a" }, rest, { href: href, tabIndex: tabIndex, box: props.ellipsis ? 'block' : 'inline', onClick: onClick, className: (0, classnames_1.default)(classes.root, rest.className, (_a = {},
            _a[classes.pseudo] = variant === 'pseudo',
            _a[classes.external] = variant === 'external',
            _a[classes.disabled] = disabled,
            _a[classes.active] = active,
            _a[classes.focus] = focus,
            _a[classes.inverted] = inverted,
            _a[classes.alarm] = intent === 'alarm',
            _a)) }),
        prepend,
        React.createElement("span", __assign({}, labelProps, { className: (0, classnames_1.default)(labelProps.className, classes.label) }), children),
        append));
};
exports.Link = Link;


/***/ }),

/***/ 5228:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListItem = exports.List = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var list_1 = __webpack_require__(9926);
Object.defineProperty(exports, "List", ({ enumerable: true, get: function () { return list_1.List; } }));
var list_item_1 = __webpack_require__(5386);
Object.defineProperty(exports, "ListItem", ({ enumerable: true, get: function () { return list_item_1.ListItem; } }));


/***/ }),

/***/ 5386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListItem = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var interactive_element_1 = __webpack_require__(9699);
var margin_box_context_1 = __webpack_require__(3998);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(7230));
/**
 * Single item of List component
 */
exports.ListItem = React.forwardRef(function ListItem(props, ref) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), Component = _b.as, classes = _b.classes, interactive = _b.interactive, prepend = _b.prepend, append = _b.append, subtitle = _b.subtitle, wrap = _b.wrap, active = _b.active, hovered = _b.hovered, focused = _b.focused, disabled = _b.disabled, _c = _b.inclusiveDisabled, inclusiveDisabled = _c === void 0 ? false : _c, className = _b.className, _d = _b.prependProps, prependProps = _d === void 0 ? {} : _d, _e = _b.appendProps, appendProps = _e === void 0 ? {} : _e, _f = _b.contentProps, contentProps = _f === void 0 ? {} : _f, _g = _b.titleProps, titleProps = _g === void 0 ? {} : _g, _h = _b.titleContentProps, titleContentProps = _h === void 0 ? {} : _h, _j = _b.subtitleProps, subtitleProps = _j === void 0 ? {} : _j, children = _b.children, rest = __rest(_b, ["as", "classes", "interactive", "prepend", "append", "subtitle", "wrap", "active", "hovered", "focused", "disabled", "inclusiveDisabled", "className", "prependProps", "appendProps", "contentProps", "titleProps", "titleContentProps", "subtitleProps", "children"]);
    var contained = React.useContext(margin_box_context_1.MarginBoxContext);
    var BaseComponent = typeof Component === 'undefined'
        ? typeof rest.href === 'undefined'
            ? 'li'
            : 'a'
        : Component;
    var RenderComponent = interactive ? interactive_element_1.InteractiveElement : BaseComponent;
    var renderComponentProps = interactive
        ? { as: BaseComponent, activeClassName: classes.active, inclusiveDisabled: inclusiveDisabled }
        : {};
    return (React.createElement(RenderComponent, __assign({ "data-qa": "list-item" }, rest, renderComponentProps, { disabled: disabled, className: (0, classnames_1.default)(className, classes.root, (_a = {},
            _a[classes.interactive] = interactive,
            _a[classes.focused] = focused,
            _a[classes.hovered] = hovered,
            _a[classes.disabled] = disabled,
            // FIXME: Prevent click if `interactive` and `inclusiveDisabled`
            // https://genestack.atlassian.net/browse/ODM-6993
            _a[classes.inclusiveDisabled] = inclusiveDisabled,
            _a[classes.active] = active,
            _a[classes.inPage] = contained === 'in-page',
            _a[classes.inDialog] = contained === 'in-dialog',
            _a)), ref: ref }),
        prepend ? (React.createElement("div", __assign({}, prependProps, { className: (0, classnames_1.default)(prependProps.className, classes.prepend) }), prepend)) : null,
        React.createElement("div", __assign({}, contentProps, { className: (0, classnames_1.default)(contentProps.className, classes.content) }),
            React.createElement("div", __assign({}, titleProps, { className: (0, classnames_1.default)(titleProps.className, classes.title) }),
                React.createElement(typography_1.Typography, __assign({ ellipsis: !wrap, as: "div" }, titleContentProps, { className: (0, classnames_1.default)(titleContentProps.className, classes.titleContent) }), children),
                append ? (React.createElement("div", __assign({}, appendProps, { className: (0, classnames_1.default)(appendProps.className, classes.append) }), append)) : null),
            subtitle ? (React.createElement(typography_1.Typography, __assign({ variant: "caption", intent: "quiet", as: "div" }, subtitleProps, { className: (0, classnames_1.default)(subtitleProps.className, classes.subtitle) }), subtitle)) : null)));
});


/***/ }),

/***/ 9926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.List = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles = __importStar(__webpack_require__(8944));
/**
 * Lists are a continuous group of text.
 * They are composed of items containing primary text and supplemental cells
 * which are represented by icons, radios, checkboxes or other text.
 */
var List = function (props) {
    var _a = props.as, Component = _a === void 0 ? 'ul' : _a, className = props.className, rest = __rest(props, ["as", "className"]);
    return React.createElement(Component, __assign({ "data-qa": "list" }, rest, { className: (0, classnames_1.default)(className, styles.root) }));
};
exports.List = List;


/***/ }),

/***/ 3358:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MarginBoxFullWidth = exports.MarginBox = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var margin_box_1 = __webpack_require__(2098);
Object.defineProperty(exports, "MarginBox", ({ enumerable: true, get: function () { return margin_box_1.MarginBox; } }));
var margin_box_full_width_1 = __webpack_require__(5209);
Object.defineProperty(exports, "MarginBoxFullWidth", ({ enumerable: true, get: function () { return margin_box_full_width_1.MarginBoxFullWidth; } }));


/***/ }),

/***/ 3998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MarginBoxContext = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/**
 * Context for MarginBox elements.
 * It is used for setting left and right paddings
 * by elements that are contained in certain MarginBoxes.
 */
exports.MarginBoxContext = React.createContext('in-page');


/***/ }),

/***/ 5209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MarginBoxFullWidth = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var margin_box_context_1 = __webpack_require__(3998);
var styles = __importStar(__webpack_require__(1207));
/**
 * Component that remove side paddings from MarginBox.
 * Should not be used directly.
 * If you want to remove margins from some container use specific
 * as `PageFullWidth`, `DialogFullWidth`, `DrawerFullWidth`, etc.
 */
var MarginBoxFullWidth = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), _c = _b.as, Component = _c === void 0 ? 'div' : _c, classes = _b.classes, rest = __rest(_b, ["as", "classes"]);
    var contained = React.useContext(margin_box_context_1.MarginBoxContext);
    return (React.createElement(Component, __assign({}, rest, { className: (0, classnames_1.default)(rest.className, (_a = {},
            _a[classes.inPage] = contained === 'in-page',
            _a[classes.inDialog] = contained === 'in-dialog',
            _a)) })));
};
exports.MarginBoxFullWidth = MarginBoxFullWidth;


/***/ }),

/***/ 2098:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MarginBox = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var divider_1 = __webpack_require__(1840);
var margin_box_context_1 = __webpack_require__(3998);
var styles = __importStar(__webpack_require__(2290));
var DEFAULT_DIVIDER_GAP = 4;
/**
 * Component that adds common margins and paddings to container.
 * Should not be used directly.
 * If you want to add margins to some container use specific
 * as `PageContent`, `DialogBody`, etc.
 */
var MarginBox = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), _c = _b.as, Component = _c === void 0 ? 'div' : _c, _d = _b.contained, contained = _d === void 0 ? 'in-page' : _d, children = _b.children, _e = _b.startDividerProps, startDividerProps = _e === void 0 ? {} : _e, noStartDivider = _b.noStartDivider, _f = _b.endDividerProps, endDividerProps = _f === void 0 ? {} : _f, noEndDivider = _b.noEndDivider, classes = _b.classes, rest = __rest(_b, ["as", "contained", "children", "startDividerProps", "noStartDivider", "endDividerProps", "noEndDivider", "classes"]);
    return (React.createElement(margin_box_context_1.MarginBoxContext.Provider, { value: contained },
        React.createElement(Component, __assign({ "data-qa": "margin-box" }, rest, { className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
                _a[classes.inPage] = contained === 'in-page',
                _a[classes.inDialog] = contained === 'in-dialog',
                _a)) }),
            !noStartDivider ? (React.createElement(divider_1.Divider, __assign({ variant: "transparent", startGap: 0, endGap: DEFAULT_DIVIDER_GAP }, startDividerProps, { className: (0, classnames_1.default)(startDividerProps.className, classes.divider) }))) : null,
            children,
            !noEndDivider ? (React.createElement(divider_1.Divider, __assign({ variant: "transparent", startGap: DEFAULT_DIVIDER_GAP, endGap: 0 }, endDividerProps, { className: (0, classnames_1.default)(endDividerProps.className, classes.divider) }))) : null)));
};
exports.MarginBox = MarginBox;


/***/ }),

/***/ 8177:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuHandler = exports.MenuCaption = exports.MenuHandler = exports.SubMenu = exports.MenuItem = exports.Menu = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var menu_1 = __webpack_require__(108);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return menu_1.Menu; } }));
var menu_item_1 = __webpack_require__(4724);
Object.defineProperty(exports, "MenuItem", ({ enumerable: true, get: function () { return menu_item_1.MenuItem; } }));
var sub_menu_1 = __webpack_require__(5247);
Object.defineProperty(exports, "SubMenu", ({ enumerable: true, get: function () { return sub_menu_1.SubMenu; } }));
var menu_handler_1 = __webpack_require__(5529);
Object.defineProperty(exports, "MenuHandler", ({ enumerable: true, get: function () { return menu_handler_1.MenuHandler; } }));
var menu_caption_1 = __webpack_require__(7796);
Object.defineProperty(exports, "MenuCaption", ({ enumerable: true, get: function () { return menu_caption_1.MenuCaption; } }));
var use_menu_handler_1 = __webpack_require__(1642);
Object.defineProperty(exports, "useMenuHandler", ({ enumerable: true, get: function () { return use_menu_handler_1.useMenuHandler; } }));


/***/ }),

/***/ 7796:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuCaption = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var list_1 = __webpack_require__(5228);
var styles = __importStar(__webpack_require__(5580));
/** Caption that is used as menu item */
var MenuCaption = function (props) { return (React.createElement(list_1.ListItem, __assign({ "data-qa": "menu-caption" }, props, { className: (0, classnames_1.default)(props.className, styles.root) }))); };
exports.MenuCaption = MenuCaption;


/***/ }),

/***/ 415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuContext = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/** Menu Context */
exports.MenuContext = React.createContext(null);


/***/ }),

/***/ 5529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuHandler = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var root_ref_1 = __webpack_require__(5424);
var use_menu_handler_1 = __webpack_require__(1642);
/**
 * UI Kit provides common menu handler that manages menu open state.
 * It opens menu by children click event and closes menu on a item click
 * that does not have subMenu.
 */
exports.MenuHandler = React.forwardRef(function MenuHandlerRef(props, ref) {
    var childRef = React.useRef(null);
    var menuHandler = (0, use_menu_handler_1.useMenuHandler)({
        disableListeners: props.disableListeners,
        referenceElement: childRef.current
    });
    React.useImperativeHandle(ref, function () { return ({
        open: menuHandler.open,
        close: menuHandler.close
    }); }, []);
    var renderChild = function () {
        var child = typeof props.children === 'function'
            ? props.children({ open: menuHandler.isOpen })
            : props.children;
        return React.cloneElement(child, menuHandler.getReferenceProps(child.props));
    };
    var renderMenu = function () {
        var menu = menuHandler.isOpen
            ? typeof props.menu === 'function'
                ? props.menu()
                : props.menu
            : null;
        return menu ? React.cloneElement(menu, menuHandler.getMenuProps(menu.props)) : null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(root_ref_1.RootRef, { rootRef: childRef }, renderChild()),
        renderMenu()));
});


/***/ }),

/***/ 4724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuItem = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var contains_1 = __importDefault(__webpack_require__(424));
var React = __importStar(__webpack_require__(6689));
var keyboard_arrow_right_icon_1 = __webpack_require__(1140);
var chain_1 = __webpack_require__(9416);
var debounce_1 = __webpack_require__(1467);
var focusable_elements_1 = __webpack_require__(8717);
var set_ref_1 = __webpack_require__(2403);
var styles_1 = __webpack_require__(598);
var focus_trap_1 = __webpack_require__(7071);
var list_1 = __webpack_require__(5228);
var root_ref_1 = __webpack_require__(5424);
var menu_context_1 = __webpack_require__(415);
var styles = __importStar(__webpack_require__(1262));
var menu_popover_1 = __webpack_require__(3435);
var OPEN_TIMEOUT = 200;
var CLOSE_TIMEOUT = 150;
var selectFocusDirection = function (event) {
    if (event.key === 'ArrowDown') {
        return 'next';
    }
    if (event.key === 'ArrowUp') {
        return 'prev';
    }
    return null;
};
/**
 * MenuItem is a ListItem that is used in any Menu elements.
 *
 * It has three cells:
 *   - left icon cell, that could be omitted,
 *   - main content cell, that could have any React.Elements.
 *   - right icon cell, that is shown when menu item has `subMenu`.
 */
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemRef = React.createRef();
        _this.subMenuPaperRef = React.createRef();
        _this.state = {
            item: null,
            container: null,
            highlighted: false
        };
        _this.openSubMenu = function (callback) {
            var item = _this.itemRef.current;
            if (!item) {
                return;
            }
            var container = menu_popover_1.MenuPopover.getClosestMenuContainer(item);
            _this.setState({ item: item, container: container, highlighted: true }, callback);
        };
        _this.closeSubMenu = function (callback) {
            var state = {
                item: null,
                container: null,
                highlighted: false
            };
            _this.setState(state, callback);
        };
        _this.openSubMenuDebounced = (0, debounce_1.debounce)(_this.openSubMenu, OPEN_TIMEOUT);
        _this.closeSubMenuDebounced = (0, debounce_1.debounce)(_this.closeSubMenu, CLOSE_TIMEOUT);
        _this.handleWindowMouseMove = function (event) {
            _this.exitKeyboardMode();
            var target = event.target;
            var item = _this.itemRef.current;
            if (target instanceof Element && item && (0, contains_1.default)(item, target)) {
                item.focus();
                _this.openSubMenuImmediately();
            }
        };
        _this.handleKeyDown = function (event) {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                _this.enterKeyboardMode();
                _this.openSubMenuImmediately(function () {
                    var subMenuPaper = _this.subMenuPaperRef.current;
                    var subMenuItem = subMenuPaper && (0, focusable_elements_1.getFirstReachableElement)(subMenuPaper);
                    if (subMenuItem) {
                        subMenuItem.focus();
                    }
                });
            }
            var item = _this.itemRef.current;
            var direction = selectFocusDirection(event);
            if (item && direction) {
                event.preventDefault();
                _this.enterKeyboardMode();
                _this.closeSubMenuImmediately();
                var reachableElements = item.parentElement && Array.from((0, focusable_elements_1.getReachableElements)(item.parentElement));
                var nextItem = reachableElements && (0, focusable_elements_1.getSiblingElement)(reachableElements, item, direction);
                if (nextItem) {
                    nextItem.focus();
                }
            }
        };
        _this.handleSubMenuKeyDown = function (event) {
            var item = _this.itemRef.current;
            if (event.key === 'ArrowLeft' && item) {
                event.preventDefault();
                event.stopPropagation();
                _this.closeSubMenuImmediately();
                item.focus();
            }
        };
        /**
         * We focus any item under the cursor for following comfortable navigation
         * through keyboard.
         */
        _this.handleMouseEnter = function () {
            var item = _this.itemRef.current;
            if (item instanceof HTMLElement && document.activeElement !== item) {
                item.focus();
            }
            _this.scheduleSubMenuOpen();
        };
        _this.handleMouseLeave = function () {
            _this.scheduleSubMenuClose();
        };
        _this.handleSubMenuEnter = function () {
            _this.scheduleSubMenuOpen();
        };
        _this.handleSubMenuLeave = function () {
            _this.scheduleSubMenuClose();
        };
        _this.handleSubMenuFocus = function () {
            _this.setState({ highlighted: true });
            _this.scheduleSubMenuOpen();
        };
        _this.handleSubMenuBlur = function () {
            _this.scheduleSubMenuClose();
        };
        _this.handleFocus = function () {
            _this.setState({ highlighted: true });
        };
        _this.handleBlur = function () {
            _this.setState({ highlighted: false });
        };
        _this.createClickHandler = function (menuContext) { return function (event) {
            if (menuContext) {
                menuContext.onItemSelect(_this, event);
            }
        }; };
        return _this;
    }
    MenuItem.prototype.componentWillUnmount = function () {
        this.closeSubMenuDebounced.cancel();
        this.openSubMenuDebounced.cancel();
        this.exitKeyboardMode();
    };
    MenuItem.prototype.scheduleSubMenuOpen = function () {
        this.closeSubMenuDebounced.cancel();
        if (this.openSubMenuDebounced.active) {
            return;
        }
        this.openSubMenuDebounced();
    };
    MenuItem.prototype.scheduleSubMenuClose = function () {
        this.openSubMenuDebounced.cancel();
        this.closeSubMenuDebounced();
    };
    MenuItem.prototype.closeSubMenuImmediately = function () {
        this.openSubMenuDebounced.cancel();
        this.closeSubMenuDebounced.cancel();
        this.closeSubMenu();
    };
    MenuItem.prototype.openSubMenuImmediately = function (callback) {
        this.openSubMenuDebounced.cancel();
        this.closeSubMenuDebounced.cancel();
        this.openSubMenu(callback);
    };
    MenuItem.prototype.enterKeyboardMode = function () {
        window.addEventListener('mousemove', this.handleWindowMouseMove);
    };
    MenuItem.prototype.exitKeyboardMode = function () {
        window.removeEventListener('mousemove', this.handleWindowMouseMove);
    };
    MenuItem.prototype.render = function () {
        var _this = this;
        var _a = (0, styles_1.mergeClassesProps)(this.props, styles), classes = _a.classes, className = _a.className, prepend = _a.prepend, append = _a.append, subMenu = _a.subMenu, value = _a.value, _b = _a.subMenuPopoverProps, subMenuPopoverProps = _b === void 0 ? {} : _b, _c = _a.prependProps, prependProps = _c === void 0 ? {} : _c, _d = _a.appendProps, appendProps = _d === void 0 ? {} : _d, subMenuArrowIconProps = _a.subMenuArrowIconProps, _e = _a.titleProps, titleProps = _e === void 0 ? {} : _e, rest = __rest(_a, ["classes", "className", "prepend", "append", "subMenu", "value", "subMenuPopoverProps", "prependProps", "appendProps", "subMenuArrowIconProps", "titleProps"]);
        var _f = this.state, container = _f.container, item = _f.item;
        var subMenuPopover = subMenu && item && container && (!rest.disabled || !rest.inclusiveDisabled) ? (React.createElement(menu_popover_1.MenuPopover, __assign({}, subMenuPopoverProps, { open: true, portalContainer: container, referenceElement: item, disableTransition: true, placement: "right-start", rootRef: (0, set_ref_1.chainRefs)(subMenuPopoverProps.rootRef, this.subMenuPaperRef), onKeyDown: (0, chain_1.chain)(subMenuPopoverProps.onKeyDown, this.handleSubMenuKeyDown), onBlur: (0, chain_1.chain)(subMenuPopoverProps.onBlur, this.handleSubMenuBlur), onFocus: (0, chain_1.chain)(subMenuPopoverProps.onFocus, this.handleSubMenuFocus), onMouseEnter: (0, chain_1.chain)(subMenuPopoverProps.onMouseEnter, this.handleSubMenuEnter), onMouseLeave: (0, chain_1.chain)(subMenuPopoverProps.onMouseLeave, this.handleSubMenuLeave), className: classes.subMenu }),
            React.createElement(focus_trap_1.FocusTrap, null, typeof subMenu === 'function' ? subMenu() : subMenu))) : null;
        return (React.createElement(menu_context_1.MenuContext.Consumer, null, function (menuContext) { return (React.createElement(React.Fragment, null,
            React.createElement(root_ref_1.RootRef, { rootRef: _this.itemRef },
                React.createElement(list_1.ListItem, __assign({ "data-qa": "menu-item" }, rest, { interactive: true, focused: _this.state.highlighted, className: (0, classnames_1.default)(className, classes.root), prependProps: __assign(__assign({}, prependProps), { className: (0, classnames_1.default)(prependProps.className, classes.prepend) }), prepend: React.createElement(React.Fragment, null, prepend), appendProps: __assign(__assign({}, appendProps), { className: (0, classnames_1.default)(appendProps.className, classes.append) }), titleProps: titleProps, append: append || subMenu ? (React.createElement(React.Fragment, null,
                        append,
                        subMenu ? (React.createElement(keyboard_arrow_right_icon_1.KeyboardArrowRightIcon, __assign({}, subMenuArrowIconProps))) : null)) : null, onClick: (0, chain_1.chain)(rest.onClick, _this.createClickHandler(menuContext)), onFocus: (0, chain_1.chain)(rest.onFocus, _this.handleFocus), onBlur: (0, chain_1.chain)(rest.onBlur, _this.handleBlur), onKeyDown: (0, chain_1.chain)(rest.onKeyDown, _this.handleKeyDown), onMouseEnter: (0, chain_1.chain)(rest.onMouseEnter, _this.handleMouseEnter), onMouseLeave: (0, chain_1.chain)(rest.onMouseLeave, _this.handleMouseLeave) }))),
            subMenuPopover)); }));
    };
    return MenuItem;
}(React.PureComponent));
exports.MenuItem = MenuItem;


/***/ }),

/***/ 3435:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuPopover = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var closest_1 = __importDefault(__webpack_require__(8865));
var React = __importStar(__webpack_require__(6689));
var hidden_scrollbar_1 = __webpack_require__(3415);
var popover_1 = __webpack_require__(6627);
var styles = __importStar(__webpack_require__(9125));
/**
 * This data attribute is used to find closest menu container.
 * Menu items are placed in container with `overflow: hidden` and
 * we can not place sub menus near the items. So we find closest
 * container through this attribute and create portal in it.
 */
var MENU_POPOVER_DATA_ATTRIBUTE = 'data-menu-popover';
var modifiers = [
    {
        name: 'preventOverflow',
        options: {
            altAxis: true
        }
    }
];
var popperElementProps = (_a = {},
    _a[MENU_POPOVER_DATA_ATTRIBUTE.toString()] = 'true',
    _a);
/** Shortcut to Popover that is used in menu  */
var MenuPopover = /** @class */ (function (_super) {
    __extends(MenuPopover, _super);
    function MenuPopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuPopover.getClosestMenuContainer = function (element) {
        return (0, closest_1.default)(element, "[".concat(MENU_POPOVER_DATA_ATTRIBUTE, "]"), document.body);
    };
    MenuPopover.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, hiddenScrollbarProps = _a.hiddenScrollbarProps, rest = __rest(_a, ["className", "children", "hiddenScrollbarProps"]);
        return (React.createElement(popover_1.Popover, __assign({ roundCorners: true }, rest, { className: (0, classnames_1.default)(className, styles.root), modifiers: modifiers, popperElementProps: popperElementProps }),
            React.createElement(hidden_scrollbar_1.HiddenScrollbar, __assign({}, hiddenScrollbarProps), children)));
    };
    return MenuPopover;
}(React.Component));
exports.MenuPopover = MenuPopover;


/***/ }),

/***/ 108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Menu = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var focusable_elements_1 = __webpack_require__(8717);
var overlay_1 = __webpack_require__(5415);
var menu_context_1 = __webpack_require__(415);
var menu_popover_1 = __webpack_require__(3435);
var styles = __importStar(__webpack_require__(7505));
var sub_menu_1 = __webpack_require__(5247);
/**
 * A Menu displays a list of choices on a temporary surface.
 * They appear when users interact with a button, action, or other control.
 *
 * @example ./focus-to-input-after-menu-item-click.md
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuContext = {
            onItemSelect: function (item, event) {
                if (_this.props.onValueSelect) {
                    _this.props.onValueSelect(item.props.value, event, item);
                }
            }
        };
        _this.handleKeyDown = function (event) {
            if (event.target !== event.currentTarget) {
                return;
            }
            var itemToFocus = null;
            if (event.key === 'ArrowDown') {
                itemToFocus = (0, focusable_elements_1.getFirstReachableElement)(event.currentTarget);
            }
            if (event.key === 'ArrowUp') {
                itemToFocus = (0, focusable_elements_1.getLastReachableElement)(event.currentTarget);
            }
            if (itemToFocus) {
                event.preventDefault();
                itemToFocus.focus();
            }
        };
        return _this;
    }
    Menu.prototype.render = function () {
        var _a;
        var _b = this.props, open = _b.open, onClose = _b.onClose, onClosed = _b.onClosed, referenceElement = _b.referenceElement, _c = _b.placement, placement = _c === void 0 ? 'bottom-start' : _c, keepMounted = _b.keepMounted, _d = _b.popoverProps, popoverProps = _d === void 0 ? {} : _d, onValueSelect = _b.onValueSelect, _e = _b.overlayProps, overlayProps = _e === void 0 ? {} : _e, rest = __rest(_b, ["open", "onClose", "onClosed", "referenceElement", "placement", "keepMounted", "popoverProps", "onValueSelect", "overlayProps"]);
        return (React.createElement(menu_context_1.MenuContext.Provider, { value: this.menuContext },
            React.createElement(overlay_1.Overlay, __assign({}, overlayProps, { open: open, keepMounted: keepMounted, onClose: onClose, onClosed: onClosed, invisible: true }),
                React.createElement(menu_popover_1.MenuPopover, __assign({ "data-qa": "menu" }, popoverProps, { referenceElement: referenceElement, open: open, placement: placement, keepMounted: keepMounted, positionFixed: true, tabIndex: -1, onKeyDown: (0, chain_1.chain)(popoverProps.onKeyDown, this.handleKeyDown) }),
                    React.createElement(sub_menu_1.SubMenu, __assign({}, rest, { className: (0, classnames_1.default)(rest.className, (_a = {}, _a[styles.closed] = !open, _a)) }))))));
    };
    return Menu;
}(React.Component));
exports.Menu = Menu;


/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SubMenu = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var wrap_pure_component_1 = __webpack_require__(6378);
var list_1 = __webpack_require__(5228);
var styles = __importStar(__webpack_require__(7505));
/**
 * SubMenu is stylized `<List />` component.
 * It uses pure component to prevent unnecessary updates
 * caused by transition components.
 */
exports.SubMenu = (0, wrap_pure_component_1.wrapPureComponent)(function (props) {
    return (React.createElement(list_1.List, __assign({ "data-qa": "sub-menu" }, props, { className: (0, classnames_1.default)(props.className, styles.subMenu) })));
});


/***/ }),

/***/ 1642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuHandler = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
/** Hook for using menu  */
function useMenuHandler(props) {
    var _a = React.useState({
        open: false,
        exited: true
    }), state = _a[0], setState = _a[1];
    function open() {
        setState({ open: true, exited: false });
    }
    function close() {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { open: false })); });
    }
    var handleMenuValueSelect = function (value, event, menuItem) {
        if (!menuItem.props.subMenu) {
            close();
        }
    };
    var handleReferenceClick = function () {
        if (!props.disableListeners) {
            open();
        }
    };
    var handleReferenceKeyDown = function (event) {
        if (!props.disableListeners && event.key === 'ArrowDown') {
            event.preventDefault();
            open();
        }
    };
    var handleMenuClose = function () {
        close();
    };
    var handleMenuClosed = function () {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { exited: true })); });
    };
    var getMenuProps = function (menuProps) {
        if (menuProps === void 0) { menuProps = {}; }
        return (__assign(__assign({ open: state.open, referenceElement: props.referenceElement }, menuProps), { onClose: (0, chain_1.chain)(menuProps.onClose, handleMenuClose), onClosed: (0, chain_1.chain)(menuProps.onClosed, handleMenuClosed), onValueSelect: (0, chain_1.chain)(menuProps.onValueSelect, handleMenuValueSelect) }));
    };
    var getReferenceProps = function (referenceProps) {
        if (referenceProps === void 0) { referenceProps = {}; }
        return (__assign(__assign({}, referenceProps), { onClick: (0, chain_1.chain)(referenceProps.onClick, handleReferenceClick), onKeyDown: (0, chain_1.chain)(referenceProps.onKeyDown, handleReferenceKeyDown) }));
    };
    return {
        isOpen: state.open || !state.exited,
        open: open,
        close: close,
        getMenuProps: getMenuProps,
        getReferenceProps: getReferenceProps
    };
}
exports.useMenuHandler = useMenuHandler;


/***/ }),

/***/ 7536:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Notification = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var notification_1 = __webpack_require__(1626);
Object.defineProperty(exports, "Notification", ({ enumerable: true, get: function () { return notification_1.Notification; } }));


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Notification = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var cross_icon_1 = __webpack_require__(1433);
var chain_1 = __webpack_require__(9416);
var dark_context_1 = __webpack_require__(3693);
var styles_1 = __webpack_require__(598);
var button_1 = __webpack_require__(8329);
var circular_countdown_1 = __webpack_require__(1122);
var divider_1 = __webpack_require__(1840);
var paper_1 = __webpack_require__(6764);
var styles = __importStar(__webpack_require__(3870));
var DEFAULT_AUTO_CLOSE_DURATION = 6000;
/**
 * A notifications are used to inform user about application state changes,
 * status update or error. A brief feedback on actions that an app
 * has performed or performing now. It should be structured as short,
 * succinct messages and could provide optional action.
 */
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCloseButtonClick = function () {
            if (_this.props.onClose) {
                _this.props.onClose('close-button-click');
            }
        };
        _this.handleCountdownComplete = function () {
            if (_this.props.onClose) {
                _this.props.onClose('countdown-timeout');
            }
        };
        return _this;
    }
    Notification.prototype.render = function () {
        var _a = (0, styles_1.mergeClassesProps)(this.props, styles), _b = _a.closeButtonProps, closeButtonProps = _b === void 0 ? {} : _b, _c = _a.countdownDuration, countdownDuration = _c === void 0 ? DEFAULT_AUTO_CLOSE_DURATION : _c, onClose = _a.onClose, classes = _a.classes, children = _a.children, _d = _a.countdown, countdown = _d === void 0 ? 'active' : _d, rest = __rest(_a, ["closeButtonProps", "countdownDuration", "onClose", "classes", "children", "countdown"]);
        var closeButton = (React.createElement(button_1.Button, __assign({}, closeButtonProps, { ghost: true, rounded: true, wrap: true, size: "small", component: "button", className: (0, classnames_1.default)(closeButtonProps.className, classes.closeButton), onClick: (0, chain_1.chain)(closeButtonProps.onClick, this.handleCloseButtonClick) }),
            React.createElement(cross_icon_1.CrossIcon, null),
            countdown !== 'none' ? (React.createElement(circular_countdown_1.CircularCountdown, { in: countdown === 'active', className: styles.circularProgress, onComplete: this.handleCountdownComplete, duration: countdownDuration, transitionProps: { appear: true } })) : null));
        return (React.createElement(dark_context_1.DarkContext.Provider, { value: true },
            React.createElement(paper_1.Paper, __assign({ "data-qa": "notification" }, rest, { className: (0, classnames_1.default)(rest.className, classes.root) }),
                React.createElement(divider_1.Divider, { variant: "transparent", startGap: 0, endGap: 2 }),
                children,
                closeButton,
                React.createElement(divider_1.Divider, { variant: "transparent", startGap: 2, endGap: 0 }))));
    };
    return Notification;
}(React.Component));
exports.Notification = Notification;


/***/ }),

/***/ 5415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Overlay = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var overlay_1 = __webpack_require__(2826);
Object.defineProperty(exports, "Overlay", ({ enumerable: true, get: function () { return overlay_1.Overlay; } }));


/***/ }),

/***/ 6777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OverlayManager = exports.FIXED_BLOCKS_CLASS_NAME = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var scrollbarSize_1 = __importDefault(__webpack_require__(632));
var react_dom_1 = __importDefault(__webpack_require__(6405));
var focusable_elements_1 = __webpack_require__(8717);
var has_vertical_scrollbar_1 = __webpack_require__(98);
/** ClassName to find all fixed element on the page */
exports.FIXED_BLOCKS_CLASS_NAME = 'gs-fixed';
function createHiddenFocusButton() {
    var button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.style.opacity = '0';
    button.style.position = 'fixed';
    return button;
}
var getPaddingRight = function (element) {
    return parseInt(window.getComputedStyle(element).paddingRight || '0', 10);
};
var remove = function (element) {
    return element.parentElement && element.parentElement.removeChild(element);
};
/**
 * Object that knows about opened overlays (dialogs, popovers) on the page.
 * Any Overlay is modal that blocks page content and scroll.
 *
 * OverlayManager removes scrollbar from container when any overlay is opened.
 * Also it adds paddings to fixed elements to prevent it chattering.
 *
 * Also to prevent scrolling below the overlays when user changes focus
 * from browser address (aka. URL) bar `OverlayManager` adds two fixed
 * buttons at the top and at the bottom of body element. So when user focuses
 * to the page these buttons are always in viewport and scroll is not affected.
 *
 * At the moment we should use a singleton of this class.
 */
var OverlayManager = /** @class */ (function () {
    function OverlayManager(container) {
        var _this = this;
        this.overlays = [];
        this.containerState = null;
        this.handleStartButtonFocus = function () {
            var overlay = _this.getLastOverlayNode();
            var element = overlay && (0, focusable_elements_1.getFirstReachableElement)(overlay);
            if (element) {
                element.focus();
            }
        };
        this.handleEndButtonFocus = function () {
            var overlay = _this.getLastOverlayNode();
            var element = overlay && (0, focusable_elements_1.getLastReachableElement)(overlay);
            if (element) {
                element.focus();
            }
        };
        this.container = container;
    }
    OverlayManager.prototype.applyContainerStyles = function () {
        var container = this.container;
        if (this.containerState) {
            return;
        }
        var startFocusButton = createHiddenFocusButton();
        startFocusButton.addEventListener('focus', this.handleStartButtonFocus);
        var endFocusButton = createHiddenFocusButton();
        endFocusButton.addEventListener('focus', this.handleEndButtonFocus);
        document.body.appendChild(endFocusButton);
        document.body.insertBefore(startFocusButton, document.body.firstChild);
        var fixedBlocksPaddingsRight = new Map();
        this.containerState = {
            containerOverflow: container.style.overflow,
            containerPaddingRight: container.style.paddingRight,
            startFocusButton: startFocusButton,
            endFocusButton: endFocusButton,
            fixedBlocksPaddingsRight: fixedBlocksPaddingsRight
        };
        var containerOverflow = 'hidden';
        var containerPaddingRight = '0px';
        var appliedFixedBlocksPaddings = new Map();
        if ((0, has_vertical_scrollbar_1.hasVerticalScrollbar)(container)) {
            var size_1 = (0, scrollbarSize_1.default)();
            containerPaddingRight = "".concat(getPaddingRight(container) + size_1, "px");
            Array.from(document.querySelectorAll(".".concat(exports.FIXED_BLOCKS_CLASS_NAME))).forEach(function (fixedElement) {
                appliedFixedBlocksPaddings.set(fixedElement, "".concat(getPaddingRight(fixedElement) + size_1, "px"));
            });
        }
        container.style.overflow = containerOverflow;
        container.style.paddingRight = containerPaddingRight;
        Array.from(appliedFixedBlocksPaddings).forEach(function (_a) {
            var fixedElement = _a[0], paddingRight = _a[1];
            fixedBlocksPaddingsRight.set(fixedElement, fixedElement.style.paddingRight);
            fixedElement.style.paddingRight = paddingRight;
        });
    };
    OverlayManager.prototype.resetContainerStyles = function () {
        var _a = this, container = _a.container, containerState = _a.containerState;
        if (!containerState) {
            return;
        }
        container.style.overflow = containerState.containerOverflow;
        container.style.paddingRight = containerState.containerPaddingRight;
        containerState.startFocusButton.removeEventListener('focus', this.handleStartButtonFocus);
        remove(containerState.startFocusButton);
        containerState.endFocusButton.removeEventListener('focus', this.handleEndButtonFocus);
        remove(containerState.endFocusButton);
        Array.from(containerState.fixedBlocksPaddingsRight).forEach(function (_a) {
            var fixedElement = _a[0], paddingRight = _a[1];
            fixedElement.style.paddingRight = paddingRight;
        });
        this.containerState = null;
    };
    OverlayManager.prototype.getLastOverlayNode = function () {
        var lastOverlay = this.overlays[this.overlays.length - 1];
        if (lastOverlay) {
            // eslint-disable-next-line react/no-find-dom-node
            var overlay = react_dom_1.default.findDOMNode(lastOverlay);
            if (overlay instanceof HTMLElement) {
                return overlay;
            }
        }
    };
    OverlayManager.prototype.isTopOverlay = function (overlay) {
        var index = this.overlays.findIndex(function (item) { return item === overlay; });
        if (index === -1) {
            return null;
        }
        return index + 1 === this.overlays.length;
    };
    OverlayManager.prototype.mount = function (overlay) {
        if (this.overlays.includes(overlay)) {
            return;
        }
        this.overlays.push(overlay);
        this.applyContainerStyles();
    };
    OverlayManager.prototype.unmount = function (overlay) {
        if (!this.overlays.includes(overlay)) {
            return;
        }
        this.overlays.splice(this.overlays.indexOf(overlay), 1);
        if (!this.overlays.length) {
            this.resetContainerStyles();
        }
    };
    OverlayManager.prototype.destroy = function () {
        this.resetContainerStyles();
    };
    return OverlayManager;
}());
exports.OverlayManager = OverlayManager;


/***/ }),

/***/ 2826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Overlay = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var ReactDOM = __importStar(__webpack_require__(6405));
var chain_1 = __webpack_require__(9416);
var backdrop_1 = __webpack_require__(3597);
var focus_trap_1 = __webpack_require__(7071);
var root_ref_1 = __webpack_require__(5424);
var overlay_manager_1 = __webpack_require__(6777);
var styles = __importStar(__webpack_require__(2457));
var container = document.body;
var manager = new overlay_manager_1.OverlayManager(container);
/**
 * Overlay component is a modal element that blocks any content on the page.
 * The component could be closed:
 *   - with click on `<Backdrop />`
 *   - with `Escape` keydown
 */
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childRef = React.createRef();
        _this.state = {
            exited: true
        };
        _this.handleBackdropClick = function (event) {
            var _a = _this.props, onClose = _a.onClose, disableClickListener = _a.disableClickListener;
            if (disableClickListener) {
                return;
            }
            if (onClose) {
                onClose('backdrop-click', event);
            }
        };
        _this.handleBackdropExited = function () {
            _this.close();
            _this.setState({ exited: true });
        };
        _this.handleKeyDown = function (event) {
            var _a = _this.props, disableEscListener = _a.disableEscListener, onClose = _a.onClose;
            if (disableEscListener || !manager.isTopOverlay(_this)) {
                return;
            }
            if (event.key === 'Escape' && !event.defaultPrevented && onClose) {
                event.preventDefault();
                onClose('escape-keydown', event);
            }
        };
        return _this;
    }
    Overlay.getDerivedStateFromProps = function (props, state) {
        if (props.open) {
            return {
                exited: false
            };
        }
        return state;
    };
    Overlay.prototype.componentDidMount = function () {
        if (this.props.open) {
            this.open();
        }
    };
    Overlay.prototype.componentDidUpdate = function (props) {
        if (this.props.open && !props.open) {
            this.open();
        }
    };
    Overlay.prototype.componentWillUnmount = function () {
        manager.unmount(this);
    };
    Overlay.prototype.open = function () {
        manager.mount(this);
        // Revert scroll position when focused element triggers scroll
        // changes into scrollable overlay.
        // May be it is better to move scroll container to overlay.
        if (this.childRef.current) {
            this.childRef.current.scrollTop = 0;
        }
    };
    Overlay.prototype.close = function () {
        manager.unmount(this);
        if (this.props.onClosed) {
            this.props.onClosed();
        }
    };
    Overlay.prototype.render = function () {
        var _a;
        var _b = this.props, open = _b.open, keepMounted = _b.keepMounted, onClose = _b.onClose, onClosed = _b.onClosed, disableClickListener = _b.disableClickListener, disableEscListener = _b.disableEscListener, invisible = _b.invisible, _c = _b.backdropProps, backdropProps = _c === void 0 ? {} : _c, children = _b.children, className = _b.className, rootRef = _b.rootRef, rest = __rest(_b, ["open", "keepMounted", "onClose", "onClosed", "disableClickListener", "disableEscListener", "invisible", "backdropProps", "children", "className", "rootRef"]);
        var exited = this.state.exited;
        if (!keepMounted && !open && exited) {
            return null;
        }
        return ReactDOM.createPortal(React.createElement("div", __assign({}, rest, { ref: rootRef, className: (0, classnames_1.default)(className, (_a = {},
                _a[styles.invisible] = !open && exited,
                _a), styles.root), onKeyDown: (0, chain_1.chain)(rest.onKeyDown, this.handleKeyDown) }),
            React.createElement(backdrop_1.Backdrop, __assign({}, backdropProps, { invisible: invisible, open: open, onExited: (0, chain_1.chain)(backdropProps.onExited, this.handleBackdropExited), onClick: (0, chain_1.chain)(backdropProps.onClick, this.handleBackdropClick) })),
            children ? (React.createElement(focus_trap_1.FocusTrap, { focusOnMount: true },
                React.createElement(root_ref_1.RootRef, { rootRef: this.childRef }, children))) : null), container);
    };
    return Overlay;
}(React.Component));
exports.Overlay = Overlay;


/***/ }),

/***/ 3790:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageFullWidth = exports.PageContent = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var page_content_1 = __webpack_require__(2);
Object.defineProperty(exports, "PageContent", ({ enumerable: true, get: function () { return page_content_1.PageContent; } }));
var page_full_width_1 = __webpack_require__(3649);
Object.defineProperty(exports, "PageFullWidth", ({ enumerable: true, get: function () { return page_full_width_1.PageFullWidth; } }));


/***/ }),

/***/ 2:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageContent = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var margin_box_1 = __webpack_require__(3358);
/**
 * Shortcut to MarginBox for adding common paddings to the main page container
 */
var PageContent = function (props) { return React.createElement(margin_box_1.MarginBox, __assign({ "data-qa": "page-content" }, props)); };
exports.PageContent = PageContent;


/***/ }),

/***/ 3649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageFullWidth = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var margin_box_1 = __webpack_require__(3358);
/**
 * Remove paddings from page content. Is used for Lists and Dividers in common.
 */
var PageFullWidth = function (props) { return React.createElement(margin_box_1.MarginBoxFullWidth, __assign({}, props)); };
exports.PageFullWidth = PageFullWidth;


/***/ }),

/***/ 9530:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Paginator = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var paginator_1 = __webpack_require__(4957);
Object.defineProperty(exports, "Paginator", ({ enumerable: true, get: function () { return paginator_1.Paginator; } }));


/***/ }),

/***/ 4957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Paginator = void 0;
/*
 * Copyright (c) 2011-2018 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var button_1 = __webpack_require__(8329);
var styles = __importStar(__webpack_require__(556));
var clickPrevious = function (_a) {
    var onChange = _a.onChange, offset = _a.offset, itemsPerPage = _a.itemsPerPage;
    return function () {
        return onChange(offset - itemsPerPage);
    };
};
var clickNext = function (_a) {
    var onChange = _a.onChange, offset = _a.offset, itemsPerPage = _a.itemsPerPage;
    return function () {
        return onChange(offset + itemsPerPage);
    };
};
/**
 * Paginator React component.
 */
var Paginator = function (props) {
    var offset = props.offset, itemsPerPage = props.itemsPerPage, itemsLength = props.itemsLength, className = props.className;
    var isFirstPage = offset === 0;
    var isLastPage = offset + itemsPerPage >= itemsLength;
    var firstShownItem = offset + 1;
    var lastShownItem = Math.min(offset + itemsPerPage, itemsLength);
    var paginatorFullClassName = (0, classnames_1.default)(styles.container, className);
    return (react_1.default.createElement("div", { "data-qa": "paginator", className: paginatorFullClassName },
        react_1.default.createElement("div", { className: styles.info },
            firstShownItem === lastShownItem
                ? lastShownItem
                : "".concat(firstShownItem, " \u2014 ").concat(lastShownItem),
            ' ',
            "of ",
            itemsLength),
        react_1.default.createElement(button_1.Button, { onClick: clickPrevious(props), disabled: isFirstPage, title: "Previous page", className: styles.button }, "\u25C0"),
        react_1.default.createElement(button_1.Button, { onClick: clickNext(props), disabled: isLastPage, title: "Next page", className: styles.button }, "\u25B6")));
};
exports.Paginator = Paginator;


/***/ }),

/***/ 6764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Paper = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var paper_1 = __webpack_require__(4777);
Object.defineProperty(exports, "Paper", ({ enumerable: true, get: function () { return paper_1.Paper; } }));


/***/ }),

/***/ 4777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Paper = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var dark_context_1 = __webpack_require__(3693);
var styles = __importStar(__webpack_require__(2074));
/**
 * Paper is a block with background and shadow.
 * Is used for overlay components.
 */
function Paper(props) {
    var _a;
    var _b = props.as, Component = _b === void 0 ? 'div' : _b, rootRef = props.rootRef, className = props.className, _c = props.inverted, inverted = _c === void 0 ? React.useContext(dark_context_1.DarkContext) : _c, rest = __rest(props, ["as", "rootRef", "className", "inverted"]);
    return (React.createElement(Component, __assign({ "data-qa": "paper" }, rest, { ref: rootRef, className: (0, classnames_1.default)(className, styles.root, (_a = {}, _a[styles.inverted] = inverted, _a)) })));
}
exports.Paper = Paper;


/***/ }),

/***/ 6627:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePopoverHandler = exports.PopoverHandler = exports.Popover = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var popover_1 = __webpack_require__(1556);
Object.defineProperty(exports, "Popover", ({ enumerable: true, get: function () { return popover_1.Popover; } }));
var popover_handler_1 = __webpack_require__(1258);
Object.defineProperty(exports, "PopoverHandler", ({ enumerable: true, get: function () { return popover_handler_1.PopoverHandler; } }));
var use_popover_handler_1 = __webpack_require__(9354);
Object.defineProperty(exports, "usePopoverHandler", ({ enumerable: true, get: function () { return use_popover_handler_1.usePopoverHandler; } }));


/***/ }),

/***/ 1403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PopoverGrow = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var grow_1 = __webpack_require__(7118);
var transformByPlacement = {
    top: 'bottom center',
    'top-start': 'bottom left',
    'top-end': 'bottom right',
    right: 'center left',
    'right-start': 'top left',
    'right-end': 'bottom left',
    bottom: 'top center',
    'bottom-start': 'top left',
    'bottom-end': 'top right',
    left: 'center right',
    'left-start': 'top right',
    'left-end': 'bottom right'
};
/** Internal Grow transition for popover. */
var PopoverGrow = function (props) {
    var disableTransition = props.disableTransition, children = props.children, placement = props.placement, open = props.open, rest = __rest(props, ["disableTransition", "children", "placement", "open"]);
    return disableTransition ? (children) : (React.createElement(grow_1.Grow, __assign({}, rest, { in: open, appear: true, transformOrigin: rest.transformOrigin ||
            (placement && transformByPlacement[placement]) ||
            'center center' }), children));
};
exports.PopoverGrow = PopoverGrow;


/***/ }),

/***/ 1258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PopoverHandler = void 0;
var React = __importStar(__webpack_require__(6689));
var popover_1 = __webpack_require__(1556);
var use_popover_handler_1 = __webpack_require__(9354);
/**
 * Popover handler.
 * It listens hover on the reference element and shows/hide content with customizable delay.
 */
function PopoverHandler(props) {
    var openDelay = props.openDelay, closeDelay = props.closeDelay, children = props.children, popoverContent = props.popoverContent, rest = __rest(props, ["openDelay", "closeDelay", "children", "popoverContent"]);
    var childRef = React.useRef(null);
    var popoverHandler = (0, use_popover_handler_1.usePopoverHandler)({
        referenceElement: childRef.current,
        openDelay: openDelay,
        closeDelay: closeDelay
    });
    var renderChild = function () {
        var child = children;
        return React.cloneElement(child, popoverHandler.getReferenceProps(child.props));
    };
    var renderContent = function () {
        var content = popoverContent;
        return React.cloneElement(content, popoverHandler.getPopoverContentProps(content.props));
    };
    return (React.createElement(React.Fragment, null,
        renderChild(),
        React.createElement(popover_1.Popover, __assign({ open: popoverHandler.isOpen, referenceElement: popoverHandler.referenceElement, placement: "left", positionFixed: true, portalContainer: document.body, modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true
                    }
                }
            ], roundCorners: true, withArrow: true }, rest), renderContent())));
}
exports.PopoverHandler = PopoverHandler;


/***/ }),

/***/ 1556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Popover = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var set_ref_1 = __webpack_require__(2403);
var styles_1 = __webpack_require__(598);
var icon_1 = __webpack_require__(6185);
var margin_box_context_1 = __webpack_require__(3998);
var paper_1 = __webpack_require__(6764);
var transition_popper_1 = __webpack_require__(1842);
var popover_grow_transition_1 = __webpack_require__(1403);
var styles = __importStar(__webpack_require__(3386));
var PopoverArrowIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 8 10", fill: "none" },
    React.createElement("path", { d: "M8 10L0 5l8-5v10z", fill: "rgba(255, 255, 255, 1)" }),
    React.createElement("path", { d: "M8 10L0 5l8-5", stroke: "rgba(211, 211, 211, 1)" })));
/**
 * Popover is a element that is shown near reference element
 * to show some context information or actions.
 * It is base component to create Menus, Dropdowns and other.
 *
 * It uses [react-popper](https://github.com/FezVrasta/react-popper)
 * under the hood.
 */
var Popover = function (props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), classes = _a.classes, withArrow = _a.withArrow, roundCorners = _a.roundCorners, popperRef = _a.popperRef, _b = _a.containerProps, containerProps = _b === void 0 ? {} : _b, containerRef = _a.containerRef, _c = _a.transitionProps, transitionProps = _c === void 0 ? {} : _c, _d = _a.popperElementProps, popperElementProps = _d === void 0 ? {} : _d, children = _a.children, rest = __rest(_a, ["classes", "withArrow", "roundCorners", "popperRef", "containerProps", "containerRef", "transitionProps", "popperElementProps", "children"]);
    return (React.createElement(transition_popper_1.TransitionPopper, __assign({}, rest, { ref: popperRef }), function (_a) {
        var _b, _c, _d;
        var ref = _a.ref, style = _a.style, arrowProps = _a.arrowProps, placement = _a.placement, targetProps = _a.targetProps, onTransitionExited = _a.onTransitionExited;
        return (React.createElement("div", __assign({}, containerProps, { ref: (0, set_ref_1.chainRefs)(ref, containerRef), style: __assign(__assign({}, containerProps.style), style), className: (0, classnames_1.default)(containerProps.className, (_b = {},
                _b[classes.withArrow] = withArrow,
                _b)), "data-placement": placement }),
            React.createElement(popover_grow_transition_1.PopoverGrow, __assign({}, transitionProps, { appear: true, disableTransition: rest.disableTransition, placement: placement, open: !!placement && rest.open, onExited: (0, chain_1.chain)(transitionProps.onExited, onTransitionExited) }),
                React.createElement("div", __assign({}, popperElementProps, { className: (0, classnames_1.default)(popperElementProps.className, classes.popper), "data-placement": placement }),
                    React.createElement(paper_1.Paper, __assign({ "data-qa": "popover" }, targetProps, { "data-placement": placement, className: (0, classnames_1.default)(targetProps.className, classes.paper, (_c = {},
                            _c[classes.roundCorners] = roundCorners,
                            _c)) }),
                        React.createElement(margin_box_context_1.MarginBoxContext.Provider, { value: "in-page" }, children)),
                    React.createElement("div", __assign({}, arrowProps, { "data-placement": placement, className: (0, classnames_1.default)(classes.arrow, (_d = {},
                            _d[classes.arrowHidden] = !withArrow,
                            _d)) }),
                        React.createElement(PopoverArrowIcon, { "data-placement": placement, className: classes.arrowIcon }))))));
    }));
};
exports.Popover = Popover;


/***/ }),

/***/ 9354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePopoverHandler = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var contains_1 = __importDefault(__webpack_require__(424));
var React = __importStar(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var defaultOpenDelay = 400;
var defaultCloseDelay = 200;
/** Hook to using popover */
function usePopoverHandler(props) {
    var _a, _b;
    var _c = React.useState(props.referenceElement), referenceElement = _c[0], setReferenceElement = _c[1];
    var _d = props.openDelay, openDelay = _d === void 0 ? defaultOpenDelay : _d, _e = props.closeDelay, closeDelay = _e === void 0 ? defaultCloseDelay : _e;
    var _f = React.useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var handleOpen = function () {
        setIsOpen(true);
    };
    var openDebouncedRef = React.useRef((0, utils_1.debounce)(handleOpen, (_a = props.openDelay) !== null && _a !== void 0 ? _a : openDelay));
    function handleClose() {
        openDebouncedRef.current.cancel();
        setReferenceElement(null);
        setIsOpen(false);
    }
    var closeDebounceRef = React.useRef((0, utils_1.debounce)(handleClose, (_b = props.closeDelay) !== null && _b !== void 0 ? _b : closeDelay));
    var handleMouseEnter = function (e) {
        var target = e.currentTarget;
        setReferenceElement(target);
        openDebouncedRef.current();
    };
    var handleMouseLeave = function (e) {
        if (e.relatedTarget instanceof Element && (0, contains_1.default)(e.currentTarget, e.relatedTarget)) {
            return;
        }
        closeDebounceRef.current();
    };
    var handleContentMouseEnter = function () {
        closeDebounceRef.current.cancel();
    };
    var handleContentMouseLeave = function () {
        closeDebounceRef.current();
    };
    React.useEffect(function () {
        return function () {
            openDebouncedRef.current.cancel();
            closeDebounceRef.current.cancel();
        };
    }, []);
    var getPopoverContentProps = function (popoverContentProps) {
        if (popoverContentProps === void 0) { popoverContentProps = {}; }
        return (__assign(__assign({}, popoverContentProps), { 
            // open: isOpen,
            // referenceElement,
            onMouseEnter: (0, utils_1.chain)(popoverContentProps.onMouseEnter, handleContentMouseEnter), onMouseLeave: (0, utils_1.chain)(popoverContentProps.onMouseLeave, handleContentMouseLeave) }));
    };
    var getReferenceProps = function (referenceProps) {
        if (referenceProps === void 0) { referenceProps = {}; }
        return (__assign(__assign({}, referenceProps), { onMouseEnter: (0, utils_1.chain)(referenceProps.onMouseEnter, handleMouseEnter), onMouseLeave: (0, utils_1.chain)(referenceProps.onMouseLeave, handleMouseLeave) }));
    };
    return {
        isOpen: isOpen,
        getPopoverContentProps: getPopoverContentProps,
        getReferenceProps: getReferenceProps,
        referenceElement: referenceElement
    };
}
exports.usePopoverHandler = usePopoverHandler;


/***/ }),

/***/ 689:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Preloader = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var preloader_1 = __webpack_require__(308);
Object.defineProperty(exports, "Preloader", ({ enumerable: true, get: function () { return preloader_1.Preloader; } }));


/***/ }),

/***/ 308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Preloader = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var dark_context_1 = __webpack_require__(3693);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(3683));
var getIterator = function (array) {
    var _i, array_1, value;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (false) {}
                _i = 0, array_1 = array;
                _a.label = 1;
            case 1:
                if (!(_i < array_1.length)) return [3 /*break*/, 4];
                value = array_1[_i];
                return [4 /*yield*/, value];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
function reduceNumber(count, reducer, initialValue) {
    var value = initialValue;
    for (var i = 0; i < count; i += 1) {
        value = reducer(value, i);
    }
    return value;
}
var DEFAULT_CLASSES = [styles.width100, styles.width75, styles.width85];
/**
 * Component that renders preloader lines
 */
var Preloader = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 1 : _b, _c = _a.iterateClassnames, iterateClassnames = _c === void 0 ? DEFAULT_CLASSES : _c, _d = _a.show, show = _d === void 0 ? false : _d, _e = _a.wrapAll, wrapAll = _e === void 0 ? React.Fragment : _e, _f = _a.wrapEach, wrapEach = _f === void 0 ? React.Fragment : _f, children = _a.children, className = _a.className, inverted = _a.inverted, variant = _a.variant, box = _a.box;
    var classNameGenerator = getIterator(iterateClassnames);
    var ListWrapper = wrapAll;
    var ListItemWrapper = wrapEach;
    if (!show) {
        // Wrapping is required for consistency of returning value
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(ListWrapper, null, reduceNumber(count, function (preloaderLines, index) {
        var nextClassName = classNameGenerator.next().value;
        return __spreadArray(__spreadArray([], preloaderLines, true), [
            React.createElement(ListItemWrapper, { key: "".concat(nextClassName, "-").concat(index) },
                React.createElement(dark_context_1.DarkContext.Consumer, null, function (darkContext) {
                    var _a;
                    var backgroundInverted = typeof inverted === 'boolean'
                        ? inverted
                        : Boolean(darkContext);
                    return (React.createElement(typography_1.Typography, { variant: variant, box: box, className: (0, classnames_1.default)(styles.preloader, (_a = {},
                            _a[styles.backgroundRegular] = !backgroundInverted,
                            _a[styles.backgroundInverted] = backgroundInverted,
                            _a), nextClassName, className), inverted: inverted }));
                }))
        ], false);
    }, [])));
};
exports.Preloader = Preloader;


/***/ }),

/***/ 1636:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RootElement = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var root_element_1 = __webpack_require__(3972);
Object.defineProperty(exports, "RootElement", ({ enumerable: true, get: function () { return root_element_1.RootElement; } }));


/***/ }),

/***/ 3972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RootElement = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
__webpack_require__(7107);
var styles = __importStar(__webpack_require__(5287));
/**
 * Element that add base styles for proper components styling.
 * It is enough to wrap your application once at application entry point.
 * Remember that this component creates DOM element.
 */
var RootElement = function (props) {
    var _a = props.as, Component = _a === void 0 ? 'div' : _a, rest = __rest(props, ["as"]);
    return React.createElement(Component, __assign({}, rest, { className: (0, classnames_1.default)(rest.className, styles.root) }));
};
exports.RootElement = RootElement;


/***/ }),

/***/ 5424:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RootRef = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var root_ref_1 = __webpack_require__(3144);
Object.defineProperty(exports, "RootRef", ({ enumerable: true, get: function () { return root_ref_1.RootRef; } }));


/***/ }),

/***/ 3144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RootRef = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var ReactDOM = __importStar(__webpack_require__(6405));
var set_ref_1 = __webpack_require__(2403);
/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 */
var RootRef = /** @class */ (function (_super) {
    __extends(RootRef, _super);
    function RootRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = null;
        return _this;
    }
    RootRef.prototype.componentDidMount = function () {
        this.node = this.getHTMLNode();
        (0, set_ref_1.setRef)(this.props.rootRef, this.node);
    };
    RootRef.prototype.componentDidUpdate = function (prevProps) {
        var node = this.getHTMLNode();
        if (prevProps.rootRef !== this.props.rootRef || this.node !== node) {
            if (prevProps.rootRef !== this.props.rootRef) {
                (0, set_ref_1.setRef)(prevProps.rootRef, null);
            }
            this.node = node;
            (0, set_ref_1.setRef)(this.props.rootRef, this.node);
        }
    };
    RootRef.prototype.componentWillUnmount = function () {
        this.node = null;
        (0, set_ref_1.setRef)(this.props.rootRef, null);
    };
    RootRef.prototype.getHTMLNode = function () {
        // eslint-disable-next-line react/no-find-dom-node
        var node = ReactDOM.findDOMNode(this);
        return node instanceof HTMLElement ? node : null;
    };
    RootRef.prototype.render = function () {
        return this.props.children;
    };
    return RootRef;
}(React.Component));
exports.RootRef = RootRef;


/***/ }),

/***/ 8413:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScrollView = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var scroll_view_1 = __webpack_require__(6027);
Object.defineProperty(exports, "ScrollView", ({ enumerable: true, get: function () { return scroll_view_1.ScrollView; } }));


/***/ }),

/***/ 6027:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScrollView = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var simplebar_react_1 = __importDefault(__webpack_require__(4172));
__webpack_require__(1348);
var utils_1 = __webpack_require__(9502);
var styles = __importStar(__webpack_require__(749));
var simplebarOptions = {
    autoHide: false
};
/**
 * A wrapper component over [SimpleBar](https://github.com/Grsmto/simplebar/tree/master/packages/simplebar-react) that provides crossplatform experience for scrollable views.
 */
var ScrollView = function (_a) {
    var _b, _c;
    var className = _a.className, _d = _a.showScrollbars, showScrollbars = _d === void 0 ? 'auto' : _d, rest = __rest(_a, ["className", "showScrollbars"]);
    var inverted = React.useContext(utils_1.DarkContext);
    return (React.createElement(simplebar_react_1.default, __assign({}, rest, { className: (0, classnames_1.default)(styles.root, (_b = {}, _b[styles.inverted] = inverted, _b), (_c = {}, _c[styles.scrollbarsAlwaysShown] = showScrollbars === 'always', _c), className) }, simplebarOptions)));
};
exports.ScrollView = ScrollView;


/***/ }),

/***/ 9171:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSelectContext = exports.Option = exports.SelectEmitter = exports.OptionLabel = exports.Select = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var select_1 = __webpack_require__(2617);
Object.defineProperty(exports, "Select", ({ enumerable: true, get: function () { return select_1.Select; } }));
var option_label_1 = __webpack_require__(2242);
Object.defineProperty(exports, "OptionLabel", ({ enumerable: true, get: function () { return option_label_1.OptionLabel; } }));
var select_emitter_1 = __webpack_require__(1572);
Object.defineProperty(exports, "SelectEmitter", ({ enumerable: true, get: function () { return select_emitter_1.SelectEmitter; } }));
var option_1 = __webpack_require__(31);
Object.defineProperty(exports, "Option", ({ enumerable: true, get: function () { return option_1.Option; } }));
var select_context_1 = __webpack_require__(1993);
Object.defineProperty(exports, "useSelectContext", ({ enumerable: true, get: function () { return select_context_1.useSelectContext; } }));


/***/ }),

/***/ 2242:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OptionLabel = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var styles = __importStar(__webpack_require__(1649));
/** Option label (depends of SelectContext) */
exports.OptionLabel = react_1.default.forwardRef(function OptionLabelComponent(props, ref) {
    var _a = (0, utils_1.mergeClassesProps)(props, styles), _b = _a.component, Component = _b === void 0 ? 'span' : _b, className = _a.className, prepend = _a.prepend, _c = _a.prependProps, prependProps = _c === void 0 ? {} : _c, append = _a.append, _d = _a.appendProps, appendProps = _d === void 0 ? {} : _d, _e = _a.labelProps, labelProps = _e === void 0 ? {} : _e, classes = _a.classes, children = _a.children, rest = __rest(_a, ["component", "className", "prepend", "prependProps", "append", "appendProps", "labelProps", "classes", "children"]);
    return (react_1.default.createElement(Component, __assign({ className: (0, classnames_1.default)(classes.optionLabel, className), title: typeof children === 'string' ? children : undefined }, rest, { ref: ref }),
        prepend && (react_1.default.createElement("span", __assign({}, prependProps, { className: (0, classnames_1.default)(classes.info, prependProps.className) }), prepend)),
        children && (react_1.default.createElement("span", __assign({}, labelProps, { className: (0, classnames_1.default)(classes.label, labelProps.className) }), children)),
        append && (react_1.default.createElement("span", __assign({}, appendProps, { className: (0, classnames_1.default)(classes.info, appendProps.className) }), append))));
});


/***/ }),

/***/ 31:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Option = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var menu_1 = __webpack_require__(8177);
var styles = __importStar(__webpack_require__(5538));
var select_context_1 = __webpack_require__(1993);
/** Option component for Select */
function Option(_a) {
    var label = _a.label, restProps = __rest(_a, ["label"]);
    var native = (0, select_context_1.useSelectContext)().native;
    if (native) {
        var optionLabel = typeof label === 'string' ? label : undefined;
        return (react_1.default.createElement("option", __assign({ value: restProps.value, label: optionLabel }, restProps, { className: (0, classnames_1.default)(styles.root, restProps.className) }), restProps.children));
    }
    return react_1.default.createElement(menu_1.MenuItem, __assign({}, restProps));
}
exports.Option = Option;


/***/ }),

/***/ 1993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSelectContext = exports.SelectContext = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var react_1 = __importDefault(__webpack_require__(6689));
/** Select Context */
exports.SelectContext = react_1.default.createContext(null);
/** Select Context hook */
var useSelectContext = function () {
    var value = react_1.default.useContext(exports.SelectContext);
    if (!value) {
        throw new Error('Could not be used outside of SelectContextProvider');
    }
    return value;
};
exports.useSelectContext = useSelectContext;


/***/ }),

/***/ 1572:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SelectEmitter = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var icons_1 = __webpack_require__(883);
var button_base_1 = __webpack_require__(3592);
var option_label_1 = __webpack_require__(2242);
var styles = __importStar(__webpack_require__(1649));
/** Wrapper for select */
exports.SelectEmitter = react_1.default.forwardRef(function EmitterRef(props, ref) {
    var _a, _b;
    var className = props.className, label = props.label, isButton = props.isButton, placeholder = props.placeholder, intent = props.intent, size = props.size, invalid = props.invalid, children = props.children, arrowProps = props.arrowProps, restProps = __rest(props, ["className", "label", "isButton", "placeholder", "intent", "size", "invalid", "children", "arrowProps"]);
    var controlClassName = (0, classnames_1.default)(styles.root, (_a = {},
        _a[styles.accent] = intent === 'accent',
        _a[styles.ghost] = restProps.ghost,
        _a[styles.invalid] = invalid,
        _a[styles.disabled] = restProps.disabled,
        _a[styles.small] = size === 'small',
        _a), className);
    var arrowClassName = (0, classnames_1.default)(styles.arrow, (_b = {},
        _b[styles.small] = size === 'small',
        _b), arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.className);
    var buttonLabel = label !== null && label !== void 0 ? label : placeholder;
    var isInlineLabel = typeof buttonLabel === 'string' || typeof buttonLabel === 'number';
    return (react_1.default.createElement(button_base_1.ButtonBase, __assign({ "data-qa": "select" }, restProps, { ref: ref, className: controlClassName, intent: invalid ? 'alarm' : intent, component: isButton ? 'button' : 'div' }),
        isInlineLabel ? react_1.default.createElement(option_label_1.OptionLabel, null, buttonLabel) : buttonLabel,
        react_1.default.createElement(icons_1.ArrowBottomThinIcon, __assign({}, arrowProps, { className: arrowClassName })),
        children));
});


/***/ }),

/***/ 1241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SelectMenu = void 0;
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var menu_1 = __webpack_require__(8177);
var select_emitter_1 = __webpack_require__(1572);
/** Menu based select */
function SelectMenu(props) {
    var native = props.native, selectProps = props.selectProps, value = props.value, onValueChange = props.onValueChange, children = props.children, rest = __rest(props, ["native", "selectProps", "value", "onValueChange", "children"]);
    var emitterRef = react_1.default.useRef(null);
    var _a = react_1.default.useState(false), isMenuVisible = _a[0], setMenuVisibility = _a[1];
    var handleMenuOpen = function () {
        setMenuVisibility(true);
    };
    var handleMenuClose = function () {
        setMenuVisibility(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(select_emitter_1.SelectEmitter, __assign({}, rest, { isButton: true, onClick: (0, utils_1.chain)(handleMenuOpen, rest.onClick), ref: emitterRef })),
        react_1.default.createElement(utils_1.DarkContext.Provider, { value: false },
            react_1.default.createElement(menu_1.Menu, __assign({ "data-qa": "select-menu" }, selectProps, { open: isMenuVisible, referenceElement: emitterRef.current, onClose: (0, utils_1.chain)(handleMenuClose, selectProps === null || selectProps === void 0 ? void 0 : selectProps.onClose), onValueSelect: (0, utils_1.chain)(handleMenuClose, selectProps === null || selectProps === void 0 ? void 0 : selectProps.onValueSelect, onValueChange) }), children))));
}
exports.SelectMenu = SelectMenu;


/***/ }),

/***/ 2056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SelectNative = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var select_emitter_1 = __webpack_require__(1572);
var styles = __importStar(__webpack_require__(6452));
/** Native select */
function SelectNative(props) {
    var native = props.native, selectProps = props.selectProps, value = props.value, onValueChange = props.onValueChange, children = props.children, rest = __rest(props, ["native", "selectProps", "value", "onValueChange", "children"]);
    var selectRef = react_1.default.useRef(null);
    var handleValueChange = onValueChange &&
        (function (e) {
            onValueChange(e.target.value, e);
        });
    return (react_1.default.createElement(select_emitter_1.SelectEmitter, __assign({}, rest),
        react_1.default.createElement("select", __assign({}, selectProps, { value: value, className: (0, classnames_1.default)(styles.select, selectProps === null || selectProps === void 0 ? void 0 : selectProps.className), ref: (0, utils_1.chainRefs)(selectProps === null || selectProps === void 0 ? void 0 : selectProps.ref, selectRef), onChange: (0, utils_1.chain)(selectProps === null || selectProps === void 0 ? void 0 : selectProps.onChange, handleValueChange), disabled: rest.disabled }), children)));
}
exports.SelectNative = SelectNative;


/***/ }),

/***/ 2617:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Select = void 0;
var react_1 = __importDefault(__webpack_require__(6689));
var select_context_1 = __webpack_require__(1993);
var select_menu_1 = __webpack_require__(1241);
var select_native_1 = __webpack_require__(2056);
var utils_1 = __webpack_require__(1368);
/** Select wrapper */
function Select(props) {
    var label = (0, utils_1.getSelectLabel)(props.children, props.value);
    return (react_1.default.createElement(select_context_1.SelectContext.Provider, { value: props }, props.native ? (react_1.default.createElement(select_native_1.SelectNative, __assign({ label: label }, props))) : (react_1.default.createElement(select_menu_1.SelectMenu, __assign({ label: label }, props)))));
}
exports.Select = Select;


/***/ }),

/***/ 1368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSelectLabel = void 0;
var react_1 = __importDefault(__webpack_require__(6689));
var _1 = __webpack_require__(9171);
// FIXME use selectContext instead this after fixing Menu (Menu must support the "keepMounted" property)
/** finds Option, skips fragments and other react elements */
function findSelectedOption(value, children) {
    var selectedChild = null;
    for (var _i = 0, _a = react_1.default.Children.toArray(children); _i < _a.length; _i++) {
        var child = _a[_i];
        if (selectedChild) {
            return selectedChild;
        }
        if (!react_1.default.isValidElement(child)) {
            return null;
        }
        if ((child.type === _1.Option || child.type === 'option') && child.props.value === value) {
            return child;
        }
        selectedChild = findSelectedOption(value, child.props.children);
    }
    return selectedChild;
}
/** Get select label from Options */
var getSelectLabel = function (children, selectValue) {
    var _a;
    if (!selectValue) {
        return null;
    }
    var selectedOption = findSelectedOption(selectValue, children);
    if (!selectedOption) {
        return null;
    }
    var _b = selectedOption.props, label = _b.label, value = _b.value;
    return (_a = label !== null && label !== void 0 ? label : value) !== null && _a !== void 0 ? _a : null;
};
exports.getSelectLabel = getSelectLabel;


/***/ }),

/***/ 6337:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Shake = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var shake_1 = __webpack_require__(5057);
Object.defineProperty(exports, "Shake", ({ enumerable: true, get: function () { return shake_1.Shake; } }));


/***/ }),

/***/ 5057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Shake = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var CSSTransition_1 = __importDefault(__webpack_require__(1075));
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(9140));
var TRANSITION_TIMEOUT = {
    enter: 350,
    exit: 0
};
/**
 * Shake transition is used to shake elements.
 * Useful for indicating to user about wrong values of inputs or impossible actions.
 *
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 *
 * This transition does not have exit stage. So pass `onEntered` callback
 * to subscribe shake transition complete.
 */
var Shake = function (props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), className = _a.className, classes = _a.classes, rest = __rest(_a, ["className", "classes"]);
    var child = React.Children.only(props.children);
    return (React.createElement(CSSTransition_1.default, __assign({}, rest, { classNames: {
            enter: classes.enter,
            enterDone: classes.enterDone
        }, timeout: TRANSITION_TIMEOUT }), React.cloneElement(child, {
        className: (0, classnames_1.default)(className, child.props.className, classes.root)
    })));
};
exports.Shake = Shake;


/***/ }),

/***/ 6798:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Slide = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var slide_1 = __webpack_require__(5089);
Object.defineProperty(exports, "Slide", ({ enumerable: true, get: function () { return slide_1.Slide; } }));


/***/ }),

/***/ 5089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Slide = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var Transition_1 = __importDefault(__webpack_require__(660));
var chain_1 = __webpack_require__(9416);
var reflow_1 = __webpack_require__(6874);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(2628));
var DURATION_TIMEOUT = 300;
var FAST_DURATION_TIMEOUT = 160;
/**
 * Slide transition component is used for smoothed showing and hiding elements through moving.
 *
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Slide = /** @class */ (function (_super) {
    __extends(Slide, _super);
    function Slide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestId = null;
        _this.handleEnter = function (node) {
            var _a;
            var _b = (0, styles_1.mergeClassesProps)(_this.props, styles), classes = _b.classes, _c = _b.direction, direction = _c === void 0 ? 'left' : _c;
            node.classList.remove(classes.enter);
            node.classList.add((0, classnames_1.default)((_a = {},
                _a[classes.exitLeft] = direction === 'left',
                _a[classes.exitRight] = direction === 'right',
                _a[classes.exitTop] = direction === 'top',
                _a[classes.exitBottom] = direction === 'bottom',
                _a)));
            _this.requestAnimationFrame(function () {
                node.classList.remove(classes.exiting);
                node.classList.add(classes.entering);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.exitLeft);
                node.classList.remove(classes.exitRight);
                node.classList.remove(classes.exitTop);
                node.classList.remove(classes.exitBottom);
                node.classList.add(classes.enter);
            });
        };
        _this.handleExit = function (node) {
            var classes = (0, styles_1.mergeClassesProps)(_this.props, styles).classes;
            node.classList.remove(classes.exitLeft);
            node.classList.remove(classes.exitRight);
            node.classList.remove(classes.exitTop);
            node.classList.remove(classes.exitBottom);
            node.classList.add(classes.enter);
            _this.requestAnimationFrame(function () {
                var _a;
                var _b = _this.props.direction, direction = _b === void 0 ? 'left' : _b;
                node.classList.remove(classes.entering);
                node.classList.add(classes.exiting);
                (0, reflow_1.reflow)(node);
                node.classList.remove(classes.enter);
                node.classList.add((0, classnames_1.default)((_a = {},
                    _a[classes.exitLeft] = direction === 'left',
                    _a[classes.exitRight] = direction === 'right',
                    _a[classes.exitTop] = direction === 'top',
                    _a[classes.exitBottom] = direction === 'bottom',
                    _a)));
            });
        };
        return _this;
    }
    Slide.prototype.componentWillUnmount = function () {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
    };
    Slide.prototype.requestAnimationFrame = function (callback) {
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
        }
        this.requestId = requestAnimationFrame(callback);
    };
    Slide.prototype.render = function () {
        var _a;
        var _b = (0, styles_1.mergeClassesProps)(this.props, styles), className = _b.className, classes = _b.classes, children = _b.children, _c = _b.direction, direction = _c === void 0 ? 'left' : _c, fast = _b.fast, rest = __rest(_b, ["className", "classes", "children", "direction", "fast"]);
        var child = React.Children.only(children);
        return (React.createElement(Transition_1.default, __assign({}, rest, { timeout: fast ? FAST_DURATION_TIMEOUT : DURATION_TIMEOUT, onEnter: (0, chain_1.chain)(rest.onEnter, this.handleEnter), onExit: (0, chain_1.chain)(rest.onExit, this.handleExit) }), React.cloneElement(child, {
            className: (0, classnames_1.default)(className, child.props.className, (_a = {},
                _a[classes.enter] = rest.in,
                _a[classes.fast] = fast,
                _a[classes.exitLeft] = !rest.in && direction === 'left',
                _a[classes.exitRight] = !rest.in && direction === 'right',
                _a[classes.exitTop] = !rest.in && direction === 'top',
                _a[classes.exitBottom] = !rest.in && direction === 'bottom',
                _a))
        })));
    };
    return Slide;
}(React.Component));
exports.Slide = Slide;


/***/ }),

/***/ 731:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Spinner = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var spinner_1 = __webpack_require__(9193);
Object.defineProperty(exports, "Spinner", ({ enumerable: true, get: function () { return spinner_1.Spinner; } }));


/***/ }),

/***/ 9193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Spinner = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(6355));
var DEFAULT_SIZE = 16;
var getDefaultStokeWidth = function (_a) {
    var _b = _a.size, size = _b === void 0 ? DEFAULT_SIZE : _b;
    return size / 8;
};
/** Shows to user intermediate process */
var Spinner = function (props) {
    var _a = (0, styles_1.mergeClassesProps)(props, styles), _b = _a.size, size = _b === void 0 ? DEFAULT_SIZE : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? getDefaultStokeWidth(props) : _c, hideBackgroundCircle = _a.hideBackgroundCircle, _d = _a.circleProps, circleProps = _d === void 0 ? {} : _d, _e = _a.backgroundCircleProps, backgroundCircleProps = _e === void 0 ? {} : _e, classes = _a.classes, rest = __rest(_a, ["size", "strokeWidth", "hideBackgroundCircle", "circleProps", "backgroundCircleProps", "classes"]);
    var radius = (size - strokeWidth) / 2;
    var perimeter = radius * 2 * Math.PI;
    var center = size / 2;
    var sectorLength = perimeter / 10;
    return (React.createElement("svg", __assign({ "data-qa": "spinner", viewBox: "0 0 ".concat(size, " ").concat(size), style: { width: size, height: size } }, rest, { className: (0, classnames_1.default)(rest.className, classes.root) }),
        !hideBackgroundCircle ? (React.createElement("circle", __assign({ cx: center, cy: center, r: radius, fill: "none", strokeWidth: strokeWidth }, backgroundCircleProps, { className: (0, classnames_1.default)(backgroundCircleProps.className, classes.backgroundCircle) }))) : null,
        React.createElement("circle", __assign({ cx: center, cy: center, r: radius, fill: "none", strokeLinecap: "round", strokeWidth: strokeWidth, strokeDasharray: "".concat(sectorLength * 3, " ").concat(sectorLength * 2) }, circleProps, { className: (0, classnames_1.default)(circleProps.className, classes.circle) }))));
};
exports.Spinner = Spinner;


/***/ }),

/***/ 4472:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SuggestInputItem = exports.SuggestInput = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var suggest_input_1 = __webpack_require__(8119);
Object.defineProperty(exports, "SuggestInput", ({ enumerable: true, get: function () { return suggest_input_1.SuggestInput; } }));
var suggest_input_item_1 = __webpack_require__(907);
Object.defineProperty(exports, "SuggestInputItem", ({ enumerable: true, get: function () { return suggest_input_item_1.SuggestInputItem; } }));


/***/ }),

/***/ 907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SuggestInputItem = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var list_1 = __webpack_require__(5228);
/** Shortcut to `ListItem` with string value property for usage in `SuggestInput` */
var SuggestInputItem = function (props) {
    var value = props.value, rest = __rest(props, ["value"]);
    return React.createElement(list_1.ListItem, __assign({}, rest, { interactive: true }));
};
exports.SuggestInputItem = SuggestInputItem;


/***/ }),

/***/ 8119:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SuggestInput = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var downshift_1 = __importDefault(__webpack_require__(772));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var set_ref_1 = __webpack_require__(2403);
var use_controlled_prop_1 = __webpack_require__(7707);
var list_1 = __webpack_require__(5228);
var suggest_1 = __webpack_require__(9714);
var styles = __importStar(__webpack_require__(1559));
/**
 * Suggest component get their children with no knowledge of Downshift under the hood. To
 * achieve this abstraction, we clone those children and enrich them with props, provided
 * by Downshift.
 */
function getSuggestInputChildren(children, downshift) {
    var index = -1;
    return React.Children.map(children, function (child) {
        if (!React.isValidElement(child)) {
            return child;
        }
        var childValue = child.props.value;
        // do not allow a child without value to be selected
        if (typeof childValue !== 'string') {
            return child;
        }
        index += 1;
        // `downshift.getItemProps` uses `AllHTMLProps` that are conflict with `SuggestInputItemProps`
        // we should omit the next properties:
        // `as` for <link /> elements
        // `wrap` for `<textarea />` elements
        var itemProps = __assign(__assign({}, child.props), { focused: downshift.highlightedIndex === index });
        return React.cloneElement(child, __assign({}, downshift.getItemProps(__assign(__assign({}, itemProps), { index: index, item: childValue }))));
    });
}
/**
 * Binding Suggest implementation to
 * [downshift](https://github.com/downshift-js/downshift).
 *
 * It supports only string values.
 */
function SuggestInput(props) {
    var onComplete = props.onComplete, openOnFocus = props.openOnFocus, onOpenChange = props.onOpenChange, _a = props.listProps, listProps = _a === void 0 ? {} : _a, rest = __rest(props, ["onComplete", "openOnFocus", "onOpenChange", "listProps"]);
    var _b = (0, use_controlled_prop_1.useControlledProp)(rest.value, rest.defaultValue || '', rest.onValueChange), value = _b[0], onValueChange = _b[1];
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var skipClick = React.useRef(false);
    var firstMount = React.useRef(true);
    React.useEffect(function () {
        if (!firstMount.current && onOpenChange) {
            onOpenChange(isOpen);
        }
        firstMount.current = false;
    }, [isOpen]);
    var handleSelect = function (item) {
        if (!item) {
            return;
        }
        if (rest.value === undefined) {
            onValueChange(item);
        }
        if (onComplete) {
            onComplete(item);
        }
    };
    var handleStateChange = function (changes) {
        if (changes.isOpen !== undefined) {
            setIsOpen(changes.isOpen);
        }
    };
    var handleInputFocus = function () {
        if (openOnFocus) {
            skipClick.current = true;
            setIsOpen(true);
        }
    };
    var handleInputClick = function () {
        if (!skipClick.current) {
            if (isOpen) {
                setIsOpen(false);
            }
            else if (openOnFocus) {
                setIsOpen(true);
            }
        }
        skipClick.current = false;
    };
    return (React.createElement(downshift_1.default, { onSelect: handleSelect, isOpen: isOpen, onStateChange: handleStateChange }, function (downshift) {
        var _a, _b;
        var _c = downshift.getRootProps({ refKey: 'rootRef' }, { suppressRefError: true }), rootRef = _c.rootRef, rootProps = __rest(_c, ["rootRef"]);
        var inputProps = downshift.getInputProps(__assign(__assign({}, rest), { onFocus: (0, chain_1.chain)(rest.onFocus, handleInputFocus), onClick: (0, chain_1.chain)(rest.onClick, handleInputClick) }));
        var inputPopoverProps = inputProps.popoverProps || {};
        var children = isOpen
            ? getSuggestInputChildren(typeof rest.children === 'function'
                ? rest.children(value)
                : rest.children, downshift)
            : null;
        var menuProps = downshift.getMenuProps({ refKey: 'rootRef' }, { suppressRefError: true });
        var open = !!children;
        var popoverProps = __assign(__assign(__assign({}, inputPopoverProps), menuProps), { rootRef: (0, set_ref_1.chainRefs)((0, set_ref_1.chainRefs)(menuProps.rootRef, inputPopoverProps.rootRef), (_a = rest.popoverProps) === null || _a === void 0 ? void 0 : _a.rootRef), style: __assign(__assign({}, inputPopoverProps.style), { display: open ? 'block' : 'none' }) });
        // Downshift prevents default event behavior on Escape key down regardless the open state.
        // Ignore downshift keydown handler for properly work the suggest into dialogs.
        var handleInputKeyDown = function (event) {
            if (!open && event.key === 'Escape') {
                if (rest.onKeyDown) {
                    rest.onKeyDown(event);
                }
            }
            else {
                if (inputProps.onKeyDown) {
                    inputProps.onKeyDown(event);
                }
            }
        };
        return (React.createElement(suggest_1.Suggest, __assign({ "data-qa": "suggest-input" }, inputProps, { onKeyDown: handleInputKeyDown, value: value, onValueChange: onValueChange, rootProps: __assign(__assign(__assign({}, inputProps.rootProps), rootProps), { ref: (0, set_ref_1.chainRefs)(rootRef, (_b = inputProps.rootProps) === null || _b === void 0 ? void 0 : _b.ref) }), popoverProps: popoverProps, open: open }), open ? (React.createElement(list_1.List, __assign({ "data-qa": "suggest-input-list" }, listProps, { className: (0, classnames_1.default)(listProps.className, styles.list) }), children)) : null));
    }));
}
exports.SuggestInput = SuggestInput;


/***/ }),

/***/ 9714:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Suggest = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var suggest_1 = __webpack_require__(1632);
Object.defineProperty(exports, "Suggest", ({ enumerable: true, get: function () { return suggest_1.Suggest; } }));


/***/ }),

/***/ 1632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Suggest = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var set_ref_1 = __webpack_require__(2403);
var input_1 = __webpack_require__(4741);
var popover_1 = __webpack_require__(6627);
var styles = __importStar(__webpack_require__(1109));
function useElementWidth(element) {
    var _a = React.useState(null), width = _a[0], setWidth = _a[1];
    React.useEffect(function () {
        if (element) {
            var nextWidth = element.getBoundingClientRect().width;
            if (nextWidth !== width) {
                setWidth(nextWidth);
            }
        }
    });
    return width;
}
/**
 * Just a wrapper component over `Input` and `Popover` that takes the responsibility
 * over styles and transitions. It is useless in common cases without any control components
 * like [downshift](https://github.com/downshift-js/downshift).
 *
 * Wrap it with your controller or use some predefined components like `SuggestInput`.
 */
function Suggest(props) {
    var open = props.open, _a = props.rootProps, rootProps = _a === void 0 ? {} : _a, _b = props.popoverProps, popoverProps = _b === void 0 ? {} : _b, children = props.children, rest = __rest(props, ["open", "rootProps", "popoverProps", "children"]);
    var _c = popoverProps.containerProps, containerProps = _c === void 0 ? {} : _c;
    var inputRootRef = React.useRef(null);
    var inputRootWidth = useElementWidth(inputRootRef.current);
    var popperRef = React.useRef(null);
    React.useEffect(function () {
        if (popperRef.current) {
            popperRef.current.scheduleUpdate();
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(input_1.Input, __assign({ "data-qa": "suggest" }, rest, { rootProps: __assign(__assign({}, rootProps), { ref: (0, set_ref_1.chainRefs)(rootProps.ref, inputRootRef) }), className: (0, classnames_1.default)(rest.className, styles.root) })),
        React.createElement(popover_1.Popover, __assign({ "data-qa": "suggest-popover", placement: "bottom-start", roundCorners: true }, popoverProps, { popperRef: (0, set_ref_1.chainRefs)(popoverProps.popperRef, popperRef), open: open, referenceElement: inputRootRef.current, style: __assign(__assign({}, popoverProps.style), { minWidth: "".concat(inputRootWidth || 0, "px") }), className: (0, classnames_1.default)(popoverProps.className, styles.popover), containerProps: __assign(__assign({}, containerProps), { className: (0, classnames_1.default)(containerProps.className, styles.popoverContainer) }) }), children)));
}
exports.Suggest = Suggest;


/***/ }),

/***/ 6257:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Switch = void 0;
var switch_1 = __webpack_require__(3208);
Object.defineProperty(exports, "Switch", ({ enumerable: true, get: function () { return switch_1.Switch; } }));


/***/ }),

/***/ 3208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Switch = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var styles_1 = __webpack_require__(598);
var styles = __importStar(__webpack_require__(3855));
/** The input component which toggles the state of a single setting on or off */
var Switch = function (props) {
    var _a;
    var _b = (0, styles_1.mergeClassesProps)(props, styles), size = _b.size, classes = _b.classes, onCheckedChange = _b.onCheckedChange, _c = _b.inputProps, inputProps = _c === void 0 ? {} : _c, rootProps = _b.rootProps, _d = _b.handlerProps, handlerProps = _d === void 0 ? {} : _d, _e = _b.trackProps, trackProps = _e === void 0 ? {} : _e, rest = __rest(_b, ["size", "classes", "onCheckedChange", "inputProps", "rootProps", "handlerProps", "trackProps"]);
    var _f = React.useState(false), focused = _f[0], setFocused = _f[1];
    var handleFocus = function () {
        setFocused(true);
    };
    var handleBlur = function () {
        setFocused(false);
    };
    var handleInputChange = onCheckedChange &&
        (function (event) {
            if (onCheckedChange) {
                onCheckedChange(event.target.checked);
            }
        });
    return (React.createElement("div", __assign({ "data-qa": "switch" }, rootProps, { className: (0, classnames_1.default)(classes.root, rest.className, (_a = {},
            _a[classes.small] = size === 'small',
            _a[classes.disabled] = rest.disabled,
            _a[classes.focused] = focused,
            _a)) }),
        React.createElement("input", __assign({ type: "checkbox" }, rest, inputProps, { className: (0, classnames_1.default)(classes.input, inputProps.className), onChange: (0, chain_1.chain)(handleInputChange, rest.onChange), onFocus: (0, chain_1.chain)(handleFocus, rest.onFocus), onBlur: (0, chain_1.chain)(handleBlur, rest.onBlur) })),
        React.createElement("div", __assign({}, trackProps, { className: (0, classnames_1.default)(classes.track, trackProps.className) }),
            React.createElement("span", __assign({}, handlerProps, { className: (0, classnames_1.default)(classes.handler, handlerProps.className) })))));
};
exports.Switch = Switch;


/***/ }),

/***/ 9681:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Indicator = exports.Tab = void 0;
var tab_1 = __webpack_require__(5532);
Object.defineProperty(exports, "Tab", ({ enumerable: true, get: function () { return tab_1.Tab; } }));
var indicator_1 = __webpack_require__(2269);
Object.defineProperty(exports, "Indicator", ({ enumerable: true, get: function () { return indicator_1.Indicator; } }));


/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Indicator = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var styles = __importStar(__webpack_require__(1154));
/** Indicator component */
exports.Indicator = react_1.default.forwardRef(function IndicatorComponent(props, ref) {
    var _a;
    var _b = (0, utils_1.mergeClassesProps)(props, styles), className = _b.className, classes = _b.classes, _c = _b.component, Component = _c === void 0 ? 'span' : _c, placement = _b.placement, fullWidth = _b.fullWidth, active = _b.active, restProps = __rest(_b, ["className", "classes", "component", "placement", "fullWidth", "active"]);
    return (react_1.default.createElement(Component, __assign({ "data-qa": "indicator", className: (0, classnames_1.default)(classes.root, (_a = {},
            _a[classes.active] = active,
            _a[classes.fullWidth] = fullWidth,
            _a[classes.bottom] = placement === 'bottom',
            _a[classes.top] = placement === 'top',
            _a[classes.left] = placement === 'left',
            _a[classes.right] = placement === 'right',
            _a), className) }, restProps, { ref: ref })));
});


/***/ }),

/***/ 5532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tab = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var indicator_1 = __webpack_require__(2269);
var styles = __importStar(__webpack_require__(5055));
/**
 *  Tab control component
 * @example ./tab-combinations.md
 *
 */
exports.Tab = react_1.default.forwardRef(function TabComponent(props, ref) {
    var _a, _b;
    var _c = (0, utils_1.mergeClassesProps)(props, styles), className = _c.className, _d = _c.component, Component = _d === void 0 ? 'button' : _d, _e = _c.variant, variant = _e === void 0 ? 'ghost' : _e, _f = _c.size, size = _f === void 0 ? 'normal' : _f, hovered = _c.hovered, selected = _c.selected, _g = _c.bodyProps, bodyProps = _g === void 0 ? {} : _g, _h = _c.labelProps, labelProps = _h === void 0 ? {} : _h, prepend = _c.prepend, _j = _c.prependProps, prependProps = _j === void 0 ? {} : _j, append = _c.append, _k = _c.appendProps, appendProps = _k === void 0 ? {} : _k, _l = _c.indicatorPlacement, indicatorPlacement = _l === void 0 ? 'bottom' : _l, _m = _c.indicatorProps, indicatorProps = _m === void 0 ? {} : _m, classes = _c.classes, disabled = _c.disabled, _o = _c.inclusiveDisabled, inclusiveDisabled = _o === void 0 ? false : _o, children = _c.children, restProps = __rest(_c, ["className", "component", "variant", "size", "hovered", "selected", "bodyProps", "labelProps", "prepend", "prependProps", "append", "appendProps", "indicatorPlacement", "indicatorProps", "classes", "disabled", "inclusiveDisabled", "children"]);
    var anyDisabled = disabled || inclusiveDisabled;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Component, __assign({ "data-qa": "tab", className: (0, classnames_1.default)(classes.root, (_a = {},
                _a[classes.hovered] = hovered,
                _a[classes.selected] = selected,
                _a[classes.disabled] = anyDisabled,
                _a[classes.empty] = !children,
                _a[classes.solid] = variant === 'solid',
                _a[classes.normal] = size === 'normal',
                _a[classes.small] = size === 'small',
                _a[classes.tiny] = size === 'tiny',
                _a), className), role: "tab", "aria-selected": selected, "aria-disabled": anyDisabled, title: typeof children === 'string' ? children : '' }, restProps, { onClick: !anyDisabled ? restProps.onClick : undefined, ref: ref }),
            react_1.default.createElement("span", __assign({}, bodyProps, { className: classes.body }),
                (0, utils_1.shouldRenderNode)(prepend) && (react_1.default.createElement("span", __assign({}, prependProps, { className: classes.prepend }), prepend)),
                (0, utils_1.shouldRenderNode)(children) && (react_1.default.createElement("span", __assign({}, labelProps, { className: classes.label }), children)),
                (0, utils_1.shouldRenderNode)(append) && (react_1.default.createElement("span", __assign({}, appendProps, { className: classes.append }), append))),
            !anyDisabled && (react_1.default.createElement(indicator_1.Indicator, __assign({ fullWidth: variant === 'solid', active: selected, placement: indicatorPlacement }, indicatorProps, { className: (0, classnames_1.default)(classes.indicator, (_b = {},
                    _b[classes.selected] = selected || indicatorProps.active,
                    _b)) }))))));
});


/***/ }),

/***/ 5669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tabs = void 0;
var tabs_1 = __webpack_require__(9691);
Object.defineProperty(exports, "Tabs", ({ enumerable: true, get: function () { return tabs_1.Tabs; } }));


/***/ }),

/***/ 9691:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tabs = void 0;
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var tab_1 = __webpack_require__(9681);
var styles = __importStar(__webpack_require__(9715));
var utils_2 = __webpack_require__(8664);
/**
 *  Tabs wrapper component
 *
 *  If you are planning to use only the icon,
 *  then you need to insert it into "prepend" or "append" for correct display of paddings
 */
exports.Tabs = react_1.default.forwardRef(function TabsComponent(props, ref) {
    var _a;
    var _b = (0, utils_1.mergeClassesProps)(props, styles), className = _b.className, selectedValue = _b.value, onValueChange = _b.onValueChange, _c = _b.component, Component = _c === void 0 ? 'div' : _c, _d = _b.orientation, orientation = _d === void 0 ? 'horizontal' : _d, _e = _b.variant, variant = _e === void 0 ? 'ghost' : _e, _f = _b.size, size = _f === void 0 ? 'normal' : _f, _g = _b.animated, animated = _g === void 0 ? true : _g, _h = _b.tabListProps, tabListProps = _h === void 0 ? {} : _h, outlinePosition = _b.indicatorPlacement, _j = _b.indicatorProps, indicatorProps = _j === void 0 ? {} : _j, classes = _b.classes, childrenList = _b.children, restProps = __rest(_b, ["className", "value", "onValueChange", "component", "orientation", "variant", "size", "animated", "tabListProps", "indicatorPlacement", "indicatorProps", "classes", "children"]);
    var valueToIndex = new Map();
    var _k = react_1.default.useState(false), mounted = _k[0], setMounted = _k[1];
    var tabListRef = react_1.default.useRef(null);
    var _l = react_1.default.useState(null), indicatorStyles = _l[0], setIndicatorStyles = _l[1];
    var indicatorPlacement = react_1.default.useMemo(function () {
        if (outlinePosition) {
            return outlinePosition;
        }
        if (orientation === 'vertical') {
            return 'right';
        }
        return 'bottom';
    }, [outlinePosition, orientation]);
    var children = react_1.default.Children.toArray(childrenList).filter(react_1.default.isValidElement);
    react_1.default.useEffect(function () {
        setMounted(true);
    }, []);
    react_1.default.useEffect(function () {
        if (!tabListRef.current) {
            return undefined;
        }
        var selectedTabNode = tabListRef.current.children[valueToIndex.get(selectedValue)];
        if (!selectedTabNode) {
            setIndicatorStyles(null);
            return undefined;
        }
        var tabIndicatorStyles = (0, utils_2.getPositionStyles)(tabListRef.current, selectedTabNode, indicatorPlacement, variant);
        setIndicatorStyles(tabIndicatorStyles);
    }, [indicatorPlacement, variant, size, orientation, selectedValue, childrenList]);
    return (react_1.default.createElement(Component, __assign({}, restProps, { ref: ref, className: (0, classnames_1.default)(classes.root, className) }),
        react_1.default.createElement("div", __assign({ "data-qa": "tabs", role: "tablist" }, tabListProps, { ref: tabListRef, className: (0, classnames_1.default)(classes.tabList, (_a = {},
                _a[classes.vertical] = orientation === 'vertical',
                _a)) }), children.map(function (child, childIndex) {
            var _a = child.props, onClick = _a.onClick, value = _a.value, _b = _a.indicatorProps, tabIndicatorProps = _b === void 0 ? {} : _b, restChildProps = __rest(_a, ["onClick", "value", "indicatorProps"]);
            var childValue = value !== null && value !== void 0 ? value : childIndex;
            var selected = childValue === selectedValue;
            valueToIndex.set(childValue, childIndex);
            function handleClick() {
                if (onValueChange) {
                    onValueChange(childValue);
                }
            }
            return react_1.default.cloneElement(child, __assign({ className: animated && classes.transition, value: childValue, onClick: (0, utils_1.chain)(handleClick, onClick), selected: selected, variant: variant, size: size, classes: {
                    prepend: animated && classes.transition,
                    append: animated && classes.transition,
                    indicator: animated && classes.indicator
                }, indicatorPlacement: indicatorPlacement, indicatorProps: __assign(__assign({}, tabIndicatorProps), { active: !animated && selected }) }, restChildProps));
        })),
        animated && mounted && indicatorStyles && (react_1.default.createElement(tab_1.Indicator, __assign({}, indicatorProps, { active: true, className: classes.indicator, style: indicatorStyles })))));
});


/***/ }),

/***/ 8664:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPositionStyles = void 0;
/** Calculation of size and position of indicator */
function getPositionStyles(tabListNode, selectedTabNode, indicatorPlacement, variant) {
    var wrapperClientRect = tabListNode.getBoundingClientRect();
    var tabClientRect = selectedTabNode.getBoundingClientRect();
    var top = tabClientRect.top - wrapperClientRect.top;
    var left = tabClientRect.left - wrapperClientRect.left;
    var indicatorHeight = variant === 'ghost' ? 2 : tabClientRect.height;
    var indicatorWidth = variant === 'ghost' ? 2 : tabClientRect.width;
    switch (indicatorPlacement) {
        case 'bottom':
            return {
                left: left,
                top: top + tabClientRect.height - indicatorHeight,
                width: tabClientRect.width,
                height: indicatorHeight
            };
        case 'top':
            return {
                left: left,
                top: top,
                width: tabClientRect.width,
                height: indicatorHeight
            };
        case 'right':
            return {
                top: top,
                left: left + tabClientRect.width - indicatorWidth,
                height: tabClientRect.height,
                width: indicatorWidth
            };
        case 'left':
            return {
                top: top,
                left: left,
                height: tabClientRect.height,
                width: indicatorWidth
            };
        default:
            throw new Error('Invalid value for tab indicator position');
    }
}
exports.getPositionStyles = getPositionStyles;


/***/ }),

/***/ 7897:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextLabel = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var text_label_1 = __webpack_require__(9129);
Object.defineProperty(exports, "TextLabel", ({ enumerable: true, get: function () { return text_label_1.TextLabel; } }));


/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextLabel = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var should_render_node_1 = __webpack_require__(5230);
var styles_1 = __webpack_require__(598);
var typography_1 = __webpack_require__(2323);
var styles = __importStar(__webpack_require__(2882));
var captionVariantsMap = {
    header: 'title',
    title: 'body'
};
/**
 * Shortcut to pair some text with small caption.
 *
 * It takes in account text overflowing. Caption is never overflowed.
 */
var TextLabel = function (props) {
    var _a, _b;
    var _c = (0, styles_1.mergeClassesProps)(props, styles), caption = _c.caption, _d = _c.as, Component = _d === void 0 ? 'div' : _d, _e = _c.variant, variant = _e === void 0 ? 'body' : _e, wrap = _c.wrap, _f = _c.labelProps, labelProps = _f === void 0 ? {} : _f, _g = _c.captionProps, captionProps = _g === void 0 ? {} : _g, children = _c.children, classes = _c.classes, box = _c.box, grow = _c.grow, rest = __rest(_c, ["caption", "as", "variant", "wrap", "labelProps", "captionProps", "children", "classes", "box", "grow"]);
    var captionVariant = captionVariantsMap[variant] || 'caption';
    return (React.createElement(typography_1.Typography, __assign({ "data-qa": "text-label" }, rest, { as: Component, variant: variant, box: box, className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
            _a[classes.inline] = box === 'inline',
            _a)) }),
        React.createElement("span", __assign({}, labelProps, { className: (0, classnames_1.default)(labelProps.className, classes.label, (_b = {},
                _b[classes.wrap] = wrap,
                _b[classes.grow] = grow,
                _b)) }), children),
        (0, should_render_node_1.shouldRenderNode)(caption) ? (React.createElement(typography_1.Typography, __assign({ as: "span", variant: captionVariant, intent: "quiet" }, captionProps, { className: (0, classnames_1.default)(captionProps.className, classes.caption) }), caption)) : null));
};
exports.TextLabel = TextLabel;


/***/ }),

/***/ 8605:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Textarea = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var textarea_1 = __webpack_require__(6907);
Object.defineProperty(exports, "Textarea", ({ enumerable: true, get: function () { return textarea_1.Textarea; } }));


/***/ }),

/***/ 6907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Textarea = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var react_textarea_autosize_1 = __importDefault(__webpack_require__(649));
var utils_1 = __webpack_require__(9502);
var styles = __importStar(__webpack_require__(9108));
/**
 * React Textarea Autosize wrapper
 */
var Textarea = function (props) {
    var _a;
    var _b = (0, utils_1.mergeClassesProps)(props, styles), invalid = _b.invalid, fullWidth = _b.fullWidth, onValueChange = _b.onValueChange, classes = _b.classes, inputRef = _b.inputRef, rest = __rest(_b, ["invalid", "fullWidth", "onValueChange", "classes", "inputRef"]);
    var handleChange = function (event) {
        var value = event.currentTarget.value;
        if (onValueChange) {
            onValueChange(value);
        }
    };
    return (react_1.default.createElement(react_textarea_autosize_1.default, __assign({ "data-qa": "textarea" }, rest, { 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: inputRef, onChange: (0, utils_1.chain)(rest.onChange, handleChange), className: (0, classnames_1.default)(rest.className, classes.root, (_a = {},
            _a[classes.fullWidth] = fullWidth,
            _a[classes.invalid] = invalid,
            _a)) })));
};
exports.Textarea = Textarea;


/***/ }),

/***/ 708:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTooltipHandler = exports.TooltipHandler = exports.Tooltip = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var tooltip_1 = __webpack_require__(1802);
Object.defineProperty(exports, "Tooltip", ({ enumerable: true, get: function () { return tooltip_1.Tooltip; } }));
var tooltip_handler_1 = __webpack_require__(3564);
Object.defineProperty(exports, "TooltipHandler", ({ enumerable: true, get: function () { return tooltip_handler_1.TooltipHandler; } }));
var use_tooltip_handler_1 = __webpack_require__(6244);
Object.defineProperty(exports, "useTooltipHandler", ({ enumerable: true, get: function () { return use_tooltip_handler_1.useTooltipHandler; } }));


/***/ }),

/***/ 3564:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TooltipHandler = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var root_ref_1 = __webpack_require__(5424);
var use_tooltip_handler_1 = __webpack_require__(6244);
/**
 * Common tooltip handler.
 * It listens hover and focus on the reference element.
 */
exports.TooltipHandler = React.forwardRef(function TooltipHandlerRef(props, ref) {
    var childRef = React.useRef(null);
    var tooltipHandler = (0, use_tooltip_handler_1.useTooltipHandler)({
        disableFocusListener: props.disableFocusListener,
        disableHoverListener: props.disableHoverListener,
        disableListeners: props.disableListeners,
        referenceElement: childRef.current,
        openDelay: props.openDelay
    });
    React.useImperativeHandle(ref, function () { return ({
        close: tooltipHandler.close,
        open: tooltipHandler.open
    }); }, []);
    var renderChild = function () {
        var child = (typeof props.children === 'function'
            ? props.children({ open: tooltipHandler.isOpen })
            : props.children);
        return React.cloneElement(child, tooltipHandler.getReferenceProps(child.props));
    };
    var renderTooltip = function () {
        var tooltip = tooltipHandler.isOpen
            ? typeof props.tooltip === 'function'
                ? props.tooltip()
                : props.tooltip
            : null;
        return tooltip && tooltipHandler.isOpen
            ? React.cloneElement(tooltip, tooltipHandler.getTooltipProps(tooltip.props))
            : null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(root_ref_1.RootRef, { rootRef: childRef }, renderChild()),
        renderTooltip()));
});


/***/ }),

/***/ 9566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TooltipSlide = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var slide_1 = __webpack_require__(6798);
var getSlideDirection = function (placement) {
    if (placement) {
        if (placement.startsWith('bottom')) {
            return 'bottom';
        }
        if (placement.startsWith('right')) {
            return 'right';
        }
        if (placement.startsWith('left')) {
            return 'left';
        }
    }
    return 'top';
};
/** Internal TooltipSlide transition for tooltip. */
var TooltipSlide = function (props) {
    var disableTransition = props.disableTransition, children = props.children, placement = props.placement, open = props.open, _a = props.direction, direction = _a === void 0 ? getSlideDirection(placement) : _a, _b = props.fast, fast = _b === void 0 ? true : _b, rest = __rest(props, ["disableTransition", "children", "placement", "open", "direction", "fast"]);
    return disableTransition ? (children) : (React.createElement(slide_1.Slide, __assign({}, rest, { in: open, direction: direction, fast: fast }), children));
};
exports.TooltipSlide = TooltipSlide;


/***/ }),

/***/ 1802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tooltip = void 0;
/*
 * Copyright (c) 2011-2018 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var react_1 = __importDefault(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var dark_context_1 = __webpack_require__(3693);
var styles_1 = __webpack_require__(598);
var icon_1 = __webpack_require__(6185);
var transition_popper_1 = __webpack_require__(1842);
var typography_1 = __webpack_require__(2323);
var tooltip_slide_transition_1 = __webpack_require__(9566);
var styles = __importStar(__webpack_require__(4670));
var TooltipArrowIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { viewBox: "0 0 8 10" },
    react_1.default.createElement("path", { d: "M8 10L0 5l8-5v10z", fill: "rgba(51, 51, 51, 1)" })));
/**
 * Tooltip is a simple and small block of text that shows some useful information
 * near some reference element.
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleWindowKeyDown = function (event) {
            if (_this.props.disableEscListener) {
                return;
            }
            if (event.key === 'Escape' && _this.props.onClose) {
                _this.props.onClose('escape_keydown', event);
            }
        };
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.handleWindowKeyDown);
    };
    Tooltip.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.handleWindowKeyDown);
    };
    Tooltip.prototype.render = function () {
        var _a = (0, styles_1.mergeClassesProps)(this.props, styles), popperRef = _a.popperRef, children = _a.children, classes = _a.classes, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, noGaps = _a.noGaps, onClose = _a.onClose, onClosed = _a.onClosed, disableEscListener = _a.disableEscListener, rest = __rest(_a, ["popperRef", "children", "classes", "placement", "noGaps", "onClose", "onClosed", "disableEscListener"]);
        return (react_1.default.createElement(transition_popper_1.TransitionPopper, __assign({}, rest, { ref: popperRef, placement: placement }), function (_a) {
            var _b;
            var ref = _a.ref, style = _a.style, arrowProps = _a.arrowProps, actualPlacement = _a.placement, targetProps = _a.targetProps, onTransitionExited = _a.onTransitionExited;
            return (react_1.default.createElement("div", { ref: ref, style: style, "data-placement": actualPlacement, className: classes.popperContainer },
                react_1.default.createElement(tooltip_slide_transition_1.TooltipSlide, { appear: true, disableTransition: rest.disableTransition, placement: actualPlacement, open: !!actualPlacement && rest.open, onExited: (0, chain_1.chain)(onTransitionExited, onClosed) },
                    react_1.default.createElement("div", { "data-placement": actualPlacement, className: classes.tooltipContainer },
                        react_1.default.createElement(dark_context_1.DarkContext.Provider, { value: true },
                            react_1.default.createElement(typography_1.Typography, __assign({ "data-qa": "tooltip", as: "div" }, targetProps, { className: (0, classnames_1.default)(targetProps.className, classes.root, (_b = {},
                                    _b[classes.withGaps] = !noGaps,
                                    _b)), variant: "caption" }), children)),
                        react_1.default.createElement("div", __assign({}, arrowProps, { "data-placement": actualPlacement, className: classes.arrow }),
                            react_1.default.createElement(TooltipArrowIcon, { "data-placement": actualPlacement, className: classes.arrowIcon }))))));
        }));
    };
    return Tooltip;
}(react_1.default.Component));
exports.Tooltip = Tooltip;


/***/ }),

/***/ 6244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTooltipHandler = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var contains_1 = __importDefault(__webpack_require__(424));
var React = __importStar(__webpack_require__(6689));
var chain_1 = __webpack_require__(9416);
var debounce_1 = __webpack_require__(1467);
var DEFAULT_OPEN_DELAY = 500;
/** Hook to using tooltip */
function useTooltipHandler(props) {
    var _a = props.openDelay, openDelay = _a === void 0 ? DEFAULT_OPEN_DELAY : _a;
    var _b = React.useState({
        exited: true,
        open: false
    }), state = _b[0], setState = _b[1];
    function open() {
        setState({ open: true, exited: false });
    }
    var openDebouncedRef = React.useRef((0, debounce_1.debounce)(open, openDelay));
    var referenceElementRef = React.useRef(props.referenceElement);
    referenceElementRef.current = props.referenceElement;
    var handleWindowMouseMove = React.useCallback(function (event) {
        if (referenceElementRef.current &&
            event.target instanceof Element &&
            !(0, contains_1.default)(referenceElementRef.current, event.target)) {
            close();
        }
    }, []);
    function close() {
        window.removeEventListener('mousemove', handleWindowMouseMove);
        openDebouncedRef.current.cancel();
        setState(function (currentState) { return (__assign(__assign({}, currentState), { open: false })); });
    }
    var handleReferenceMouseEnter = function () {
        if (openDebouncedRef.current.active ||
            props.disableListeners ||
            props.disableHoverListener) {
            return;
        }
        openDebouncedRef.current();
        window.addEventListener('mousemove', handleWindowMouseMove);
    };
    var handleReferenceMouseLeave = function (event) {
        if (event.relatedTarget instanceof Element &&
            (0, contains_1.default)(event.currentTarget, event.relatedTarget)) {
            return;
        }
        close();
    };
    var handleReferenceFocus = function () {
        if (openDebouncedRef.current.active ||
            props.disableListeners ||
            props.disableFocusListener) {
            return;
        }
        openDebouncedRef.current();
    };
    var handleReferenceBlur = function (event) {
        if (event.relatedTarget instanceof Node &&
            (0, contains_1.default)(event.currentTarget, event.relatedTarget)) {
            return;
        }
        close();
    };
    var handleTooltipClose = function () {
        close();
    };
    var handleTooltipClosed = function () {
        setState(function (currentState) { return (__assign(__assign({}, currentState), { exited: true })); });
    };
    React.useEffect(function () {
        return function () {
            window.removeEventListener('mousemove', handleWindowMouseMove);
            openDebouncedRef.current.cancel();
        };
    }, []);
    var getTooltipProps = function (tooltipProps) {
        if (tooltipProps === void 0) { tooltipProps = {}; }
        return (__assign(__assign({ open: state.open, referenceElement: props.referenceElement }, tooltipProps), { onClose: (0, chain_1.chain)(tooltipProps.onClose, handleTooltipClose), onClosed: (0, chain_1.chain)(tooltipProps.onClosed, handleTooltipClosed) }));
    };
    var getReferenceProps = function (referenceProps) {
        if (referenceProps === void 0) { referenceProps = {}; }
        return (__assign(__assign({}, referenceProps), { onMouseEnter: (0, chain_1.chain)(referenceProps.onMouseEnter, handleReferenceMouseEnter), onMouseLeave: (0, chain_1.chain)(referenceProps.onMouseLeave, handleReferenceMouseLeave), onFocus: (0, chain_1.chain)(referenceProps.onFocus, handleReferenceFocus), onBlur: (0, chain_1.chain)(referenceProps.onBlur, handleReferenceBlur) }));
    };
    return {
        isOpen: state.open || !state.exited,
        open: open,
        close: close,
        getTooltipProps: getTooltipProps,
        getReferenceProps: getReferenceProps
    };
}
exports.useTooltipHandler = useTooltipHandler;


/***/ }),

/***/ 1842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransitionPopper = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var transition_popper_1 = __webpack_require__(9103);
Object.defineProperty(exports, "TransitionPopper", ({ enumerable: true, get: function () { return transition_popper_1.TransitionPopper; } }));


/***/ }),

/***/ 9103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransitionPopper = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
var React = __importStar(__webpack_require__(6689));
var ReactDOM = __importStar(__webpack_require__(6405));
var react_popper_1 = __webpack_require__(2932);
/**
 * It is a wrapper around react-popper
 * with portal support, transitions and unmounting on close.
 *
 * It is generic to handy API. This component omit popper's properties
 * and left target's `T` properties for handy API.
 * @ATTENTION Be careful. Targets properties must not conflict with TransitionPopperProps
 */
var TransitionPopper = /** @class */ (function (_super) {
    __extends(TransitionPopper, _super);
    function TransitionPopper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popperScheduleUpdate = null;
        _this.state = {
            exited: true
        };
        _this.handleTransitionExited = function () {
            _this.setState({ exited: true });
        };
        return _this;
    }
    TransitionPopper.getDerivedStateFromProps = function (props, state) {
        if (props.open) {
            return {
                exited: false
            };
        }
        return state;
    };
    /**
     * Recalculate position of popper.
     * Call it when any user action changes reference element position.
     */
    TransitionPopper.prototype.scheduleUpdate = function () {
        if (this.popperScheduleUpdate) {
            this.popperScheduleUpdate();
        }
    };
    TransitionPopper.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, referenceElement = _a.referenceElement, keepMounted = _a.keepMounted, disableTransition = _a.disableTransition, portalContainer = _a.portalContainer, children = _a.children, innerRef = _a.innerRef, modifiers = _a.modifiers, placement = _a.placement, positionFixed = _a.positionFixed, 
        // omit all popper's properties
        targetProps = __rest(_a, ["open", "referenceElement", "keepMounted", "disableTransition", "portalContainer", "children", "innerRef", "modifiers", "placement", "positionFixed"]);
        var exited = this.state.exited;
        if (!keepMounted && !open && (exited || disableTransition)) {
            return null;
        }
        var element = (typeof referenceElement === 'function' ? referenceElement() : referenceElement) ||
            undefined;
        var popper = (React.createElement(react_popper_1.Popper, { strategy: positionFixed ? 'fixed' : 'absolute', placement: placement, referenceElement: element || undefined, innerRef: innerRef, modifiers: modifiers }, function (popperChildrenProps) {
            return children(__assign(__assign({}, popperChildrenProps), { ref: function (node) {
                    if (typeof popperChildrenProps.ref === 'function') {
                        popperChildrenProps.ref(node);
                    }
                    _this.popperScheduleUpdate = popperChildrenProps.update;
                }, targetProps: targetProps, onTransitionExited: _this.handleTransitionExited }));
        }));
        return portalContainer ? ReactDOM.createPortal(popper, portalContainer) : popper;
    };
    return TransitionPopper;
}(React.Component));
exports.TransitionPopper = TransitionPopper;


/***/ }),

/***/ 2323:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Typography = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var typography_1 = __webpack_require__(1690);
Object.defineProperty(exports, "Typography", ({ enumerable: true, get: function () { return typography_1.Typography; } }));


/***/ }),

/***/ 1690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Typography = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
var React = __importStar(__webpack_require__(6689));
var utils_1 = __webpack_require__(9502);
var styles = __importStar(__webpack_require__(9370));
/**
 * Component that renders text with specific preset.
 * Its purpose is to reduce amount of custom CSS text styles.
 * It is one of the base components of whole UI Kit.
 * Will be moved to UI Kit.
 */
function Typography(props) {
    return (React.createElement(utils_1.DarkContext.Consumer, null, function (darkContext) {
        var _a;
        var mergedProps = (0, utils_1.mergeClassesProps)(props, styles);
        var as = mergedProps.as, _b = mergedProps.variant, variant = _b === void 0 ? 'body' : _b, _c = mergedProps.intent, intent = _c === void 0 ? 'no-intent' : _c, _d = mergedProps.box, box = _d === void 0 ? 'block' : _d, _e = mergedProps.inverted, inverted = _e === void 0 ? darkContext : _e, classes = mergedProps.classes, className = mergedProps.className, condensed = mergedProps.condensed, ellipsis = mergedProps.ellipsis, rest = __rest(mergedProps, ["as", "variant", "intent", "box", "inverted", "classes", "className", "condensed", "ellipsis"]);
        var Component = mergedProps.as;
        if (!Component) {
            switch (variant) {
                case 'body':
                    Component = 'p';
                    break;
                case 'caption':
                    Component = 'p';
                    break;
                case 'header':
                    Component = 'h2';
                    break;
                case 'section':
                    Component = 'h3';
                    break;
                case 'title':
                    Component = 'h1';
                    break;
                default:
                    Component = 'div';
            }
        }
        return (React.createElement(Component, __assign({ "data-qa": "typography" }, rest, { className: (0, classnames_1.default)(className, classes.root, (_a = {},
                _a[classes.header] = variant === 'header',
                _a[classes.title] = variant === 'title',
                _a[classes.section] = variant === 'section',
                _a[classes.body] = variant === 'body',
                _a[classes.caption] = variant === 'caption',
                _a[classes.quiet] = intent === 'quiet',
                _a[classes.inverted] = inverted,
                _a[classes.inline] = box === 'inline',
                _a[classes.paragraph] = box === 'paragraph',
                _a[classes.success] = intent === 'success',
                _a[classes.warning] = intent === 'warning',
                _a[classes.alarm] = intent === 'alarm',
                _a[classes.ellipsis] = ellipsis,
                _a[classes.condensed] = condensed,
                _a)) })));
    }));
}
exports.Typography = Typography;


/***/ }),

/***/ 7427:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WithSeparator = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var with_separator_1 = __webpack_require__(2027);
Object.defineProperty(exports, "WithSeparator", ({ enumerable: true, get: function () { return with_separator_1.WithSeparator; } }));


/***/ }),

/***/ 2027:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WithSeparator = void 0;
var React = __importStar(__webpack_require__(6689));
/** Component that adds separator between children */
var WithSeparator = function (props) {
    var children = React.Children.toArray(props.children).reduce(function (result, child, index, arr) {
        result.push(child);
        if (index < arr.length - 1) {
            if (React.isValidElement(props.separator)) {
                result.push(React.cloneElement(props.separator, {
                    key: "separator-".concat(index)
                }));
            }
            else {
                result.push(props.separator);
            }
        }
        return result;
    }, []);
    return React.createElement(React.Fragment, null, children);
};
exports.WithSeparator = WithSeparator;


/***/ }),

/***/ 8636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowBottomThinIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Keyboard arrow key icon shows user possible transformation direction
 * after some interaction has applied.
 */
exports.ArrowBottomThinIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M7 8l3 3 3-3c1-1 2 0 1 1l-4 4-4-4C5 8 6 7 7 8z", className: "gs-svg-icon-fill", fillOpacity: "0.6" })));


/***/ }),

/***/ 607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowDownloadIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Simple bottom arrow and a line below It
 */
exports.ArrowDownloadIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M7.5 8.5c-.39-.39-1.11-.39-1.5 0-.39.39-.39 1.11 0 1.5l4 4 4-4c.39-.39.39-1.11 0-1.5-.39-.39-1.11-.39-1.5 0L11 10V4a1 1 0 1 0-2 0v6L7.5 8.5z" }),
    React.createElement("rect", { width: "10", height: "2", x: "5", y: "15", rx: "1", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowDownloadThinIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Thin bottom arrow and a line below it
 */
exports.ArrowDownloadThinIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M10.5 3.5V13.5M10.5 13.5L14.5 9.5M10.5 13.5L6.5 9.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" }),
    React.createElement("rect", { x: "5", y: "16", width: "11", height: "1", rx: "0.5", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 4303:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowLeftIcon = void 0;
/*
 * Copyright (c) 2011-2022 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Arrow Left Icon
 */
exports.ArrowLeftIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M9 6l-4 4 4 4M7 10h8", className: "gs-svg-icon-stroke", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));


/***/ }),

/***/ 1956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2022 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowLeftThinIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Arrow Left Thin Icon
 */
exports.ArrowLeftThinIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M8.5 6.5L4.5 10.5L8.5 14.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" }),
    React.createElement("line", { x1: "15.5", y1: "10.5", x2: "5.5", y2: "10.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" })));


/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowRightIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Arrow Right Icon
 */
exports.ArrowRightIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M11 14l4-4-4-4M13 10H5", className: "gs-svg-icon-stroke", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));


/***/ }),

/***/ 2720:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2022 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowRightThinIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Arrow Right Thin Icon
 */
exports.ArrowRightThinIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M11.5 14.5L15.5 10.5L11.5 6.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" }),
    React.createElement("line", { x1: "14.5", y1: "10.5", x2: "4.5", y2: "10.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" })));


/***/ }),

/***/ 7933:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkBorderedIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var bookmarkPath = "\nM6 5.99999C6 5.57707 6.10539 5.35171 6.22855 5.22855C6.35171 5.10539 6.57707 5 6.99999 5V4C6.42292 4 5.89828 4.14461 5.52144 4.52144C5.14461 4.89828 5 5.42292 5 5.99999H6ZM6.99999 5H13V4H6.99999V5ZM13 5C13.4229 5 13.6483 5.10539 13.7714 5.22855C13.8946 5.35171 14 5.57707 14 6H15C15 5.42293 14.8554 4.89829 14.4786 4.52145C14.1017 4.14461 13.5771 4 13 4V5ZM6 14.5V5.99999H5V14.5H6ZM15 14.5V6H14V14.5H15ZM5 14.5C5 14.9716 4.9944 15.5643 5.15066 16.0331C5.23355 16.2818 5.37313 16.5348 5.6149 16.7228C5.861 16.9142 6.16354 17 6.5 17V16C6.33646 16 6.264 15.9608 6.22885 15.9334C6.18937 15.9027 6.14145 15.8432 6.09934 15.7169C6.0056 15.4357 6 15.0284 6 14.5H5ZM6.5 17C6.74794 17 6.97025 16.9084 7.15105 16.8014C7.33444 16.693 7.50952 16.5481 7.672 16.3942C7.99467 16.0885 8.32723 15.6884 8.63411 15.3201C8.95223 14.9384 9.24467 14.5885 9.51575 14.3317C9.65015 14.2044 9.76413 14.1148 9.85808 14.0592C9.95463 14.0021 9.99794 14 10 14V13C9.75206 13 9.52975 13.0916 9.34895 13.1986C9.16556 13.307 8.99048 13.4519 8.828 13.6058C8.50533 13.9115 8.17277 14.3116 7.86589 14.6799C7.54777 15.0616 7.25533 15.4115 6.98425 15.6683C6.84985 15.7956 6.73587 15.8852 6.64192 15.9408C6.54537 15.9979 6.50206 16 6.5 16V17ZM10 14C10.0021 14 10.0454 14.0021 10.1419 14.0592C10.2359 14.1148 10.3499 14.2044 10.4843 14.3317C10.7553 14.5885 11.0478 14.9384 11.3659 15.3201C11.6728 15.6884 12.0053 16.0885 12.328 16.3942C12.4905 16.5481 12.6656 16.693 12.8489 16.8014C13.0297 16.9084 13.2521 17 13.5 17V16C13.4979 16 13.4546 15.9979 13.3581 15.9408C13.2641 15.8852 13.1501 15.7956 13.0157 15.6683C12.7447 15.4115 12.4522 15.0616 12.1341 14.6799C11.8272 14.3116 11.4947 13.9115 11.172 13.6058C11.0095 13.4519 10.8344 13.307 10.6511 13.1986C10.4703 13.0916 10.2479 13 10 13V14ZM13.5 17C13.8365 17 14.139 16.9142 14.3851 16.7228C14.6269 16.5348 14.7665 16.2818 14.8493 16.0331C15.0056 15.5643 15 14.9716 15 14.5H14C14 15.0284 13.9944 15.4357 13.9007 15.7169C13.8585 15.8432 13.8106 15.9027 13.7712 15.9334C13.736 15.9608 13.6635 16 13.5 16V17Z\n";
/**
 * Bordered bookmark icon
 */
exports.BookmarkBorderedIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: bookmarkPath, className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 8552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var bookmarkPath = "\nM7 4.5C6 4.5 5.5 5 5.5 6V14.5C5.5 15.5 5.5 16.5 6.5 16.5C7.5 16.5 9 13.5 10 13.5C11 13.5 12.5 16.5 13.5 16.5C14.5 16.5 14.5 15.5 14.5 14.5V6C14.5 5 14 4.5 13 4.5H7Z\n";
/**
 * Bookmark icon
 */
exports.BookmarkIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: bookmarkPath, className: "gs-svg-icon-stroke gs-svg-icon-fill", strokeLinecap: "round" })));


/***/ }),

/***/ 6835:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BooleanIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Boolean Icon
 */
exports.BooleanIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M4 7H9V13H4V7ZM11.5 7H11V7.5V12.5V13H11.5H15.5H16V12.5V7.5V7H15.5H11.5ZM12 12V8H15V12H12Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 7722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BoxplotIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Just a circle icon */
exports.BoxplotIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M12 2v3h-2v10h2v3h1v-3h2V5h-2V2h-1zm.5 4h.5v8h-2V6h1.5zm-8-1H6V3h1v2h2v6H7v5H6v-5H4V5h.5zM5 9.5V6h2v4H5v-.5z" }))); });


/***/ }),

/***/ 3216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BulletIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Just a circle icon */
exports.BulletIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("circle", { cx: "10", cy: "10", r: "3", className: "gs-svg-icon-fill" }))); });


/***/ }),

/***/ 6976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CheckedRadioIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Ring with circle inside.
 * Looks like checked radio button.
 */
exports.CheckedRadioIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none" },
    React.createElement("circle", { cx: "10", cy: "10", r: "8", className: "gs-svg-icon-stroke", strokeWidth: "1" }),
    React.createElement("circle", { cx: "10", cy: "10", r: "4", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 1214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CheckMarkIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Check-mark icon
 */
exports.CheckMarkIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M5 9.6l3.5 3.5L15 6.6", className: "gs-svg-icon-stroke", strokeWidth: "2", strokeLinecap: "round" })));


/***/ }),

/***/ 4628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChevronDownIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.ChevronDownIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3536 12.3536C10.1583 12.5488 9.84171 12.5488 9.64645 12.3536L6.64645 9.35355C6.45118 9.15829 6.45118 8.84171 6.64645 8.64645C6.84171 8.45118 7.15829 8.45118 7.35355 8.64645L10 11.2929L12.6464 8.64645C12.8417 8.45118 13.1583 8.45118 13.3536 8.64645C13.5488 8.84171 13.5488 9.15829 13.3536 9.35355L10.3536 12.3536Z", fill: "rgba(129, 129, 129, 1)" })));


/***/ }),

/***/ 816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChevronRightIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.ChevronRightIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8536 10.1464C12.0488 10.3417 12.0488 10.6582 11.8536 10.8535L8.85364 13.8536C8.65839 14.0488 8.3418 14.0489 8.14654 13.8536C7.95127 13.6583 7.95126 13.3418 8.14652 13.1465L10.7929 10.5L8.14639 7.85359C7.95113 7.65834 7.95112 7.34175 8.14638 7.14649C8.34163 6.95122 8.65822 6.95121 8.85348 7.14647L11.8536 10.1464Z", fill: "rgba(129, 129, 129, 1)" })));


/***/ }),

/***/ 5516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Clear Icon
 */
exports.ClearIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M7.5 12.5l5-5M7.5 7.5l5 5", className: "gs-svg-icon-stroke", strokeLinecap: "round" }),
    React.createElement("circle", { cx: "10", cy: "10", r: "6.5", className: "gs-svg-icon-stroke", fill: "none" })));


/***/ }),

/***/ 1091:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CollapseVerticalIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Collapse vertical icon */
exports.CollapseVerticalIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M5 10H15", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M7 5L10 8L13 5", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M13 15L10 12L7 15", className: "gs-svg-icon-stroke" })));


/***/ }),

/***/ 2698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompletedIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.CompletedIcon = (0, icon_1.createIcon)(React.createElement("svg", { fill: "none", width: "20", height: "20", viewBox: "0 0 20 20" },
    React.createElement("path", { stroke: "#77AB30", d: "M16.945 9.12a7 7 0 11-3.474-5.199" }),
    React.createElement("path", { fill: "#77AB30", fillRule: "evenodd", d: "M6 8c.586-.585 1.414-.585 2 0l2 2.079L15 5c.586-.585 1.914-1.085 2.5-.5.586.586.086 1.915-.5 2.5l-7 7-4-3.92A1.45 1.45 0 016 8z", clipRule: "evenodd" })));


/***/ }),

/***/ 1433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CrossIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Cross icon indicates that the bound action close or cancel something
 */
exports.CrossIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round", d: "M6 13.939L13.939 6M6.061 6L14 13.939" })));


/***/ }),

/***/ 3817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CrossSmallIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * The same as the Cross icon, but smaller
 */
exports.CrossSmallIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round", d: "M7 7l6 6M7 13l6-6" })));


/***/ }),

/***/ 6828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DateIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Date Icon
 */
exports.DateIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M3.5 4.5H17.5V16.5L3.5 16.5V4.5Z", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M6 7.5H9.5V10.5M6 13.5H9.5V10.5M9.5 10.5H7", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M13.5 13.5V7.5H12M13.5 13.5H11M13.5 13.5H15", className: "gs-svg-icon-stroke" }),
    React.createElement("rect", { x: "6", y: "2", width: "1", height: "3", className: "gs-svg-icon-fill" }),
    React.createElement("rect", { x: "14", y: "2", width: "1", height: "3", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 6829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DecimalIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Decimal Icon
 */
exports.DecimalIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M4.5 7.5H7.5V13.5H4.5V7.5Z", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M16 7.5H12.5V10.5H15.5V13.5H12", className: "gs-svg-icon-stroke" }),
    React.createElement("rect", { x: "9", y: "12", width: "2", height: "2", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 2213:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DictionaryIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Dictionary Icon
 */
exports.DictionaryIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("mask", { id: "mask0", maskUnits: "userSpaceOnUse", x: "3", y: "1", width: "14", height: "18" },
        React.createElement("path", { d: "M3 3V17C3 18.1046 3.89543 19 5 19H15C16.1046 19 17 18.1046 17 17V6.70156C17 6.24742 16.8454 5.8068 16.5617 5.45217L13.6005 1.75061C13.2209 1.27618 12.6463 1 12.0388 1H5C3.89543 1 3 1.89543 3 3Z", fill: "#B0B5BF" })),
    React.createElement("g", { mask: "url(#mask0)" },
        React.createElement("path", { d: "M3 3V17C3 18.1046 3.89543 19 5 19H15C16.1046 19 17 18.1046 17 17V6.70156C17 6.24742 16.8454 5.8068 16.5617 5.45217L13.6005 1.75061C13.2209 1.27618 12.6463 1 12.0388 1H5C3.89543 1 3 1.89543 3 3Z", fill: "#B0B5BF" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5.5C5 4.67157 5.67157 4 6.5 4C7.32843 4 8 4.67157 8 5.5C8 6.32843 7.32843 7 6.5 7C5.67157 7 5 6.32843 5 5.5ZM6 10.5V8H7V10H11V11H6.5H6V10.5ZM6 12V14.5V15H6.5H11V14H7V12H6ZM12 10.5C12 9.67157 12.6716 9 13.5 9C14.3284 9 15 9.67157 15 10.5C15 11.3284 14.3284 12 13.5 12C12.6716 12 12 11.3284 12 10.5ZM13.5 13C12.6716 13 12 13.6716 12 14.5C12 15.3284 12.6716 16 13.5 16C14.3284 16 15 15.3284 15 14.5C15 13.6716 14.3284 13 13.5 13Z", fill: "#798091" }),
        React.createElement("path", { d: "M12 5V1H12.5194C12.8232 1 13.1105 1.13809 13.3002 1.3753L17 6H13C12.4477 6 12 5.55228 12 5Z", fill: "#798091" }))));


/***/ }),

/***/ 1737:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DockBottomIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var react_1 = __importDefault(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Dock right icon */
exports.DockBottomIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 12H15V14H5L5 12ZM5 15H4V14L4 6L4 5L5 5L15 5L16 5V6L16 14V15H15L5 15ZM15 6L5 6L5 11H15V6Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DockRightIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var react_1 = __importDefault(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Dock right icon */
exports.DockRightIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 14L13 6L15 6L15 14H13ZM16 14L16 6V5L15 5L5 5L4 5L4 6L4 14V15H5L15 15H16V14ZM5 14H12L12 6L5 6L5 14Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3168:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DownloadIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Download icon indicates that the bound action could initialize
 * some download process.
 */
exports.DownloadIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M4.5 8h1.722V7a4 4 0 0 1 4-4C12.01 3 14 4 14 6h.5C16 6 17 7.195 17 8.5c0 1-1 1.5-1 1.5l1 .5s1-.5 1-2a3.5 3.5 0 0 0-3.188-3.486C14.5 3 12.278 2 10.222 2a5 5 0 0 0-5 5H4.5a2.5 2.5 0 0 0 0 5H5l1-1H4.5a1.5 1.5 0 0 1 0-3z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { d: "M8.5 11.5L7 13l5 5 5-5-1.5-1.5-2.517 2.5V8H11v6l-2.5-2.5z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 7223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DraftIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Icon with blank list and pencil */
exports.DraftIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M4 7.407a1 1 0 01.293-.7l3.414-3.414A1 1 0 018.414 3H13.5a.5.5 0 110 1H9v3a1 1 0 01-1 1H5v7.5a.51.51 0 00.166.334A.51.51 0 005.5 16h9a.51.51 0 00.334-.166A.51.51 0 0015 15.5v-6a.5.5 0 011 0v6c0 .413-.201.783-.459 1.041-.258.258-.628.459-1.041.459h-9c-.413 0-.783-.201-1.041-.459C4.201 16.283 4 15.913 4 15.5V7.407zM5.414 7L8 4.414V7H5.414z" }),
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M15 4s1-1 2 0 0 2 0 2l-6 6-3 1 1-3 6-6z" }))); });


/***/ }),

/***/ 1911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExpandVerticalIcon = void 0;
var react_1 = __importDefault(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Expand vertical icon */
exports.ExpandVerticalIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    react_1.default.createElement("path", { d: "M5 10H15", className: "gs-svg-icon-stroke" }),
    react_1.default.createElement("path", { d: "M7 12L10 15L13 12", className: "gs-svg-icon-stroke" }),
    react_1.default.createElement("path", { d: "M13 8L10 5L7 8", className: "gs-svg-icon-stroke" })));


/***/ }),

/***/ 5008:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExternalLinkIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * External link Icon
 */
exports.ExternalLinkIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M5 15V5h4v1H6v8h8v-3h1v4H5zm10-6h-1V7l-1 1-3.293 3.293L9 12l-.293-.293-.414-.414L8 11l.707-.707L12 7l1-1h-2V5h4v4z" })));


/***/ }),

/***/ 1111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EyeClosedIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.EyeClosedIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M11.9998 15.4999C9.97033 15.4999 8.33003 14.5723 7.1788 13.6154C6.60515 13.1386 6.16124 12.6612 5.86147 12.3037C5.71183 12.1252 5.59881 11.9775 5.52416 11.8759C5.48686 11.8251 5.4592 11.7858 5.44139 11.7601L5.42213 11.732L5.4181 11.726L5.41767 11.7253C5.41776 11.7255 5.41785 11.7256 4.99982 11.9999C4.5818 12.2743 4.58191 12.2744 4.58204 12.2746L4.58233 12.2751L4.58311 12.2762L4.58538 12.2797L4.59285 12.2908C4.59912 12.3001 4.60796 12.3131 4.61935 12.3296C4.64214 12.3625 4.67514 12.4092 4.71816 12.4678C4.80416 12.5849 4.9304 12.7497 5.09521 12.9462C5.13346 12.9918 5.17383 13.0392 5.21629 13.0881C5.19172 13.1051 5.16832 13.1245 5.14645 13.1464L4.14645 14.1464C3.95118 14.3417 3.95118 14.6582 4.14645 14.8535C4.34171 15.0488 4.65829 15.0488 4.85355 14.8535L5.85355 13.8535C5.86877 13.8383 5.88279 13.8223 5.89564 13.8058C6.08984 13.9941 6.30471 14.1892 6.5396 14.3845C6.95095 14.7264 7.42727 15.0714 7.96436 15.3808L6.6 17.1999C6.43431 17.4209 6.47909 17.7343 6.7 17.8999C6.92091 18.0656 7.23431 18.0209 7.4 17.7999L8.87145 15.838C9.65182 16.1766 10.5311 16.4202 11.5 16.4836V18.9999C11.5 19.2761 11.7239 19.4999 12 19.4999C12.2761 19.4999 12.5 19.2761 12.5 18.9999V16.4836C13.3134 16.4303 14.0635 16.2501 14.745 15.9933L16.1 17.7999C16.2657 18.0209 16.5791 18.0656 16.8 17.8999C17.0209 17.7343 17.0657 17.4209 16.9 17.1999L15.6811 15.5747C16.3649 15.2197 16.9604 14.7998 17.4601 14.3845C17.695 14.1892 17.91 13.994 18.1042 13.8056C18.1171 13.8222 18.1312 13.8382 18.1464 13.8535L19.1464 14.8535C19.3417 15.0488 19.6583 15.0488 19.8536 14.8535C20.0488 14.6582 20.0488 14.3417 19.8536 14.1464L18.8536 13.1464C18.8316 13.1245 18.8081 13.105 18.7835 13.088C18.8259 13.0391 18.8662 12.9918 18.9044 12.9462C19.0693 12.7497 19.1955 12.5849 19.2815 12.4678C19.3245 12.4092 19.3575 12.3625 19.3803 12.3296C19.3917 12.3131 19.4005 12.3001 19.4068 12.2908L19.4143 12.2797L19.4165 12.2762L19.4173 12.2751L19.4176 12.2746C19.4177 12.2744 19.4178 12.2743 18.9998 11.9999C18.5818 11.7256 18.5819 11.7255 18.582 11.7253L18.5815 11.726L18.5775 11.732L18.5583 11.7601C18.5405 11.7858 18.5128 11.8251 18.4755 11.8759C18.4008 11.9775 18.2878 12.1252 18.1382 12.3037C17.8384 12.6612 17.3945 13.1386 16.8208 13.6154C15.6696 14.5723 14.0293 15.4999 11.9998 15.4999Z" })));


/***/ }),

/***/ 3813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EyeEmptyIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.EyeEmptyIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.587 10.162A.834.834 0 013.504 10a.836.836 0 01.083-.162c.083-.133.215-.301.398-.495a9.18 9.18 0 011.533-1.26C6.808 7.22 8.459 6.5 10 6.5c1.54 0 3.193.72 4.482 1.582.64.428 1.17.876 1.533 1.261.183.194.315.362.398.495.055.089.076.141.083.162a.834.834 0 01-.083.162c-.083.133-.215.301-.398.495a9.186 9.186 0 01-1.533 1.26C13.192 12.78 11.541 13.5 10 13.5c-1.54 0-3.193-.72-4.482-1.582a9.184 9.184 0 01-1.533-1.261 3.313 3.313 0 01-.398-.495zM10 5.5c-1.819 0-3.667.835-5.038 1.751-.69.462-1.28.957-1.704 1.406-.211.223-.39.444-.52.651-.118.19-.238.436-.238.692 0 .256.12.502.239.692.129.207.308.428.519.651.424.449 1.014.944 1.704 1.406C6.333 13.665 8.182 14.5 10 14.5c1.819 0 3.667-.835 5.038-1.751a10.17 10.17 0 001.704-1.406c.211-.223.39-.444.52-.651.118-.19.238-.436.238-.692 0-.256-.12-.502-.239-.692a4.289 4.289 0 00-.519-.651 10.17 10.17 0 00-1.704-1.406C13.667 6.335 11.818 5.5 10 5.5zM10 8a2 2 0 100 4 2 2 0 000-4z", className: "gs-svg-icon-fill" }))));


/***/ }),

/***/ 3689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EyeIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var eyePath = "\nM3 10c0-1 3.64-5 7-5s7 4 7 5-3.64 5-7 5-7-4-7-5zm10 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-1 0a2 2 \n0 1 1-4 0 2 2 0 0 1 4 0z\n";
/**
 * Eye icon
 */
exports.EyeIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: eyePath })));


/***/ }),

/***/ 1251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FailedIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.FailedIcon = (0, icon_1.createIcon)(React.createElement("svg", { fill: "none", width: "20", height: "20", viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M6.8 2h6.4L18 6.8v6.4L13.2 18H6.8L2 13.2V6.8L6.8 2zm4.946 8.049l2.351-2.352L12.4 6l-2.352 2.352L7.699 6 6 7.697l2.351 2.352L6 12.4l1.697 1.697 2.352-2.351 2.351 2.351 1.697-1.697-2.351-2.351z" })));


/***/ }),

/***/ 416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FileIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * File icon
 */
exports.FileIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M4 18V1h9.086L16 3.914V18H4z", fill: "none", className: "gs-svg-icon-stroke", strokeWidth: "2" })));


/***/ }),

/***/ 7098:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FiltersIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Hopper icon */
exports.FiltersIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M3 4v1l6 6v6l2-1v-5l6-6V4H3z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 1711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FirstPageIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Left-pointing double chevrons */
exports.FirstPageIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M9 6l-4 4 4 4M14 6l-4 4 4 4", className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round" })));


/***/ }),

/***/ 4704:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.FocusIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1H1V7.5L4 7.5C4.27614 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.27614 8.5 4 8.5H1L1 15H7.5V12C7.5 11.7239 7.72386 11.5 8 11.5C8.27614 11.5 8.5 11.7239 8.5 12V15H15V8.5H12C11.7239 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.7239 7.5 12 7.5L15 7.5V1H8.5V4C8.5 4.27614 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.27614 7.5 4V1ZM0 0V16H16V0H0Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 6218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GearIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Gear icon
 */
exports.GearIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "m7.0667 5.8266l-1.9276-0.84639c-0.4913 0.47687-0.91468 1.0252-1.2539 1.6287l1.2501 1.7309c0.35347 0.48942 0.19597 1.1781-0.3351 1.4652l-1.8087 0.97788c0.06265 0.7198 0.23043 1.4089 0.48767 2.0515l2.0054 0.0826c0.60726 0.0251 1.052 0.5815 0.94247 1.1794l-0.36148 1.9735c0.55642 0.3819 1.1695 0.6851 1.8238 0.8939l1.3494-1.6481c0.40067-0.4893 1.1493-0.4885 1.5489 0.0017l1.3392 1.6431c0.6509-0.2089 1.261-0.5112 1.8148-0.8914l-0.3613-1.9727c-0.1095-0.5979 0.3352-1.1543 0.9424-1.1794l2.0041-0.0825c0.2573-0.6428 0.4252-1.3322 0.4878-2.0523l-1.8075-0.97718c-0.531-0.28711-0.6885-0.97575-0.3351-1.4652l1.2494-1.7299c-0.3393-0.60367-0.7627-1.1523-1.2541-1.6293l-1.9267 0.84598c-0.5611 0.24639-1.2099-0.06533-1.3681-0.65739l-0.5604-2.0964c-0.3295-0.04803-0.6665-0.07289-1.0092-0.07289-0.34215 0-0.67863 0.02479-1.0078 0.07268l-0.5604 2.0966c-0.15826 0.59206-0.80699 0.90378-1.3681 0.65739zm2.9333 6.1734c1.1046 0 2-0.8954 2-2 0-1.1046-0.8954-2-2-2-1.1046 0-2 0.89543-2 2 0 1.1046 0.89543 2 2 2z", clipRule: "evenodd", fillRule: "evenodd", fill: "#818181" })));


/***/ }),

/***/ 8640:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GenericFileIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Generic file icon
 */
exports.GenericFileIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("mask", { id: "a", maskUnits: "userSpaceOnUse", x: "3", y: "1", width: "14", height: "18" },
        React.createElement("path", { d: "M3 3v14a2 2 0 002 2h10a2 2 0 002-2V6.702a2 2 0 00-.438-1.25L13.6 1.751A2 2 0 0012.04 1H5a2 2 0 00-2 2z", fill: "#B0B5BF" })),
    React.createElement("g", { mask: "url(#a)" },
        React.createElement("path", { d: "M3 3v14a2 2 0 002 2h10a2 2 0 002-2V6.702a2 2 0 00-.438-1.25L13.6 1.751A2 2 0 0012.04 1H5a2 2 0 00-2 2z", fill: "#B0B5BF" }),
        React.createElement("path", { d: "M12 5V1h.52a1 1 0 01.78.375L17 6h-4a1 1 0 01-1-1z", fill: "#798091" })),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 16V6h1v10H4zm2-1V7h1v8H6zm2-7v6h1V8H8zm8 6V8h1v6h-1zm-6-5v4h1V9h-1zm4 4V9h1v4h-1zm-2-3v2h1v-2h-1z", fill: "#798091" })));


/***/ }),

/***/ 7764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/*
 * Copyright (c) 2011-2022 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MoreIcon = exports.MinusIcon = exports.MenuIcon = exports.LockOutlinedIcon = exports.LockIcon = exports.LinkIcon = exports.LastPageIcon = exports.KeyboardArrowRightIcon = exports.KeyboardArrowLeftIcon = exports.KeyboardArrowBottomIcon = exports.KebabIcon = exports.IntegerIcon = exports.InfoIcon = exports.GearIcon = exports.FirstPageIcon = exports.FiltersIcon = exports.FileIcon = exports.EyeEmptyIcon = exports.EyeIcon = exports.ExternalLinkIcon = exports.ExpandVerticalIcon = exports.DraftIcon = exports.DownloadIcon = exports.DockRightIcon = exports.DockBottomIcon = exports.DictionaryIcon = exports.DecimalIcon = exports.DateIcon = exports.CrossSmallIcon = exports.CrossIcon = exports.CollapseVerticalIcon = exports.ClearIcon = exports.CheckMarkIcon = exports.CheckedRadioIcon = exports.BulletIcon = exports.BoxplotIcon = exports.BooleanIcon = exports.BookmarkIcon = exports.BookmarkBorderedIcon = exports.ArrowRightThinIcon = exports.ArrowLeftThinIcon = exports.ArrowRightIcon = exports.ArrowLeftIcon = exports.ArrowDownloadThinIcon = exports.ArrowDownloadIcon = exports.ArrowBottomThinIcon = exports.StudyIcon = exports.SampleIcon = exports.TemplateIcon = exports.GenericFileIcon = void 0;
exports.RedoIcon = exports.UndoIcon = exports.EyeClosedIcon = exports.MinusCircledIcon = exports.PlusCircledIcon = exports.PathIcon = exports.FocusIcon = exports.StarIcon = exports.CompletedIcon = exports.WorkingCopyEdited = exports.PublishIcon = exports.FailedIcon = exports.WorkingCopyOwnIcon = exports.WorkingCopyIcon = exports.ChevronRightIcon = exports.ChevronDownIcon = exports.ListIcon = exports.InProgressIcon = exports.WidenIcon = exports.WarningIcon = exports.UserIcon = exports.UserGroupIcon = exports.UploadIcon = exports.TrashIcon = exports.TimeReverseIcon = exports.TextIcon = exports.StatisticsIcon = exports.StartEndIcon = exports.StopIcon = exports.SquareArrowsIcon = exports.SimpleFileIcon = exports.SharedWithUserIcon = exports.ShareIcon = exports.SearchIcon = exports.ReverseArrowsIcon = exports.RetryIcon = exports.RadioIcon = exports.QuestionGhostIcon = exports.QuestionIcon = exports.PlusUserIcon = exports.PlusIcon = exports.PlayIcon = exports.PlayCircledIcon = exports.PauseIcon = exports.OrganizationIcon = exports.OpenFolderIcon = exports.OntologyIcon = exports.NewTabIcon = exports.NarrowIcon = void 0;
var generic_file_icon_1 = __webpack_require__(8640);
Object.defineProperty(exports, "GenericFileIcon", ({ enumerable: true, get: function () { return generic_file_icon_1.GenericFileIcon; } }));
var template_icon_1 = __webpack_require__(3329);
Object.defineProperty(exports, "TemplateIcon", ({ enumerable: true, get: function () { return template_icon_1.TemplateIcon; } }));
var sample_icon_1 = __webpack_require__(4409);
Object.defineProperty(exports, "SampleIcon", ({ enumerable: true, get: function () { return sample_icon_1.SampleIcon; } }));
var study_icon_1 = __webpack_require__(3334);
Object.defineProperty(exports, "StudyIcon", ({ enumerable: true, get: function () { return study_icon_1.StudyIcon; } }));
var arrow_bottom_thin_icon_1 = __webpack_require__(8636);
Object.defineProperty(exports, "ArrowBottomThinIcon", ({ enumerable: true, get: function () { return arrow_bottom_thin_icon_1.ArrowBottomThinIcon; } }));
var arrow_download_icon_1 = __webpack_require__(607);
Object.defineProperty(exports, "ArrowDownloadIcon", ({ enumerable: true, get: function () { return arrow_download_icon_1.ArrowDownloadIcon; } }));
var arrow_download_thin_icon_1 = __webpack_require__(3851);
Object.defineProperty(exports, "ArrowDownloadThinIcon", ({ enumerable: true, get: function () { return arrow_download_thin_icon_1.ArrowDownloadThinIcon; } }));
var arrow_left_icon_1 = __webpack_require__(4303);
Object.defineProperty(exports, "ArrowLeftIcon", ({ enumerable: true, get: function () { return arrow_left_icon_1.ArrowLeftIcon; } }));
var arrow_right_icon_1 = __webpack_require__(4186);
Object.defineProperty(exports, "ArrowRightIcon", ({ enumerable: true, get: function () { return arrow_right_icon_1.ArrowRightIcon; } }));
var arrow_left_thin_icon_1 = __webpack_require__(1956);
Object.defineProperty(exports, "ArrowLeftThinIcon", ({ enumerable: true, get: function () { return arrow_left_thin_icon_1.ArrowLeftThinIcon; } }));
var arrow_right_thin_icon_1 = __webpack_require__(2720);
Object.defineProperty(exports, "ArrowRightThinIcon", ({ enumerable: true, get: function () { return arrow_right_thin_icon_1.ArrowRightThinIcon; } }));
var bookmark_bordered_icon_1 = __webpack_require__(7933);
Object.defineProperty(exports, "BookmarkBorderedIcon", ({ enumerable: true, get: function () { return bookmark_bordered_icon_1.BookmarkBorderedIcon; } }));
var bookmark_icon_1 = __webpack_require__(8552);
Object.defineProperty(exports, "BookmarkIcon", ({ enumerable: true, get: function () { return bookmark_icon_1.BookmarkIcon; } }));
var boolean_icon_1 = __webpack_require__(6835);
Object.defineProperty(exports, "BooleanIcon", ({ enumerable: true, get: function () { return boolean_icon_1.BooleanIcon; } }));
var boxplot_icon_1 = __webpack_require__(7722);
Object.defineProperty(exports, "BoxplotIcon", ({ enumerable: true, get: function () { return boxplot_icon_1.BoxplotIcon; } }));
var bullet_icon_1 = __webpack_require__(3216);
Object.defineProperty(exports, "BulletIcon", ({ enumerable: true, get: function () { return bullet_icon_1.BulletIcon; } }));
var checked_radio_icon_1 = __webpack_require__(6976);
Object.defineProperty(exports, "CheckedRadioIcon", ({ enumerable: true, get: function () { return checked_radio_icon_1.CheckedRadioIcon; } }));
var checkmark_icon_1 = __webpack_require__(1214);
Object.defineProperty(exports, "CheckMarkIcon", ({ enumerable: true, get: function () { return checkmark_icon_1.CheckMarkIcon; } }));
var clear_icon_1 = __webpack_require__(5516);
Object.defineProperty(exports, "ClearIcon", ({ enumerable: true, get: function () { return clear_icon_1.ClearIcon; } }));
var collapse_vertical_icon_1 = __webpack_require__(1091);
Object.defineProperty(exports, "CollapseVerticalIcon", ({ enumerable: true, get: function () { return collapse_vertical_icon_1.CollapseVerticalIcon; } }));
var cross_icon_1 = __webpack_require__(1433);
Object.defineProperty(exports, "CrossIcon", ({ enumerable: true, get: function () { return cross_icon_1.CrossIcon; } }));
var cross_small_icon_1 = __webpack_require__(3817);
Object.defineProperty(exports, "CrossSmallIcon", ({ enumerable: true, get: function () { return cross_small_icon_1.CrossSmallIcon; } }));
var date_icon_1 = __webpack_require__(6828);
Object.defineProperty(exports, "DateIcon", ({ enumerable: true, get: function () { return date_icon_1.DateIcon; } }));
var decimal_icon_1 = __webpack_require__(6829);
Object.defineProperty(exports, "DecimalIcon", ({ enumerable: true, get: function () { return decimal_icon_1.DecimalIcon; } }));
var dictionary_icon_1 = __webpack_require__(2213);
Object.defineProperty(exports, "DictionaryIcon", ({ enumerable: true, get: function () { return dictionary_icon_1.DictionaryIcon; } }));
var dock_bottom_icon_1 = __webpack_require__(1737);
Object.defineProperty(exports, "DockBottomIcon", ({ enumerable: true, get: function () { return dock_bottom_icon_1.DockBottomIcon; } }));
var dock_right_icon_1 = __webpack_require__(3136);
Object.defineProperty(exports, "DockRightIcon", ({ enumerable: true, get: function () { return dock_right_icon_1.DockRightIcon; } }));
var download_icon_1 = __webpack_require__(3168);
Object.defineProperty(exports, "DownloadIcon", ({ enumerable: true, get: function () { return download_icon_1.DownloadIcon; } }));
var draft_icon_1 = __webpack_require__(7223);
Object.defineProperty(exports, "DraftIcon", ({ enumerable: true, get: function () { return draft_icon_1.DraftIcon; } }));
var expand_vertical_icon_1 = __webpack_require__(1911);
Object.defineProperty(exports, "ExpandVerticalIcon", ({ enumerable: true, get: function () { return expand_vertical_icon_1.ExpandVerticalIcon; } }));
var external_link_1 = __webpack_require__(5008);
Object.defineProperty(exports, "ExternalLinkIcon", ({ enumerable: true, get: function () { return external_link_1.ExternalLinkIcon; } }));
var eye_icon_1 = __webpack_require__(3689);
Object.defineProperty(exports, "EyeIcon", ({ enumerable: true, get: function () { return eye_icon_1.EyeIcon; } }));
var eye_empty_icon_1 = __webpack_require__(3813);
Object.defineProperty(exports, "EyeEmptyIcon", ({ enumerable: true, get: function () { return eye_empty_icon_1.EyeEmptyIcon; } }));
var file_icon_1 = __webpack_require__(416);
Object.defineProperty(exports, "FileIcon", ({ enumerable: true, get: function () { return file_icon_1.FileIcon; } }));
var filters_icon_1 = __webpack_require__(7098);
Object.defineProperty(exports, "FiltersIcon", ({ enumerable: true, get: function () { return filters_icon_1.FiltersIcon; } }));
var first_page_icon_1 = __webpack_require__(1711);
Object.defineProperty(exports, "FirstPageIcon", ({ enumerable: true, get: function () { return first_page_icon_1.FirstPageIcon; } }));
var gear_icon_1 = __webpack_require__(6218);
Object.defineProperty(exports, "GearIcon", ({ enumerable: true, get: function () { return gear_icon_1.GearIcon; } }));
var info_icon_1 = __webpack_require__(9972);
Object.defineProperty(exports, "InfoIcon", ({ enumerable: true, get: function () { return info_icon_1.InfoIcon; } }));
var integer_icon_1 = __webpack_require__(8755);
Object.defineProperty(exports, "IntegerIcon", ({ enumerable: true, get: function () { return integer_icon_1.IntegerIcon; } }));
var kebab_icon_1 = __webpack_require__(3863);
Object.defineProperty(exports, "KebabIcon", ({ enumerable: true, get: function () { return kebab_icon_1.KebabIcon; } }));
var keyboard_arrow_bottom_icon_1 = __webpack_require__(2591);
Object.defineProperty(exports, "KeyboardArrowBottomIcon", ({ enumerable: true, get: function () { return keyboard_arrow_bottom_icon_1.KeyboardArrowBottomIcon; } }));
var keyboard_arrow_left_icon_1 = __webpack_require__(4774);
Object.defineProperty(exports, "KeyboardArrowLeftIcon", ({ enumerable: true, get: function () { return keyboard_arrow_left_icon_1.KeyboardArrowLeftIcon; } }));
var keyboard_arrow_right_icon_1 = __webpack_require__(1140);
Object.defineProperty(exports, "KeyboardArrowRightIcon", ({ enumerable: true, get: function () { return keyboard_arrow_right_icon_1.KeyboardArrowRightIcon; } }));
var last_page_icon_1 = __webpack_require__(5882);
Object.defineProperty(exports, "LastPageIcon", ({ enumerable: true, get: function () { return last_page_icon_1.LastPageIcon; } }));
var link_icon_1 = __webpack_require__(4852);
Object.defineProperty(exports, "LinkIcon", ({ enumerable: true, get: function () { return link_icon_1.LinkIcon; } }));
var lock_icon_1 = __webpack_require__(5731);
Object.defineProperty(exports, "LockIcon", ({ enumerable: true, get: function () { return lock_icon_1.LockIcon; } }));
var lock_outlined_icon_1 = __webpack_require__(6793);
Object.defineProperty(exports, "LockOutlinedIcon", ({ enumerable: true, get: function () { return lock_outlined_icon_1.LockOutlinedIcon; } }));
var menu_icon_1 = __webpack_require__(830);
Object.defineProperty(exports, "MenuIcon", ({ enumerable: true, get: function () { return menu_icon_1.MenuIcon; } }));
var minus_icon_1 = __webpack_require__(5512);
Object.defineProperty(exports, "MinusIcon", ({ enumerable: true, get: function () { return minus_icon_1.MinusIcon; } }));
var more_icon_1 = __webpack_require__(4192);
Object.defineProperty(exports, "MoreIcon", ({ enumerable: true, get: function () { return more_icon_1.MoreIcon; } }));
var narrow_icon_1 = __webpack_require__(7519);
Object.defineProperty(exports, "NarrowIcon", ({ enumerable: true, get: function () { return narrow_icon_1.NarrowIcon; } }));
var new_tab_1 = __webpack_require__(718);
Object.defineProperty(exports, "NewTabIcon", ({ enumerable: true, get: function () { return new_tab_1.NewTabIcon; } }));
var ontology_icon_1 = __webpack_require__(703);
Object.defineProperty(exports, "OntologyIcon", ({ enumerable: true, get: function () { return ontology_icon_1.OntologyIcon; } }));
var open_folder_icon_1 = __webpack_require__(7407);
Object.defineProperty(exports, "OpenFolderIcon", ({ enumerable: true, get: function () { return open_folder_icon_1.OpenFolderIcon; } }));
var organization_icon_1 = __webpack_require__(2283);
Object.defineProperty(exports, "OrganizationIcon", ({ enumerable: true, get: function () { return organization_icon_1.OrganizationIcon; } }));
var pause_icon_1 = __webpack_require__(8635);
Object.defineProperty(exports, "PauseIcon", ({ enumerable: true, get: function () { return pause_icon_1.PauseIcon; } }));
var play_circled_icon_1 = __webpack_require__(6790);
Object.defineProperty(exports, "PlayCircledIcon", ({ enumerable: true, get: function () { return play_circled_icon_1.PlayCircledIcon; } }));
var play_icon_1 = __webpack_require__(3083);
Object.defineProperty(exports, "PlayIcon", ({ enumerable: true, get: function () { return play_icon_1.PlayIcon; } }));
var plus_icon_1 = __webpack_require__(1789);
Object.defineProperty(exports, "PlusIcon", ({ enumerable: true, get: function () { return plus_icon_1.PlusIcon; } }));
var plus_user_icon_1 = __webpack_require__(4215);
Object.defineProperty(exports, "PlusUserIcon", ({ enumerable: true, get: function () { return plus_user_icon_1.PlusUserIcon; } }));
var question_icon_1 = __webpack_require__(901);
Object.defineProperty(exports, "QuestionIcon", ({ enumerable: true, get: function () { return question_icon_1.QuestionIcon; } }));
var question_ghost_icon_1 = __webpack_require__(964);
Object.defineProperty(exports, "QuestionGhostIcon", ({ enumerable: true, get: function () { return question_ghost_icon_1.QuestionGhostIcon; } }));
var radio_icon_1 = __webpack_require__(9382);
Object.defineProperty(exports, "RadioIcon", ({ enumerable: true, get: function () { return radio_icon_1.RadioIcon; } }));
var retry_icon_1 = __webpack_require__(5552);
Object.defineProperty(exports, "RetryIcon", ({ enumerable: true, get: function () { return retry_icon_1.RetryIcon; } }));
var reverse_arrows_icon_1 = __webpack_require__(5044);
Object.defineProperty(exports, "ReverseArrowsIcon", ({ enumerable: true, get: function () { return reverse_arrows_icon_1.ReverseArrowsIcon; } }));
var search_icon_1 = __webpack_require__(3483);
Object.defineProperty(exports, "SearchIcon", ({ enumerable: true, get: function () { return search_icon_1.SearchIcon; } }));
var share_icon_1 = __webpack_require__(7972);
Object.defineProperty(exports, "ShareIcon", ({ enumerable: true, get: function () { return share_icon_1.ShareIcon; } }));
var shared_with_user_icon_1 = __webpack_require__(3546);
Object.defineProperty(exports, "SharedWithUserIcon", ({ enumerable: true, get: function () { return shared_with_user_icon_1.SharedWithUserIcon; } }));
var simple_file_icon_1 = __webpack_require__(7995);
Object.defineProperty(exports, "SimpleFileIcon", ({ enumerable: true, get: function () { return simple_file_icon_1.SimpleFileIcon; } }));
var square_arrows_icon_1 = __webpack_require__(596);
Object.defineProperty(exports, "SquareArrowsIcon", ({ enumerable: true, get: function () { return square_arrows_icon_1.SquareArrowsIcon; } }));
var stop_icon_1 = __webpack_require__(4173);
Object.defineProperty(exports, "StopIcon", ({ enumerable: true, get: function () { return stop_icon_1.StopIcon; } }));
var start_end_icon_1 = __webpack_require__(3834);
Object.defineProperty(exports, "StartEndIcon", ({ enumerable: true, get: function () { return start_end_icon_1.StartEndIcon; } }));
var statistics_icon_1 = __webpack_require__(3103);
Object.defineProperty(exports, "StatisticsIcon", ({ enumerable: true, get: function () { return statistics_icon_1.StatisticsIcon; } }));
var text_icon_1 = __webpack_require__(3196);
Object.defineProperty(exports, "TextIcon", ({ enumerable: true, get: function () { return text_icon_1.TextIcon; } }));
var time_reverse_icon_1 = __webpack_require__(4848);
Object.defineProperty(exports, "TimeReverseIcon", ({ enumerable: true, get: function () { return time_reverse_icon_1.TimeReverseIcon; } }));
var trash_icon_1 = __webpack_require__(4193);
Object.defineProperty(exports, "TrashIcon", ({ enumerable: true, get: function () { return trash_icon_1.TrashIcon; } }));
var upload_icon_1 = __webpack_require__(8777);
Object.defineProperty(exports, "UploadIcon", ({ enumerable: true, get: function () { return upload_icon_1.UploadIcon; } }));
var user_group_icon_1 = __webpack_require__(2081);
Object.defineProperty(exports, "UserGroupIcon", ({ enumerable: true, get: function () { return user_group_icon_1.UserGroupIcon; } }));
var user_icon_1 = __webpack_require__(7725);
Object.defineProperty(exports, "UserIcon", ({ enumerable: true, get: function () { return user_icon_1.UserIcon; } }));
var warning_icon_1 = __webpack_require__(8031);
Object.defineProperty(exports, "WarningIcon", ({ enumerable: true, get: function () { return warning_icon_1.WarningIcon; } }));
var widen_icon_1 = __webpack_require__(9265);
Object.defineProperty(exports, "WidenIcon", ({ enumerable: true, get: function () { return widen_icon_1.WidenIcon; } }));
var in_progress_icon_1 = __webpack_require__(393);
Object.defineProperty(exports, "InProgressIcon", ({ enumerable: true, get: function () { return in_progress_icon_1.InProgressIcon; } }));
var list_icon_1 = __webpack_require__(3910);
Object.defineProperty(exports, "ListIcon", ({ enumerable: true, get: function () { return list_icon_1.ListIcon; } }));
var chevron_down_icon_1 = __webpack_require__(4628);
Object.defineProperty(exports, "ChevronDownIcon", ({ enumerable: true, get: function () { return chevron_down_icon_1.ChevronDownIcon; } }));
var chevron_right_icon_1 = __webpack_require__(816);
Object.defineProperty(exports, "ChevronRightIcon", ({ enumerable: true, get: function () { return chevron_right_icon_1.ChevronRightIcon; } }));
var working_copy_icon_1 = __webpack_require__(2772);
Object.defineProperty(exports, "WorkingCopyIcon", ({ enumerable: true, get: function () { return working_copy_icon_1.WorkingCopyIcon; } }));
var working_copy_own_icon_1 = __webpack_require__(3616);
Object.defineProperty(exports, "WorkingCopyOwnIcon", ({ enumerable: true, get: function () { return working_copy_own_icon_1.WorkingCopyOwnIcon; } }));
var failed_icon_1 = __webpack_require__(1251);
Object.defineProperty(exports, "FailedIcon", ({ enumerable: true, get: function () { return failed_icon_1.FailedIcon; } }));
var publish_icon_1 = __webpack_require__(3339);
Object.defineProperty(exports, "PublishIcon", ({ enumerable: true, get: function () { return publish_icon_1.PublishIcon; } }));
var working_copy_edited_1 = __webpack_require__(1026);
Object.defineProperty(exports, "WorkingCopyEdited", ({ enumerable: true, get: function () { return working_copy_edited_1.WorkingCopyEdited; } }));
var completed_icon_1 = __webpack_require__(2698);
Object.defineProperty(exports, "CompletedIcon", ({ enumerable: true, get: function () { return completed_icon_1.CompletedIcon; } }));
var star_icon_1 = __webpack_require__(516);
Object.defineProperty(exports, "StarIcon", ({ enumerable: true, get: function () { return star_icon_1.StarIcon; } }));
var focus_icon_1 = __webpack_require__(4704);
Object.defineProperty(exports, "FocusIcon", ({ enumerable: true, get: function () { return focus_icon_1.FocusIcon; } }));
var path_icon_1 = __webpack_require__(1130);
Object.defineProperty(exports, "PathIcon", ({ enumerable: true, get: function () { return path_icon_1.PathIcon; } }));
var plus_circled_icon_1 = __webpack_require__(2907);
Object.defineProperty(exports, "PlusCircledIcon", ({ enumerable: true, get: function () { return plus_circled_icon_1.PlusCircledIcon; } }));
var minus_circled_icon_1 = __webpack_require__(2173);
Object.defineProperty(exports, "MinusCircledIcon", ({ enumerable: true, get: function () { return minus_circled_icon_1.MinusCircledIcon; } }));
var eye_closed_icon_1 = __webpack_require__(1111);
Object.defineProperty(exports, "EyeClosedIcon", ({ enumerable: true, get: function () { return eye_closed_icon_1.EyeClosedIcon; } }));
var undo_icon_1 = __webpack_require__(4071);
Object.defineProperty(exports, "UndoIcon", ({ enumerable: true, get: function () { return undo_icon_1.UndoIcon; } }));
var redo_icon_1 = __webpack_require__(7150);
Object.defineProperty(exports, "RedoIcon", ({ enumerable: true, get: function () { return redo_icon_1.RedoIcon; } }));


/***/ }),

/***/ 393:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InProgressIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var react_1 = __importDefault(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * In-progress icon
 */
exports.InProgressIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "-5 -3 20 20", className: "gs-svg-icon-fill", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.5C0 0.223858 0.223858 0 0.5 0H9.5C9.77614 0 10 0.223858 10 0.5C10 0.776142 9.77614 1 9.5 1H9C9 2.04267 8.86964 2.87007 8.51768 3.64439C8.16859 4.41241 7.61958 5.08753 6.85355 5.85355C6.65829 6.04882 6.34171 6.04882 6.14645 5.85355C5.95118 5.65829 5.95118 5.34171 6.14645 5.14645C6.19597 5.09693 6.2442 5.04813 6.29118 5H5.5C5.22386 5 5 4.77614 5 4.5C5 4.22386 5.22386 4 5.5 4H6.5H6.5004H7C7.04837 4 7.09514 4.00687 7.13938 4.01969C7.33436 3.75225 7.48738 3.49446 7.60732 3.23059C7.64167 3.15501 7.6736 3.07829 7.70317 3H5C4.72386 3 4.5 2.77614 4.5 2.5C4.5 2.22386 4.72386 2 5 2H7.94375C7.98191 1.70137 8 1.3722 8 1H2C2.00002 3.80672 3.38948 5.63572 5.22361 6.55279C7.38946 7.63571 9 9.80669 9 13H9.5C9.77614 13 10 13.2239 10 13.5C10 13.7761 9.77614 14 9.5 14H0.5C0.223858 14 0 13.7761 0 13.5C0 13.2239 0.223858 13 0.5 13H1C1 11.9573 1.13035 11.1299 1.48232 10.3555C1.83141 9.58753 2.38042 8.91241 3.14645 8.14639C3.34171 7.95112 3.65829 7.95112 3.85355 8.14639C4.04882 8.34165 4.04882 8.65823 3.85355 8.85349C3.11958 9.58747 2.66859 10.1624 2.39268 10.7693C2.35833 10.8449 2.3264 10.9217 2.29683 10.9999H5C5.27614 10.9999 5.5 11.2238 5.5 11.4999C5.5 11.7761 5.27614 11.9999 5 11.9999H2.05625C2.01809 12.2986 2 12.6278 2 13H8C8 10.1933 6.61054 8.36429 4.77639 7.44721C2.61055 6.36429 1.00002 4.19333 1 1H0.5C0.223858 1 0 0.776142 0 0.5Z" })));


/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(7764), exports);


/***/ }),

/***/ 9972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InfoIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * This is `i` letter in a circle icon
 */
exports.InfoIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm1-10a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2.5 7a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5v-2.293a.5.5 0 0 0-.146-.353A.5.5 0 0 1 9.207 9h1.586a.5.5 0 0 1 .353.854.5.5 0 0 0-.146.353V12.5a.5.5 0 0 0 .5.5.5.5 0 0 1 0 1h-3z" })));


/***/ }),

/***/ 8755:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IntegerIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Integer Icon
 */
exports.IntegerIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M13 7.5H16.5V10.5M13 13.5H16.5V10.5M16.5 10.5H14", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M5.5 13.5V7.5H4M5.5 13.5H3M5.5 13.5H7", className: "gs-svg-icon-stroke" }),
    React.createElement("path", { d: "M8.5 8V7.5H11.5V10.5H8.5V13.5H12", className: "gs-svg-icon-stroke" })));


/***/ }),

/***/ 3863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.KebabIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Kebab Icon
 */
exports.KebabIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM10 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 2591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.KeyboardArrowBottomIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Keyboard arrow key icon shows user possible transformation direction
 * after some interaction has applied.
 */
exports.KeyboardArrowBottomIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M10.354 11.354L13 8.707l.293.293L10 12.293 6.707 9 7 8.707l2.646 2.647.354.353.354-.353z", fill: "none", className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round" })));


/***/ }),

/***/ 4774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.KeyboardArrowLeftIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Keyboard Left Icon (aka chevron turned left, aka >) icon
 */
exports.KeyboardArrowLeftIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M12 6L8 10L12 14", fill: "none", className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round" })));


/***/ }),

/***/ 1140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.KeyboardArrowRightIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Keyboard arrow key icon shows user possible transformation direction
 * after some interaction has applied.
 */
exports.KeyboardArrowRightIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M9 14l4-4-4-4", fill: "none", className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round" })));


/***/ }),

/***/ 5882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LastPageIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Right-pointing double chevrons */
exports.LastPageIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M6 14l4-4-4-4M11 14l4-4-4-4", className: "gs-svg-icon-stroke", strokeWidth: "1.5", strokeLinecap: "round" })));


/***/ }),

/***/ 4852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Link Icon
 */
exports.LinkIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M6.5 8.5H5.5C4.39543 8.5 3.5 9.39543 3.5 10.5V10.5C3.5 11.6046 4.39543 12.5 5.5 12.5H9.79289C10.2456 12.5 10.6799 12.3201 11 12V12C11.3201 11.6799 11.5 11.2456 11.5 10.7929V10.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" }),
    React.createElement("path", { d: "M13.5 12.5L14.5 12.5C15.6046 12.5 16.5 11.6046 16.5 10.5V10.5C16.5 9.39543 15.6046 8.5 14.5 8.5L10.2071 8.5C9.75435 8.5 9.32015 8.67985 9 9V9C8.67986 9.32014 8.5 9.75435 8.5 10.2071L8.5 10.5", className: "gs-svg-icon-stroke", strokeLinecap: "round" })));


/***/ }),

/***/ 3910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.ListIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 12H17", stroke: "#6A7EA7", strokeLinecap: "round" }),
    React.createElement("path", { d: "M7 12H9", stroke: "#6A7EA7", strokeLinecap: "round" }),
    React.createElement("path", { d: "M11 8H17", stroke: "#6A7EA7", strokeLinecap: "round" }),
    React.createElement("path", { d: "M7 8H9", stroke: "#6A7EA7", strokeLinecap: "round" }),
    React.createElement("path", { d: "M11 16H17", stroke: "#6A7EA7", strokeLinecap: "round" }),
    React.createElement("path", { d: "M7 16H9", stroke: "#6A7EA7", strokeLinecap: "round" })));


/***/ }),

/***/ 5731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LockIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Lock Icon
 */
exports.LockIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 7v2h1v7H5V9h1V7c0-1.5 2-3 4-3s4 1.5 4 3zM8 9h4V7.8c0-.994-.895-1.8-2-1.8s-2 .806-2 1.8V9z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 6793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LockOutlinedIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Lock Outlined Icon
 */
exports.LockOutlinedIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.31187 3.38323C8.75201 3.13871 9.30805 3 10 3C10.692 3 11.248 3.13871 11.6881 3.38323C12.1306 3.62905 12.4284 3.96662 12.6246 4.31968C13.0003 4.99605 13.0001 5.7283 13 5.98869C13 5.99257 13 5.99634 13 6V8H14C14.5523 8 15 8.44772 15 9V15C15 15.5523 14.5523 16 14 16H6C5.44772 16 5 15.5523 5 15V9C5 8.44772 5.44772 8 6 8H7V6C7 5.99634 7 5.99257 7 5.98869C6.99991 5.72829 6.99966 4.99605 7.37542 4.31968C7.57157 3.96662 7.8694 3.62905 8.31187 3.38323ZM8 8H12V6C12 5.74991 11.9941 5.24389 11.7504 4.80532C11.6341 4.59588 11.4632 4.4022 11.2025 4.25739C10.9395 4.11129 10.558 4 10 4C9.44195 4 9.06049 4.11129 8.79751 4.25739C8.53685 4.4022 8.36593 4.59588 8.24958 4.80532C8.00593 5.24389 8 5.74991 8 6V8ZM7.5 9H6V15H14V9H12.5H7.5Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { d: "M9 14H10V12H11V11H9V14Z", fillRule: "evenodd", clipRule: "evenodd", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 830:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Menu icon is used dock
 */
exports.MenuIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5H18V7H2V5ZM2 9H18V11H2V9ZM18 13H2V15H18V13Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 2173:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MinusCircledIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.MinusCircledIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM16 12.5C16.2761 12.5 16.5 12.2761 16.5 12C16.5 11.7239 16.2761 11.5 16 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5H16Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 5512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MinusIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var react_1 = __importDefault(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Minus icon */
exports.MinusIcon = (0, icon_1.createIcon)(react_1.default.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    react_1.default.createElement("path", { d: "M5 10H15", className: "gs-svg-icon-stroke", strokeLinecap: "round" })));


/***/ }),

/***/ 4192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MoreIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * More Icon
 */
exports.MoreIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-5.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm9.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 7519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NarrowIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Narrow Icon
 */
exports.NarrowIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.646 12.646a.5.5 0 00.708.708L9.207 10.5 6.354 7.646a.5.5 0 10-.708.708L7.293 10H3.5a.5.5 0 000 1h3.793l-1.647 1.646zM12.207 10l1.647-1.646a.5.5 0 00-.708-.708L10.293 10.5l2.853 2.854a.5.5 0 00.708-.708L12.207 11H16.5a.5.5 0 000-1h-4.293z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NewTabIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * New Tab Icon
 */
exports.NewTabIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M8 5V4h4V3H8c-1 0-1 .5-1 1v8c0 .5.5 1 1 1h8c.5 0 1-.5 1-1V8h-1v4H8V5zM5 15h9v-1h1v1c0 .5-.5 1-1 1H5c-.5 0-1-.5-1-1V7c0-.5.5-1 1-1h1v1H5v8zm12-8h-1V5l-1 1-3.293 3.293L11 10l-.293-.293-.414-.414L10 9l.707-.707L14 5l1-1h-2V3h4v4z" })));


/***/ }),

/***/ 703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OntologyIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Ontology Icon
 */
exports.OntologyIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M4 4H9V6H4V4ZM6 10.5V7H7V10H9V11H6.5H6V10.5ZM6 12V15.5V16H6.5H9V15H7V12H6ZM10 9H15V11H10V9ZM15 14H10V16H15V14Z" })));


/***/ }),

/***/ 7407:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OpenFolderIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Open folder icon
 */
exports.OpenFolderIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { 
        // fillRule="evenodd"
        // clipRule="evenodd"
        d: "M13.19 7.757L14.5 13l2.094-6.702A1 1 0 0 0 15.64 5H5.78a1 1 0 0 0-.97 1.243L5 7h7.22a1 1 0 0 1 .97.757zM2.363 9.275A1 1 0 0 1 3.326 8h7.92a1 1 0 0 1 .961.725l1.429 5A1 1 0 0 1 12.674 15h-7.92a1 1 0 0 1-.961-.725l-1.429-5zm1.11.369A.5.5 0 0 1 3.953 9h6.894a.5.5 0 0 1 .48.356l1.2 4a.5.5 0 0 1-.48.644H5.153a.5.5 0 0 1-.479-.356l-1.2-4z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 2283:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OrganizationIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Building icon
 */
exports.OrganizationIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3V4H7C6.44772 4 6 4.44772 6 5V16H4V17H6.5H14.5H17V16H15V5C15 4.44772 14.5523 4 14 4H13V3H8ZM11 16H7V5L14 5V16H13V12.5C13 12.2239 12.7761 12 12.5 12H11.5C11.2239 12 11 12.2239 11 12.5V16ZM8 6.5C8 6.22386 8.22386 6 8.5 6H9.5C9.77614 6 10 6.22386 10 6.5V7.5C10 7.77614 9.77614 8 9.5 8H8.5C8.22386 8 8 7.77614 8 7.5V6.5ZM11.5 6C11.2239 6 11 6.22386 11 6.5V7.5C11 7.77614 11.2239 8 11.5 8H12.5C12.7761 8 13 7.77614 13 7.5V6.5C13 6.22386 12.7761 6 12.5 6H11.5ZM11 9.5C11 9.22386 11.2239 9 11.5 9H12.5C12.7761 9 13 9.22386 13 9.5V10.5C13 10.7761 12.7761 11 12.5 11H11.5C11.2239 11 11 10.7761 11 10.5V9.5ZM8 9.5C8 9.22386 8.22386 9 8.5 9H9.5C9.77614 9 10 9.22386 10 9.5V10.5C10 10.7761 9.77614 11 9.5 11H8.5C8.22386 11 8 10.7761 8 10.5V9.5ZM8.5 12C8.22386 12 8 12.2239 8 12.5V13.5C8 13.7761 8.22386 14 8.5 14H9.5C9.77614 14 10 13.7761 10 13.5V12.5C10 12.2239 9.77614 12 9.5 12H8.5Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 1130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PathIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.PathIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.5C3 3.67157 3.67157 3 4.5 3C5.15311 3 5.70873 3.4174 5.91465 4C5.91687 4.00628 5.91905 4.01259 5.92119 4.01891C5.97229 4.16992 6 4.33173 6 4.5C6 4.67532 5.96992 4.84361 5.91465 5C5.70873 5.5826 5.15311 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.0854 11C10.2913 10.4174 10.8469 10 11.5 10C12.3284 10 13 10.6716 13 11.5C13 12.3284 12.3284 13 11.5 13C10.8469 13 10.2913 12.5826 10.0854 12C10.0831 11.9937 10.081 11.9874 10.0788 11.9811C10.0277 11.8301 10 11.6683 10 11.5C10 11.3247 10.0301 11.1564 10.0854 11ZM6.94999 5L10.75 5C11.4404 5 12 5.55964 12 6.25C12 6.94036 11.4404 7.5 10.75 7.5H5.25C4.00736 7.5 3 8.50736 3 9.75C3 10.9926 4.00736 12 5.25 12H9.05001C9.01722 11.8384 9 11.6712 9 11.5C9 11.3288 9.01722 11.1616 9.05001 11H5.25C4.55964 11 4 10.4404 4 9.75C4 9.05964 4.55964 8.5 5.25 8.5H10.75C11.9926 8.5 13 7.49264 13 6.25C13 5.00736 11.9926 4 10.75 4H6.94999C6.98278 4.16155 7 4.32877 7 4.5C7 4.67123 6.98278 4.83844 6.94999 5Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 8635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PauseIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Pause Icon
 */
exports.PauseIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M5 5h3v10H5zM11 5h3v10h-3z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 6790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlayCircledIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Triangle icon in a circle
 */
exports.PlayCircledIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM8.777 6.518A.5.5 0 0 0 8 6.934v6.132a.5.5 0 0 0 .777.416l4.599-3.066a.5.5 0 0 0 0-.832L8.777 6.518z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlayIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Play Icon
 */
exports.PlayIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M15 10.196l-9 5.196V5l9 5.196z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 2907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlusCircledIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.PlusCircledIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 8C12.5 7.72386 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.72386 11.5 8V11.5H8C7.72386 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5H11.5V16C11.5 16.2761 11.7239 16.5 12 16.5C12.2761 16.5 12.5 16.2761 12.5 16V12.5H16C16.2761 12.5 16.5 12.2761 16.5 12C16.5 11.7239 16.2761 11.5 16 11.5H12.5V8Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 1789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlusIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var plusPath = "\nM10 4a1 1 0 0 0-1 1v4H5a1 1 0 0 0 0 2h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4V5a1 1 0 0 0-1-1z\n";
/**
 * Plus icon
 */
exports.PlusIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: plusPath })));


/***/ }),

/***/ 4215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PlusUserIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * User icon and plus sign at the left top corner
 */
exports.PlusUserIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.4 13.6C7.2 14.2 6 14.8 6 16h12c0-1.2-1.2-1.8-2.4-2.4-1.2-.6-2.602-.857-2.602-1.886 0-1.028.5-1.028.998-1.543.5-.514.999-1.542.999-3.085C14.995 5.029 13.654 4 12 4c-1.654 0-2.995 1.382-2.995 3.086 0 1.543.5 2.571.998 3.085.5.515.999.515.999 1.543C11.002 12.743 9.6 13 8.4 13.6z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 7H4v2H2v2h2v2h2v-2h2V9H6V7z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PublishIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.PublishIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M11 3.5H13.5C14.0523 3.5 14.5 3.94772 14.5 4.5V5M5.58823 13V15.5C5.58823 16.0523 6.03595 16.5 6.58823 16.5H13.5C14.0523 16.5 14.5 16.0523 14.5 15.5V12", stroke: "rgba(129, 129, 129, 1)" }),
    React.createElement("path", { d: "M9.20581 3.5H8.9806C8.83715 3.5 8.7006 3.56162 8.60569 3.66919L5.62498 7.04727C5.54437 7.13863 5.49989 7.25628 5.4999 7.37811L5.4999 7.5H8.70581C8.98195 7.5 9.20581 7.27614 9.20581 7V3.5Z", stroke: "rgba(129, 129, 129, 1)" }),
    React.createElement("path", { d: "M6 10L9.5 13.5L16 7", stroke: "rgba(129, 129, 129, 1)", strokeWidth: "2", strokeLinecap: "round" })));


/***/ }),

/***/ 964:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QuestionGhostIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Question Ghost Icon
 */
exports.QuestionGhostIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 10a6 6 0 11-12 0 6 6 0 0112 0zm1 0a7 7 0 11-14 0 7 7 0 0114 0zM9.08 7.27c-.19.146-.33.364-.33.73a.75.75 0 01-1.5 0c0-.837.36-1.494.92-1.922C8.703 5.67 9.374 5.5 10 5.5c.638 0 1.308.188 1.837.6.547.428.913 1.08.913 1.9 0 1.13-.78 1.712-1.25 2.062l-.05.038c-.538.404-.7.57-.7.9h-1.5c0-1.13.78-1.712 1.25-2.062l.05-.038c.538-.404.7-.57.7-.9 0-.335-.134-.56-.337-.718C10.692 7.11 10.363 7 10 7c-.375 0-.704.104-.92.27zM11 13a1 1 0 11-2 0 1 1 0 012 0z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QuestionIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Question Icon
 */
exports.QuestionIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM9.08093 7.26933C8.88965 7.41579 8.75 7.63395 8.75 8C8.75 8.41421 8.41421 8.75 8 8.75C7.58579 8.75 7.25 8.41421 7.25 8C7.25 7.16292 7.61035 6.50609 8.16907 6.07832C8.70367 5.66902 9.37544 5.5 10 5.5C10.6379 5.5 11.3084 5.68762 11.8367 6.10039C12.3841 6.52805 12.75 7.17918 12.75 8C12.75 9.12936 11.9699 9.7118 11.5003 10.0624L11.45 10.1C10.9117 10.5037 10.75 10.6707 10.75 11H9.25C9.25 9.87064 10.0301 9.2882 10.4997 8.93758L10.55 8.9C11.0883 8.4963 11.25 8.32931 11.25 8C11.25 7.66457 11.1159 7.4407 10.9133 7.28242C10.6916 7.10926 10.3621 7 10 7C9.62456 7 9.29633 7.10442 9.08093 7.26933ZM11 13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 9382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RadioIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Just a ring.
 * Looks like unchecked radio button.
 */
exports.RadioIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none" },
    React.createElement("circle", { cx: "10", cy: "10", r: "8", className: "gs-svg-icon-stroke", strokeWidth: "1" })));


/***/ }),

/***/ 7150:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RedoIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.RedoIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11.7957 7.00004L9.50285 4.70714C9.30759 4.51188 9.30759 4.1953 9.50285 4.00004C9.69812 3.80478 10.0147 3.80478 10.21 4.00004L13.71 7.50004L10.21 11C10.0147 11.1953 9.69812 11.1953 9.50285 11C9.30759 10.8048 9.30759 10.4882 9.50285 10.2929L11.7957 8.00004H9.00285C7.97395 8.00004 6.96181 8.00802 6.19981 8.33459C5.83662 8.49024 5.5494 8.71192 5.34785 9.03204C5.1444 9.35516 5.00285 9.81902 5.00285 10.5V12H4.00285V10.5C4.00285 9.68102 4.1738 9.01987 4.50161 8.49923C4.83131 7.9756 5.29409 7.63478 5.8059 7.41544C6.77596 6.99971 7.98691 6.99989 8.94971 7.00003L11.7957 7.00004Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 5552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RetryIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Retry Icon
 */
exports.RetryIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 7.022V9.5L14 6L10 2.5V5C8.75649 4.99998 7.54131 5.3865 6.52431 6.10923C5.43892 6.88058 4.64095 7.99108 4.25608 9.26581C3.87122 10.5405 3.92133 11.9071 4.39852 13.1502C4.87571 14.3933 5.75286 15.4424 6.89184 16.1322C8.03081 16.822 9.36688 17.1133 10.6896 16.9602C12.0124 16.8072 13.2466 16.2185 14.198 15.2868C15.1493 14.3552 15.7638 13.1335 15.9445 11.8143C16.1252 10.495 15.8619 9.15317 15.1962 8L13.4451 9.011C13.8865 9.77555 14.061 10.6652 13.9412 11.5399C13.8214 12.4145 13.414 13.2245 12.7833 13.8422C12.1525 14.4599 11.3342 14.8502 10.4572 14.9516C9.58024 15.0531 8.69443 14.86 7.93929 14.4026C7.18415 13.9453 6.60259 13.2498 6.28622 12.4256C5.96984 11.6014 5.93662 10.6954 6.19178 9.85023C6.44695 9.00508 6.976 8.26883 7.69562 7.75742C8.36989 7.27825 9.17555 7.02199 10 7.022Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 5044:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReverseArrowsIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Revers arrows icon */
exports.ReverseArrowsIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", fillRule: "evenodd", clipRule: "evenodd", d: "M3.14652 7.14645L2.79297 7.5L3.14652 7.85355L5.64652 10.3536C5.84178 10.5488 6.15837 10.5488 6.35363 10.3536C6.54889 10.1583 6.54889 9.84171 6.35363 9.64645L4.70718 8H16.5001C16.7762 8 17.0001 7.77614 17.0001 7.5C17.0001 7.22386 16.7762 7 16.5001 7H4.70718L6.35363 5.35355C6.54889 5.15829 6.54889 4.84171 6.35363 4.64645C6.15837 4.45118 5.84178 4.45118 5.64652 4.64645L3.14652 7.14645ZM16.8535 13.8536L17.2071 13.5L16.8535 13.1464L14.3535 10.6464C14.1582 10.4512 13.8417 10.4512 13.6464 10.6464C13.4511 10.8417 13.4511 11.1583 13.6464 11.3536L15.2928 13H3.49995C3.22381 13 2.99995 13.2239 2.99995 13.5C2.99995 13.7761 3.22381 14 3.49995 14H15.2928L13.6464 15.6464C13.4511 15.8417 13.4511 16.1583 13.6464 16.3536C13.8417 16.5488 14.1582 16.5488 14.3535 16.3536L16.8535 13.8536Z" }))); });


/***/ }),

/***/ 4409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SampleIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Sample Icon
 */
exports.SampleIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M13 4H7v11c0 2 1 3 3 3s3-1 3-3V4z", fill: "#D2DFEF" }),
    React.createElement("path", { d: "M13 15V7s-1 1.5-3 1-3 1-3 1v6c0 2 1 3 3 3s3-1 3-3z", fill: "#6290C8" }),
    React.createElement("circle", { cx: "9", cy: "10", r: "1", fill: "#D2DFEF" }),
    React.createElement("path", { fill: "#6290C8", d: "M7 3h6v2H7z" }),
    React.createElement("path", { fill: "#D2DFEF", d: "M10 12h1v1h-1z" })));


/***/ }),

/***/ 3483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Search Icon
 */
exports.SearchIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("circle", { cx: "10", cy: "10", r: "6.25", className: "gs-svg-icon-stroke", strokeWidth: "1.5", fill: "none" }),
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M14 15.414L15.414 14l3.561 3.56-1.414 1.415z" })));


/***/ }),

/***/ 7972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShareIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Share Icon
 */
exports.ShareIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { className: "gs-svg-icon-stroke", d: "M9 9l4.5-3M9 11l4.5 3" }),
    React.createElement("path", { className: "gs-svg-icon-stroke", d: "M16.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM9.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM15 15.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z", strokeLinecap: "round", strokeLinejoin: "round" })));


/***/ }),

/***/ 3546:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharedWithUserIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Right arrow pointing to human figure
 */
exports.SharedWithUserIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 11H2V9h3V6.5L8.5 10 5 13.5V11z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.4 13.6C7.2 14.2 6 14.8 6 16h12c0-1.2-1.2-1.8-2.4-2.4-1.2-.6-2.602-.857-2.602-1.886 0-1.028.5-1.028.998-1.543.5-.514.999-1.542.999-3.085C14.995 5.029 13.654 4 12 4c-1.654 0-2.995 1.382-2.995 3.086 0 1.543.5 2.571.998 3.085.5.515.999.515.999 1.543C11.002 12.743 9.6 13 8.4 13.6z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 7995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SimpleFileIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Simple file icon
 */
exports.SimpleFileIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("mask", { id: "a", maskUnits: "userSpaceOnUse", x: "3", y: "1", width: "14", height: "18" },
        React.createElement("path", { d: "M3 3v14a2 2 0 002 2h10a2 2 0 002-2V6.702a2 2 0 00-.438-1.25L13.6 1.751A2 2 0 0012.04 1H5a2 2 0 00-2 2z", fill: "#B0B5BF" })),
    React.createElement("g", { mask: "url(#a)" },
        React.createElement("path", { d: "M3 3v14a2 2 0 002 2h10a2 2 0 002-2V6.702a2 2 0 00-.438-1.25L13.6 1.751A2 2 0 0012.04 1H5a2 2 0 00-2 2z", fill: "#B0B5BF" }),
        React.createElement("path", { d: "M12 5V1h.52a1 1 0 01.78.375L17 6h-4a1 1 0 01-1-1z", fill: "#798091" }))));


/***/ }),

/***/ 596:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2022 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SquareArrowsIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Two arrows forming a Square
 */
exports.SquareArrowsIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7v6.6c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.656c.32.164.74.164 1.581.164H9a1 1 0 0 0 0-2H6.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C6 13.62 6 13.48 6 13.2V7l.999 1c.623.623 1.35.271 1.54.08.192-.191.632-.905-.078-1.615L5 3.495l-3.55 3.033c-.482.482-.288 1.219 0 1.508.29.289 1.01.49 1.536-.036L4 7Zm12.006 5.995V6.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C14.867 4 14.447 4 13.607 4h-2.6a1 1 0 1 0 0 2h2.2c.28 0 .42 0 .526.054a.5.5 0 0 1 .219.219c.054.107.054.247.054.527v6.195L13.013 12a1.113 1.113 0 0 0-1.541-.08c-.191.191-.632.905.078 1.615l3.457 2.965 3.516-3c.483-.482.29-1.219 0-1.508-.289-.29-1.01-.49-1.535.036l-.982.967Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StarIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.StarIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "16", height: "15", viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M7.24897 1.45222L5.54019 4.81352L1.71702 5.35428C1.03141 5.45075 0.756648 6.27076 1.25384 6.74043L4.01982 9.35534L3.36562 13.0492C3.24786 13.7169 3.97272 14.217 4.57982 13.9048L8 12.1607L11.4202 13.9048C12.0273 14.2145 12.7521 13.7169 12.6344 13.0492L11.9802 9.35534L14.7462 6.74043C15.2434 6.27076 14.9686 5.45075 14.283 5.35428L10.4598 4.81352L8.75103 1.45222C8.44486 0.853074 7.55776 0.845458 7.24897 1.45222Z", stroke: "#818181" })));


/***/ }),

/***/ 3834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StartEndIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.StartEndIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11H8Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { d: "M8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StatisticsIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.StatisticsIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", className: "gs-svg-icon-fill", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { x: "7", y: "13", width: "2", height: "4", rx: "1" }),
    React.createElement("rect", { x: "15", y: "10", width: "2", height: "7", rx: "1" }),
    React.createElement("rect", { x: "11", y: "7", width: "2", height: "10", rx: "1" })));


/***/ }),

/***/ 4173:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StopIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Stop Icon
 */
exports.StopIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M5 5h9v10H5z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 3334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StudyIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Study icon
 */
exports.StudyIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { d: "M3 12a1 1 0 01-1-1V5a3 3 0 013-3h4.382a1 1 0 01.894.553l.448.894a1 1 0 00.894.553H16a2 2 0 012\n2v5a1 1 0 01-1 1H3z", fill: "#B6D477" }),
    React.createElement("path", { d: "M2 11a5 5 0 015-5h9a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z", fill: "#6C990F" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.003 15.465a4 4 0 10-4-6.928c-1.914 1.104-3.435 4.05-2.33 5.964 1.005 1.741 4.827 1.831\n6.33.964zM12.827 12c.829 0 2.173-.42 2.173-1.25C15 9.923 14.156 9 13.327 9c-.828 0-2.015.922-2.015\n1.75 0 .83.687 1.25 1.515 1.25zm.938.79a1 1 0 00.484 1.94c.536-.133 1.226-1.282\n1.093-1.818-.123-.494-.906-.294-1.447-.155l-.13.033zm-2.028.645c.271.42.122 1.112-.298\n1.383-.42.27-1.111.122-1.382-.298-.271-.42-.697-1.336.027-1.803.723-.467 1.382.298 1.653.718z", fill: "#B6D477" })));


/***/ }),

/***/ 3329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TemplateIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var boxPath = "\nM3 4v12a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2H5a2 2 0 00-2 2z\n";
var templatePath = "\nM7 2.5V2h6v.5A1.5 1.5 0 0111.5 4h-3A1.5 1.5 0 017 2.5zM5 9a1 1 0 011-1h2v8H6a1 1 0 01-1-1V9zm4 \n7V8h5a1 1 0 011 1v6a1 1 0 01-1 1H9z\n";
/**
 * Template icon
 */
exports.TemplateIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: boxPath, fill: "#6CB6DA" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: templatePath, fill: "#0779B2" })));


/***/ }),

/***/ 3196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Text Icon
 */
exports.TextIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M5 5H14V7H13V6H10V14H12V15H7V14H9V6H6V7H5V5Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 4848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimeReverseIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Presents clocks with contraclockwise arrow */
exports.TimeReverseIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M10 3c3.906 0 7 3.125 7 7s-3 7-7 7c-2.992 0-4.707-1.813-4.707-1.813L6 14.5S7.5 16 10 16c3.344 0 6-2.656 6-6s-2.734-6-6-6-6 2.594-6 6h.691a.5.5 0 01.447.724l-1.19 2.382a.5.5 0 01-.895 0l-1.191-2.382A.5.5 0 012.309 10H3c0-3.86 3.094-7 7-7zm-.5 3a.5.5 0 00-.5.5v4.293a.5.5 0 00.146.353l2 2a.5.5 0 00.708 0l.793-.792a.5.5 0 000-.708l-1.5-1.5A.5.5 0 0111 9.793V6.5a.5.5 0 00-.5-.5h-1z" })));


/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TrashIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Trash Icon
 */
exports.TrashIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4C8 2.89543 8.89543 2 10 2C11.1046 2 12 2.89543 12 4L16 4V5L4 5V4L8 4ZM10 3C10.5523 3 11 3.44772 11 4L9 4C9 3.44772 9.44771 3 10 3Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { d: "M8 8H9V14H8V8Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { d: "M12 8H11V14H12V8Z", className: "gs-svg-icon-fill" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 6V14.5C5 15.8807 6.11929 17 7.5 17H12.5C13.8807 17 15 15.8807 15 14.5V6H5ZM6 14.5V7L14 7V14.5C14 15.3284 13.3284 16 12.5 16H7.5C6.67157 16 6 15.3284 6 14.5Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 4071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UndoIcon = void 0;
/*
 * Copyright (c) 2011-2024 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.UndoIcon = (0, icon_1.createIcon)(React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16" },
    React.createElement("path", { d: "M4.20718 7.00004L6.50007 4.70714C6.69534 4.51188 6.69534 4.1953 6.50008 4.00004C6.30481 3.80478 5.98823 3.80478 5.79297 4.00004L2.29297 7.50004L5.79297 11C5.98823 11.1953 6.30481 11.1953 6.50008 11C6.69534 10.8048 6.69534 10.4882 6.50008 10.2929L4.20718 8.00004H7.00008C8.02898 8.00004 9.04112 8.00802 9.80312 8.33459C10.1663 8.49024 10.4535 8.71192 10.6551 9.03204C10.8585 9.35516 11.0001 9.81902 11.0001 10.5V12H12.0001V10.5C12.0001 9.68102 11.8291 9.01987 11.5013 8.49923C11.1716 7.9756 10.7088 7.63478 10.197 7.41544C9.22697 6.99971 8.01602 6.99989 7.05322 7.00003L4.20718 7.00004Z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 8777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UploadIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/** Icon to indicate that user could upload some file */
exports.UploadIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M9 3a3.5 3.5 0 00-3.246 4.812l.279.688H4.5a1.5 1.5 0 00-.5 2.915v1.035a2.5 2.5 0 01.5-4.95h.112a4.5 4.5 0 018.655-2.433A4 4 0 0117.465 11h-1.229a3 3 0 00-3.167-4.853l-.53.173-.114-.545A3.502 3.502 0 009 3z" }),
    React.createElement("path", { className: "gs-svg-icon-fill", d: "M16 14c-.39.39-1.11.39-1.5 0L12 11.5V18a1 1 0 11-2 0v-6.5L7.5 14c-.39.39-1.11.39-1.5 0-.39-.39-.39-1.11 0-1.5L11 8l5 4.5c.39.39.39 1.11 0 1.5z" })));


/***/ }),

/***/ 2081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserGroupIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Two human figures, one of which is bigger
 */
exports.UserGroupIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 16c0-1.2 1.2-1.8 2.4-2.4.287-.144.587-.268.875-.388.916-.38 1.727-.716 1.727-1.498 0-.753-.268-.954-.607-1.21a3.196 3.196 0 01-.392-.333c-.499-.514-.998-1.542-.998-3.085C4.005 5.382 5.345 4 7 4c1.654 0 2.995 1.029 2.995 3.086 0 1.543-.5 2.571-.999 3.085a3.195 3.195 0 01-.391.333c-.34.256-.607.457-.607 1.21 0 .782.81 1.118 1.726 1.498.289.12.588.244.876.388.242.121.484.242.716.368l.14-.059c.687-.285 1.295-.537 1.295-1.123 0-.565-.2-.716-.455-.908a2.4 2.4 0 01-.294-.25c-.374-.385-.748-1.157-.748-2.314C11.254 8.036 12.259 7 13.5 7c1.24 0 2.246.771 2.246 2.314 0 1.157-.374 1.929-.749 2.315a2.4 2.4 0 01-.293.249c-.255.192-.456.343-.456.908 0 .586.608.838 1.295 1.123.217.09.441.183.657.291.9.45 1.8.9 1.8 1.8H1z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 7725:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserIcon = void 0;
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Human shadow figure
 */
exports.UserIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { d: "M6.4 13.6C5.2 14.2 4 14.8 4 16h12c0-1.2-1.2-1.8-2.4-2.4-1.2-.6-2.602-.857-2.602-1.886 0-1.028.5-1.028.998-1.543.5-.514.999-1.542.999-3.085C12.995 5.029 11.654 4 10 4 8.346 4 7.005 5.382 7.005 7.086c0 1.543.5 2.571.998 3.085.5.515.999.515.999 1.543C9.002 12.743 7.6 13 6.4 13.6z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 8031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WarningIcon = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 *
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
var warningPath = "\nM17 10a7 7 0 11-14 0 7 7 0 0114 0zm-6 4a1 1 0 11-2 0 1 1 0 012 0zM9.18 6a1 1 0 00-.986 1.164l.667 \n4a1 1 0 00.986.836h.306a1 1 0 00.986-.836l.667-4A1 1 0 0010.82 6H9.18z\n";
/**
 * Warning (exclamation mark) icon
 */
exports.WarningIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20", fill: "none" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: warningPath, className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 9265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WidenIcon = void 0;
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
/**
 * Widen Icon
 */
exports.WidenIcon = (0, icon_1.createIcon)(React.createElement("svg", { viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.646 12.646a.5.5 0 00.708.708l2.853-2.854-2.853-2.854a.5.5 0 10-.707.708L15.293 10H11.5a.5.5 0 100 1h3.793l-1.646 1.646zM6.354 8.354a.5.5 0 10-.707-.708L2.793 10.5l2.854 2.854a.5.5 0 00.707-.708L4.707 11H8.5a.5.5 0 000-1H4.707l1.647-1.646z", className: "gs-svg-icon-fill" })));


/***/ }),

/***/ 1026:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkingCopyEdited = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.WorkingCopyEdited = (0, icon_1.createIcon)(React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 10C5.5 7.51472 7.51472 5.5 10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10ZM10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5ZM7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10ZM10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5Z", fill: "rgba(129, 129, 129, 1)" })));


/***/ }),

/***/ 2772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkingCopyIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.WorkingCopyIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 10C5.5 7.51472 7.51472 5.5 10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10ZM10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5ZM10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5ZM6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10ZM11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z", className: "gs-svg-icon-fill" }))); });


/***/ }),

/***/ 3616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkingCopyOwnIcon = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
var icon_1 = __webpack_require__(6185);
exports.WorkingCopyOwnIcon = (0, icon_1.createIcon)(function () { return (React.createElement("svg", { width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 10C5.5 7.51472 7.51472 5.5 10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10ZM10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5ZM10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5Z", fill: "rgba(129, 129, 129, 1)" }))); });


/***/ }),

/***/ 341:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
__exportStar(__webpack_require__(9399), exports);
__exportStar(__webpack_require__(3597), exports);
__exportStar(__webpack_require__(358), exports);
__exportStar(__webpack_require__(8329), exports);
__exportStar(__webpack_require__(3592), exports);
__exportStar(__webpack_require__(6119), exports);
__exportStar(__webpack_require__(1122), exports);
__exportStar(__webpack_require__(8321), exports);
__exportStar(__webpack_require__(5330), exports);
__exportStar(__webpack_require__(1840), exports);
__exportStar(__webpack_require__(2141), exports);
__exportStar(__webpack_require__(5848), exports);
__exportStar(__webpack_require__(3874), exports);
__exportStar(__webpack_require__(6339), exports);
__exportStar(__webpack_require__(9629), exports);
__exportStar(__webpack_require__(7071), exports);
__exportStar(__webpack_require__(9962), exports);
__exportStar(__webpack_require__(7118), exports);
__exportStar(__webpack_require__(1230), exports);
__exportStar(__webpack_require__(3415), exports);
__exportStar(__webpack_require__(4953), exports);
__exportStar(__webpack_require__(6185), exports);
__exportStar(__webpack_require__(4741), exports);
__exportStar(__webpack_require__(9699), exports);
__exportStar(__webpack_require__(5545), exports);
__exportStar(__webpack_require__(5228), exports);
__exportStar(__webpack_require__(3358), exports);
__exportStar(__webpack_require__(8177), exports);
__exportStar(__webpack_require__(7536), exports);
__exportStar(__webpack_require__(5415), exports);
__exportStar(__webpack_require__(6777), exports);
__exportStar(__webpack_require__(3790), exports);
__exportStar(__webpack_require__(9530), exports);
__exportStar(__webpack_require__(6764), exports);
__exportStar(__webpack_require__(6627), exports);
__exportStar(__webpack_require__(689), exports);
__exportStar(__webpack_require__(1636), exports);
__exportStar(__webpack_require__(5424), exports);
__exportStar(__webpack_require__(8413), exports);
__exportStar(__webpack_require__(9171), exports);
__exportStar(__webpack_require__(6337), exports);
__exportStar(__webpack_require__(6798), exports);
__exportStar(__webpack_require__(731), exports);
__exportStar(__webpack_require__(9714), exports);
__exportStar(__webpack_require__(4472), exports);
__exportStar(__webpack_require__(6257), exports);
__exportStar(__webpack_require__(9681), exports);
__exportStar(__webpack_require__(5669), exports);
__exportStar(__webpack_require__(7897), exports);
__exportStar(__webpack_require__(8605), exports);
__exportStar(__webpack_require__(708), exports);
__exportStar(__webpack_require__(1842), exports);
__exportStar(__webpack_require__(2323), exports);
__exportStar(__webpack_require__(7427), exports);
__exportStar(__webpack_require__(883), exports);
__exportStar(__webpack_require__(9502), exports);


/***/ }),

/***/ 9416:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.chain = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/**
 * Chain all functions in single one.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function chain() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    var funcs = items.filter(Boolean);
    if (!funcs.length) {
        return undefined;
    }
    return funcs.reduce(function (acc, func) {
        if (!func) {
            return acc;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            acc.apply(void 0, args);
            func.apply(void 0, args);
        });
    }, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    (function () { }));
}
exports.chain = chain;


/***/ }),

/***/ 7915:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CloneProps = void 0;
/**
 *  Cloning props to children elements
 *
 *  @example
 *  <CloneProps>
 *      {tabProps => (
 *          <Tooltip title="can't change back">
 *              <Tab {...tabProps} />
 *          </Tooltip>
 *      )}
 *  </CloneProps>
 */
function CloneProps(_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return children(restProps);
}
exports.CloneProps = CloneProps;


/***/ }),

/***/ 3693:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DarkContext = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/**
 * React context that is used for dark backgrounds.
 * All consumers should be inverted.
 */
exports.DarkContext = React.createContext(null);


/***/ }),

/***/ 1467:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.debounce = void 0;
/**
 * Creates a debounced function that delays invoking `callback` until after
 * `duration` milliseconds have elapsed since the last time the debounced
 * function was invoked.
 */
function debounce(callback, duration) {
    var timeout = null;
    var debouncedCallback = (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        cancel();
        debouncedCallback.active = true;
        timeout = window.setTimeout(function () {
            debouncedCallback.active = false;
            callback.apply(void 0, args);
        }, duration);
    });
    debouncedCallback.cancel = cancel;
    debouncedCallback.active = false;
    function cancel() {
        debouncedCallback.active = false;
        if (timeout) {
            window.clearTimeout(timeout);
        }
    }
    return debouncedCallback;
}
exports.debounce = debounce;


/***/ }),

/***/ 5125:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.escapeRegExp = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
/** Escape string for use in Javascript regex */
var escapeRegExp = function (value) { return value.replace(matchOperatorsRegex, '\\$&'); };
exports.escapeRegExp = escapeRegExp;


/***/ }),

/***/ 8717:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFocusDirection = exports.getSiblingElement = exports.getLastReachableElement = exports.getFirstReachableElement = exports.getReachableElements = exports.getFocusableElements = exports.isElementReachable = exports.isElementFocusable = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var matches_1 = __webpack_require__(7522);
/**
 * See difference between focusable and reachable elements at
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
 */
var FOCUSABLE_SELECTOR = [
    'button:not([disabled])',
    'a[href]:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]'
].join(', ');
var REACHABLE_SELECTOR = [
    'button:not([disabled]):not([tabindex^="-"])',
    'a[href]:not([disabled]):not([tabindex^="-"])',
    'input:not([disabled]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
].join(', ');
/** Returns true if element could be focused */
function isElementFocusable(element) {
    return (0, matches_1.matches)(element, FOCUSABLE_SELECTOR);
}
exports.isElementFocusable = isElementFocusable;
/** Returns true if element could be reached by Tab key */
function isElementReachable(element) {
    return (0, matches_1.matches)(element, REACHABLE_SELECTOR);
}
exports.isElementReachable = isElementReachable;
/** Returns all focusable elements are contained in target element */
function getFocusableElements(element) {
    return element.querySelectorAll(FOCUSABLE_SELECTOR);
}
exports.getFocusableElements = getFocusableElements;
/** Returns all focusable elements are contained in target element */
function getReachableElements(element) {
    return element.querySelectorAll(REACHABLE_SELECTOR);
}
exports.getReachableElements = getReachableElements;
/** Returns the first reachable element in container */
function getFirstReachableElement(container) {
    var items = getReachableElements(container);
    var item = items.item(0);
    return item instanceof HTMLElement ? item : null;
}
exports.getFirstReachableElement = getFirstReachableElement;
/** Returns the last reachable element in container */
function getLastReachableElement(container) {
    var items = getReachableElements(container);
    var item = items.item(items.length - 1);
    return item instanceof HTMLElement ? item : null;
}
exports.getLastReachableElement = getLastReachableElement;
/** Returns sibling element according to direction */
function getSiblingElement(elements, element, direction) {
    if (!element.parentElement || !elements.length) {
        return null;
    }
    var currentIndex = elements.indexOf(element);
    if (currentIndex === -1) {
        currentIndex = direction === 'next' ? -1 : elements.length;
    }
    var nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
    if (nextIndex < 0) {
        nextIndex = 0;
    }
    if (nextIndex >= elements.length) {
        nextIndex = elements.length - 1;
    }
    var nextElement = elements[nextIndex];
    if (nextElement instanceof HTMLElement && nextElement !== element) {
        return nextElement;
    }
    return null;
}
exports.getSiblingElement = getSiblingElement;
function getAncestors(startNode) {
    var nodes = [];
    var node = startNode;
    while (node) {
        nodes.unshift(node);
        node = node.parentNode;
    }
    return nodes;
}
function getCommonAncestor(firstNode, secondNode) {
    var firstAncestors = getAncestors(firstNode);
    var secondAncestors = getAncestors(secondNode);
    if (firstAncestors[0] !== secondAncestors[0]) {
        return null;
    }
    for (var i = 0; i < firstAncestors.length; i += 1) {
        if (firstAncestors[i] !== secondAncestors[i]) {
            return firstAncestors[i - 1];
        }
    }
    return null;
}
/**
 * Determines the focus direction based on targets of FocusEvent
 */
function getFocusDirection(event) {
    var target = event.target, relatedTarget = event.relatedTarget;
    if (!(target instanceof HTMLElement) || !(relatedTarget instanceof HTMLElement)) {
        return null;
    }
    var ancestor = getCommonAncestor(target, relatedTarget);
    if (!(ancestor instanceof Element)) {
        return null;
    }
    var focusableElements = Array.from(getFocusableElements(ancestor));
    var currentIndex = focusableElements.indexOf(target);
    var previousIndex = focusableElements.indexOf(relatedTarget);
    if (currentIndex === -1 || previousIndex === -1 || currentIndex === previousIndex) {
        return null;
    }
    return currentIndex > previousIndex ? 'next' : 'prev';
}
exports.getFocusDirection = getFocusDirection;


/***/ }),

/***/ 98:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasVerticalScrollbar = void 0;
/**
 * Returns that `element` has visible vertical scroll bar.
 * Take in account the `body` element specific.
 */
function hasVerticalScrollbar(element) {
    if (element instanceof HTMLBodyElement) {
        var style = window.getComputedStyle(element);
        var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
        var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
        return marginLeft + element.clientWidth + marginRight < window.innerWidth;
    }
    return element.scrollHeight > element.clientHeight;
}
exports.hasVerticalScrollbar = hasVerticalScrollbar;


/***/ }),

/***/ 9502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
__exportStar(__webpack_require__(9416), exports);
__exportStar(__webpack_require__(3693), exports);
__exportStar(__webpack_require__(1467), exports);
__exportStar(__webpack_require__(5125), exports);
__exportStar(__webpack_require__(8717), exports);
__exportStar(__webpack_require__(98), exports);
__exportStar(__webpack_require__(2368), exports);
__exportStar(__webpack_require__(7655), exports);
__exportStar(__webpack_require__(6874), exports);
__exportStar(__webpack_require__(2403), exports);
__exportStar(__webpack_require__(5230), exports);
__exportStar(__webpack_require__(598), exports);
__exportStar(__webpack_require__(7707), exports);
__exportStar(__webpack_require__(6378), exports);
__exportStar(__webpack_require__(7915), exports);


/***/ }),

/***/ 7522:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.matches = void 0;
/*
 * Copyright (c) 2011-2023 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
/** IE11 polyfill for Element.prototype.matches */
function matches(element, selector) {
    // ie 11
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return element.matches(selector);
}
exports.matches = matches;


/***/ }),

/***/ 2368:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2021 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 7655:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 6874:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reflow = void 0;
/** Force reflow */
var reflow = function (node) { return node.scrollTop; };
exports.reflow = reflow;


/***/ }),

/***/ 2403:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.chainRefs = exports.setRef = void 0;
/**
 * Manually update value of React.Ref.
 */
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        // ref.current is readonly, but not for us
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref.current = value;
    }
}
exports.setRef = setRef;
/**
 * Like functions chain but works with React.Refs.
 * It is useful when some component needs child's ref
 * but also should expose it the parent component.
 */
function chainRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (value) {
        refs.forEach(function (ref) {
            if (ref) {
                setRef(ref, value);
            }
        });
    };
}
exports.chainRefs = chainRefs;


/***/ }),

/***/ 5230:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shouldRenderNode = void 0;
/**
 * returns true for all the nodes that is feasible to render (e.g. 0, but not false)
 * based on https://git.io/fjbnj
 */
function shouldRenderNode(node) {
    var type = typeof node;
    if (type === 'undefined' || type === 'boolean') {
        return false;
    }
    return node !== null && node !== '';
}
exports.shouldRenderNode = shouldRenderNode;


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeClassesProps = void 0;
/*
 * Copyright (c) 2011-2018 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var classnames_1 = __importDefault(__webpack_require__(9003));
/**
 * Merge `props.classes` with `styles` hash map from css modules.
 *
 * @param props - Original component's props
 * @param styles - Hashmap imported from css module
 * @returns Transformed original component's props with `classes` hash map
 */
function mergeClassesProps(props, styles) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _a = props, _b = _a.classes, publicClasses = _b === void 0 ? {} : _b, rest = __rest(_a, ["classes"]);
    var privateClasses = {};
    var keys = Array.from(new Set(__spreadArray(__spreadArray([], Object.keys(styles), true), Object.keys(publicClasses), true)));
    keys.forEach(function (key) {
        privateClasses[key] = (0, classnames_1.default)(privateClasses[key], styles[key], publicClasses[key]);
    });
    return __assign(__assign({}, rest), { classes: privateClasses });
}
exports.mergeClassesProps = mergeClassesProps;


/***/ }),

/***/ 7707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useControlledProp = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/**
 * Use state for uncontrolled properties.
 * @see https://github.com/jquense/uncontrollable
 */
function useControlledProp(value, defaultValue, onValueChange) {
    var _a = React.useState(defaultValue), stateValue = _a[0], setStateValue = _a[1];
    var isUncontrolled = value === undefined;
    var handledValue = isUncontrolled ? stateValue : value;
    var handleChange = function (updatedValue) {
        if (isUncontrolled) {
            setStateValue(updatedValue);
        }
        if (onValueChange) {
            onValueChange(updatedValue);
        }
    };
    return [handledValue, handleChange];
}
exports.useControlledProp = useControlledProp;


/***/ }),

/***/ 5830:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useInputInvalidity = void 0;
/*
 * Copyright (c) 2011-2020 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/** Subscribe to native input invalidity */
function useInputInvalidity(inputRef, invalid) {
    // Input is valid by default
    var _a = React.useState(invalid || false), invalidState = _a[0], setInvalidState = _a[1];
    // Use native input validation before browser paint
    React.useLayoutEffect(function () {
        if (inputRef.current) {
            var nextInvalidState = !inputRef.current.validity.valid;
            if (nextInvalidState !== invalidState) {
                setInvalidState(nextInvalidState);
            }
        }
    });
    return invalid === undefined ? invalidState : invalid;
}
exports.useInputInvalidity = useInputInvalidity;


/***/ }),

/***/ 6378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapPureComponent = void 0;
/*
 * Copyright (c) 2011-2019 Genestack Limited
 * All Rights Reserved
 * THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF GENESTACK LIMITED
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */
var React = __importStar(__webpack_require__(6689));
/** Purify any react component */
function wrapPureComponent(Component) {
    return /** @class */ (function (_super) {
        __extends(PureComponent, _super);
        function PureComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PureComponent.prototype.render = function () {
            return React.createElement(Component, __assign({}, this.props));
        };
        return PureComponent;
    }(React.PureComponent));
}
exports.wrapPureComponent = wrapPureComponent;


/***/ }),

/***/ 9003:
/***/ ((module) => {

"use strict";
module.exports = require("classnames");

/***/ }),

/***/ 772:
/***/ ((module) => {

"use strict";
module.exports = require("downshift");

/***/ }),

/***/ 6689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 6405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 2932:
/***/ ((module) => {

"use strict";
module.exports = require("react-popper");

/***/ }),

/***/ 649:
/***/ ((module) => {

"use strict";
module.exports = require("react-textarea-autosize");

/***/ }),

/***/ 4172:
/***/ ((module) => {

"use strict";
module.exports = require("simplebar-react");

/***/ }),

/***/ 1721:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _inheritsLoose)
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 3366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(341);
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;